export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  Guid: { input: any; output: any; }
  Seconds: { input: any; output: any; }
  UInt: { input: any; output: any; }
  UtcDateTime: { input: any; output: any; }
}

export enum AccessPrivileges {
  /** Allows user login in admin portal */
  AdminPortalToken = 'AdminPortalToken',
  /** Allows AppSuite Integrations endpoint access */
  AppSuiteIntegrations = 'AppSuiteIntegrations',
  /** Allows Call Center Integrations endpoint access */
  CallCenterIntegrations = 'CallCenterIntegrations',
  /** Allows user impersonation in the API */
  CanImpersonateUser = 'CanImpersonateUser',
  /** Allows qManage Integration endpoint access */
  QManageIntegrations = 'QManageIntegrations',
  /** Allows Support Dashboard endpoint access */
  SupportDashboard = 'SupportDashboard'
}

export interface AccessToken {
  accessTokenId: Scalars['UInt']['output'];
  accessTokenPrivilegesConnection: AccessTokenPrivilegeConnection;
  account: Maybe<Account>;
  accountId: Maybe<Scalars['UInt']['output']>;
  token: Scalars['Guid']['output'];
  user: User;
  userId: Scalars['Int']['output'];
}


export interface AccessTokenAccessTokenPrivilegesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface AccessTokenConnection {
  /** Information to aid in pagination. */
  edges: Array<AccessTokenModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<AccessToken>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface AccessTokenInput {
  accessTokenId?: InputMaybe<Scalars['UInt']['input']>;
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface AccessTokenModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AccessToken;
}

export interface AccessTokenPrivilege {
  accessPrivilegeId: AccessPrivileges;
  accessTokenId: Scalars['UInt']['output'];
  accessTokenPrivilegeId: Scalars['UInt']['output'];
  hasPrivilege: Scalars['Boolean']['output'];
  token: Maybe<AccessToken>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface AccessTokenPrivilegeConnection {
  /** Information to aid in pagination. */
  edges: Array<AccessTokenPrivilegeModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<AccessTokenPrivilege>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface AccessTokenPrivilegeInput {
  accessPrivilegeId?: InputMaybe<AccessPrivileges>;
  accessTokenId?: InputMaybe<Scalars['UInt']['input']>;
  accessTokenPrivilegeId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  hasPrivilege?: InputMaybe<Scalars['Boolean']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface AccessTokenPrivilegeModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AccessTokenPrivilege;
}

export interface Account {
  accountId: Scalars['UInt']['output'];
  activeEndDate: Maybe<Scalars['UtcDateTime']['output']>;
  activeStartDate: Maybe<Scalars['UtcDateTime']['output']>;
  callCostDailyLimit: Maybe<Scalars['UInt']['output']>;
  callRetentionPolicyTypeId: CallRetentionPolicyTypes;
  centralId: Scalars['UInt']['output'];
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  defaultAreaCode: Maybe<Scalars['UInt']['output']>;
  departmentsConnection: DepartmentConnection;
  domain: Maybe<Scalars['String']['output']>;
  extensionCount: Scalars['UInt']['output'];
  extensionGroupsConnection: ExtensionGroupConnection;
  extensionsConnection: ExtensionConnection;
  externalNumbersConnection: ExternalNumberHistoryConnection;
  faxFileTypeId: FaxFileTypes;
  fileStoreId: Maybe<Scalars['UInt']['output']>;
  hasPresenceCredentials: Scalars['Boolean']['output'];
  hashedProvisioningPasswordOld: Maybe<Scalars['String']['output']>;
  holdMusicPrompt: Maybe<Prompt>;
  holdMusicPromptId: Maybe<Scalars['UInt']['output']>;
  isAgentCanAssign: Scalars['Boolean']['output'];
  isCallRecordingFeatureEnabled: Scalars['Boolean']['output'];
  isFmFmEnabled: Scalars['Boolean']['output'];
  isInternationalDialingEnabled: Scalars['Boolean']['output'];
  isInternationalDialingSuspended: Scalars['Boolean']['output'];
  isLcsInternal: Scalars['Boolean']['output'];
  isMailboxMessageTranscriptionEnabled: Scalars['Boolean']['output'];
  isMissedCallsShown: Scalars['Boolean']['output'];
  isOtrEnabled: Scalars['Boolean']['output'];
  isRecordInboundCalls: Scalars['Boolean']['output'];
  isRecordInternalCalls: Scalars['Boolean']['output'];
  isRecordOutboundCalls: Scalars['Boolean']['output'];
  isResidential: Scalars['Boolean']['output'];
  isSuspended: Scalars['Boolean']['output'];
  isWhisperTranscriptionEnabled: Scalars['Boolean']['output'];
  lcsAccountNumber: Maybe<Scalars['Int']['output']>;
  locationsConnection: LocationConnection;
  logLevelChanged: Maybe<Scalars['UtcDateTime']['output']>;
  logLevelChangedByUser: Maybe<User>;
  logLevelChangedByUserId: Maybe<Scalars['UInt']['output']>;
  logLevelId: LogLevels;
  name: Maybe<Scalars['String']['output']>;
  nameDirectoryPreferenceId: NameDirectoryPreference;
  namespace: Maybe<Scalars['String']['output']>;
  note: Maybe<Note>;
  noteId: Maybe<Scalars['UInt']['output']>;
  operatorExtension: Maybe<Extension>;
  operatorExtensionId: Maybe<Scalars['UInt']['output']>;
  outboundRecordingNotificationEnabled: Scalars['Boolean']['output'];
  pdmsSubOrgId: Maybe<Scalars['String']['output']>;
  phoneNumberCount: Scalars['UInt']['output'];
  phoneNumbersConnection: PhoneNumberConnection;
  presenceEnabled: Scalars['Boolean']['output'];
  presenceUser: Maybe<Scalars['String']['output']>;
  provisioningPassword: Maybe<Scalars['String']['output']>;
  pstnLineLimit: Scalars['UInt']['output'];
  queueManagementStrategyTypeId: Maybe<QueueManagementStrategy>;
  reasonLogLevelChanged: Maybe<Scalars['String']['output']>;
  schedule: Maybe<Schedule>;
  scheduleId: Maybe<Scalars['UInt']['output']>;
  shortName: Maybe<Scalars['String']['output']>;
  timeZoneId: TimeZones;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
  versionId: Versions;
}


export interface AccountDepartmentsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface AccountExtensionGroupsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface AccountExtensionsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface AccountExternalNumbersConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface AccountLocationsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface AccountPhoneNumbersConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface AccountConnection {
  /** Information to aid in pagination. */
  edges: Array<AccountModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Account>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface AccountInput {
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  activeEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  activeStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  callCostDailyLimit?: InputMaybe<Scalars['UInt']['input']>;
  callRetentionPolicyTypeId?: InputMaybe<CallRetentionPolicyTypes>;
  centralId?: InputMaybe<Scalars['UInt']['input']>;
  defaultAreaCode?: InputMaybe<Scalars['UInt']['input']>;
  departments?: InputMaybe<Array<DepartmentInput>>;
  domain?: InputMaybe<Scalars['String']['input']>;
  extensionGroups?: InputMaybe<Array<ExtensionGroupInput>>;
  extensions?: InputMaybe<Array<ExtensionInput>>;
  externalNumbers?: InputMaybe<Array<ExternalNumberHistoryInput>>;
  faxFileTypeId?: InputMaybe<FaxFileTypes>;
  fields: Array<Scalars['String']['input']>;
  fileStoreId?: InputMaybe<Scalars['UInt']['input']>;
  hashedProvisioningPasswordOld?: InputMaybe<Scalars['String']['input']>;
  holdMusicPrompt?: InputMaybe<PromptInput>;
  holdMusicPromptId?: InputMaybe<Scalars['UInt']['input']>;
  isAgentCanAssign?: InputMaybe<Scalars['Boolean']['input']>;
  isCallRecordingFeatureEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isFmFmEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isInternationalDialingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isInternationalDialingSuspended?: InputMaybe<Scalars['Boolean']['input']>;
  isLcsInternal?: InputMaybe<Scalars['Boolean']['input']>;
  isMailboxMessageTranscriptionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMissedCallsShown?: InputMaybe<Scalars['Boolean']['input']>;
  isOtrEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isRecordInboundCalls?: InputMaybe<Scalars['Boolean']['input']>;
  isRecordInternalCalls?: InputMaybe<Scalars['Boolean']['input']>;
  isRecordOutboundCalls?: InputMaybe<Scalars['Boolean']['input']>;
  isResidential?: InputMaybe<Scalars['Boolean']['input']>;
  isSuspended?: InputMaybe<Scalars['Boolean']['input']>;
  isWhisperTranscriptionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lcsAccountNumber?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<Array<LocationInput>>;
  logLevelChanged?: InputMaybe<Scalars['DateTime']['input']>;
  logLevelChangedByUser?: InputMaybe<UserInput>;
  logLevelChangedByUserId?: InputMaybe<Scalars['UInt']['input']>;
  logLevelId?: InputMaybe<LogLevels>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameDirectoryPreferenceId?: InputMaybe<NameDirectoryPreference>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<NoteInput>;
  operatorExtension?: InputMaybe<ExtensionInput>;
  operatorExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  outboundRecordingNotificationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pdmsSubOrgId?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers?: InputMaybe<Array<PhoneNumberInput>>;
  presenceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  presenceUser?: InputMaybe<Scalars['String']['input']>;
  provisioningPassword?: InputMaybe<Scalars['String']['input']>;
  pstnLineLimit?: InputMaybe<Scalars['UInt']['input']>;
  queueManagementStrategyTypeId?: InputMaybe<QueueManagementStrategy>;
  reasonLogLevelChanged?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<ScheduleInput>;
  scheduleId?: InputMaybe<Scalars['UInt']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  timeZoneId?: InputMaybe<TimeZones>;
  versionId?: InputMaybe<Versions>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface AccountModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Account;
}

export interface ActiveCall {
  account: Account;
  accountId: Scalars['UInt']['output'];
  callDetailId: Scalars['UInt']['output'];
  callDirectionTypeId: CallDirectionTypes;
  callDirectionTypeName: Maybe<Scalars['String']['output']>;
  callDispositionTypeId: CallDispositionTypes;
  callDispositionTypeName: Maybe<Scalars['String']['output']>;
  callRate: Scalars['Float']['output'];
  callRecording: Maybe<CallRecording>;
  callRecordingCallDetailConnection: CallRecordingCallDetailConnection;
  callRecordingId: Maybe<Scalars['UInt']['output']>;
  callSegmentsConnection: ActiveCallSegmentConnection;
  callerChannelId: Maybe<Scalars['String']['output']>;
  callerName: Maybe<Scalars['String']['output']>;
  destinationExtension: Maybe<Extension>;
  destinationExtensionId: Maybe<Scalars['UInt']['output']>;
  destinationIpAddress: Maybe<Scalars['String']['output']>;
  destinationNumber: Maybe<Scalars['String']['output']>;
  destinationProviderId: Maybe<Providers>;
  originalDestinationNumber: Maybe<Scalars['String']['output']>;
  otrTriggered: Scalars['Boolean']['output'];
  phoneNumber: Maybe<PhoneNumber>;
  phoneNumberId: Maybe<Scalars['UInt']['output']>;
  providerId: Maybe<Providers>;
  queueHistoriesConnection: QueueHistoryConnection;
  queueHistoryCallDetailsConnection: QueueHistoryCallDetailConnection;
  serverName: Maybe<Scalars['String']['output']>;
  sipCallId: Maybe<Scalars['String']['output']>;
  sourceExtension: Maybe<Extension>;
  sourceExtensionId: Maybe<Scalars['UInt']['output']>;
  sourceIpAddress: Maybe<Scalars['String']['output']>;
  sourceNumber: Maybe<Scalars['String']['output']>;
  sourceProviderId: Maybe<Providers>;
  startTime: Scalars['UtcDateTime']['output'];
  stirShakenAttest: Maybe<Scalars['String']['output']>;
  stirShakenToken: Maybe<Scalars['String']['output']>;
  stirShakenVerification: Scalars['Int']['output'];
}


export interface ActiveCallCallRecordingCallDetailConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface ActiveCallCallSegmentsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface ActiveCallQueueHistoriesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface ActiveCallQueueHistoryCallDetailsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface ActiveCallConnection {
  /** Information to aid in pagination. */
  edges: Array<ActiveCallModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<ActiveCall>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface ActiveCallInput {
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  callDetailId?: InputMaybe<Scalars['UInt']['input']>;
  callDirectionTypeId?: InputMaybe<CallDirectionTypes>;
  callDispositionTypeId?: InputMaybe<CallDispositionTypes>;
  callRate?: InputMaybe<Scalars['Float']['input']>;
  callRecordingId?: InputMaybe<Scalars['UInt']['input']>;
  callerChannelId?: InputMaybe<Scalars['String']['input']>;
  callerName?: InputMaybe<Scalars['String']['input']>;
  destinationExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  destinationIpAddress?: InputMaybe<Scalars['String']['input']>;
  destinationNumber?: InputMaybe<Scalars['String']['input']>;
  destinationProviderId?: InputMaybe<Providers>;
  fields: Array<Scalars['String']['input']>;
  originalDestinationNumber?: InputMaybe<Scalars['String']['input']>;
  otrTriggered?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumberId?: InputMaybe<Scalars['UInt']['input']>;
  providerId?: InputMaybe<Providers>;
  serverName?: InputMaybe<Scalars['String']['input']>;
  sipCallId?: InputMaybe<Scalars['String']['input']>;
  sourceExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  sourceIpAddress?: InputMaybe<Scalars['String']['input']>;
  sourceNumber?: InputMaybe<Scalars['String']['input']>;
  sourceProviderId?: InputMaybe<Providers>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  stirShakenAttest?: InputMaybe<Scalars['String']['input']>;
  stirShakenToken?: InputMaybe<Scalars['String']['input']>;
  stirShakenVerification?: InputMaybe<Scalars['Int']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface ActiveCallModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ActiveCall;
}

export interface ActiveCallReadOnly {
  account: Account;
  accountId: Scalars['UInt']['output'];
  callDetailId: Scalars['UInt']['output'];
  callDirectionTypeId: CallDirectionTypes;
  callDirectionTypeName: Maybe<Scalars['String']['output']>;
  callDispositionTypeId: CallDispositionTypes;
  callDispositionTypeName: Maybe<Scalars['String']['output']>;
  callRate: Scalars['Float']['output'];
  callRecording: Maybe<CallRecording>;
  callRecordingCallDetailConnection: CallRecordingCallDetailConnection;
  callRecordingId: Maybe<Scalars['UInt']['output']>;
  callSegmentsConnection: ActiveCallSegmentConnection;
  callerChannelId: Maybe<Scalars['String']['output']>;
  callerName: Maybe<Scalars['String']['output']>;
  destinationExtension: Maybe<Extension>;
  destinationExtensionId: Maybe<Scalars['UInt']['output']>;
  destinationIpAddress: Maybe<Scalars['String']['output']>;
  destinationNumber: Maybe<Scalars['String']['output']>;
  destinationProviderId: Maybe<Providers>;
  originalDestinationNumber: Maybe<Scalars['String']['output']>;
  otrTriggered: Scalars['Boolean']['output'];
  phoneNumber: Maybe<PhoneNumber>;
  phoneNumberId: Maybe<Scalars['UInt']['output']>;
  providerId: Maybe<Providers>;
  queueHistoriesConnection: QueueHistoryConnection;
  queueHistoryCallDetailsConnection: QueueHistoryCallDetailConnection;
  serverName: Maybe<Scalars['String']['output']>;
  sipCallId: Maybe<Scalars['String']['output']>;
  sourceExtension: Maybe<Extension>;
  sourceExtensionId: Maybe<Scalars['UInt']['output']>;
  sourceIpAddress: Maybe<Scalars['String']['output']>;
  sourceNumber: Maybe<Scalars['String']['output']>;
  sourceProviderId: Maybe<Providers>;
  startTime: Scalars['UtcDateTime']['output'];
  stirShakenAttest: Maybe<Scalars['String']['output']>;
  stirShakenToken: Maybe<Scalars['String']['output']>;
  stirShakenVerification: Scalars['Int']['output'];
}


export interface ActiveCallReadOnlyCallRecordingCallDetailConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface ActiveCallReadOnlyCallSegmentsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface ActiveCallReadOnlyQueueHistoriesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface ActiveCallReadOnlyQueueHistoryCallDetailsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface ActiveCallReadOnlyConnection {
  /** Information to aid in pagination. */
  edges: Array<ActiveCallReadOnlyModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<ActiveCallReadOnly>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface ActiveCallReadOnlyModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ActiveCallReadOnly;
}

export interface ActiveCallSegment {
  callDetail: ActiveCall;
  callDetailId: Scalars['UInt']['output'];
  callEventId: Maybe<CallEvents>;
  callSegmentId: Scalars['UInt']['output'];
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  duration: Maybe<Scalars['UInt']['output']>;
  endDate: Maybe<Scalars['UtcDateTime']['output']>;
  extension: Maybe<Extension>;
  extensionId: Maybe<Scalars['UInt']['output']>;
  sequence: Scalars['UInt']['output'];
  sourceExtension: Maybe<Extension>;
  sourceExtensionId: Maybe<Scalars['UInt']['output']>;
  startDate: Scalars['UtcDateTime']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface ActiveCallSegmentConnection {
  /** Information to aid in pagination. */
  edges: Array<ActiveCallSegmentModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<ActiveCallSegment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface ActiveCallSegmentInput {
  callDetailId?: InputMaybe<Scalars['UInt']['input']>;
  callEventId?: InputMaybe<CallEvents>;
  callSegmentId?: InputMaybe<Scalars['UInt']['input']>;
  duration?: InputMaybe<Scalars['UInt']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['UInt']['input']>;
  sourceExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface ActiveCallSegmentModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ActiveCallSegment;
}

export interface AggregateQueuesReportParameterGraphType {
  isAskParameter: Scalars['Boolean']['output'];
  parameterType: ReportParameters;
  sortOrder: Maybe<Scalars['Int']['output']>;
  value: Scalars['Boolean']['output'];
}

export interface AggregateQueuesReportParameterInput {
  fields: Array<Scalars['String']['input']>;
  isAskParameter?: InputMaybe<Scalars['Boolean']['input']>;
  parameterType?: InputMaybe<ReportParameters>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface AllowedIpAddress {
  account: Account;
  accountId: Scalars['UInt']['output'];
  allowedIpAddressId: Scalars['UInt']['output'];
  createDate: Scalars['UtcDateTime']['output'];
  ipAddress: Maybe<Scalars['String']['output']>;
  originatingType: Scalars['Int']['output'];
  qManageTicketId: Maybe<Scalars['String']['output']>;
  requestedByUser: User;
  requestedByUserId: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updateDate: Scalars['UtcDateTime']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface AllowedIpAddressConnection {
  /** Information to aid in pagination. */
  edges: Array<AllowedIpAddressModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<AllowedIpAddress>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface AllowedIpAddressInput {
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  allowedIpAddressId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  originatingType?: InputMaybe<Scalars['Int']['input']>;
  qManageTicketId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface AllowedIpAddressModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AllowedIpAddress;
}

export interface AreaCodeRisk {
  areaCode: Scalars['Int']['output'];
  areaCodeRiskId: Scalars['UInt']['output'];
  riskLevel: Scalars['Int']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface AreaCodeRiskConnection {
  /** Information to aid in pagination. */
  edges: Array<AreaCodeRiskModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<AreaCodeRisk>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface AreaCodeRiskModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AreaCodeRisk;
}

export interface AutoAttendantKey {
  autoAttendantKeyId: Scalars['UInt']['output'];
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  extensionAutoAttendant: ExtensionAutoAttendant;
  extensionAutoAttendantId: Scalars['UInt']['output'];
  /** @deprecated  */
  extensionId: Maybe<Scalars['UInt']['output']>;
  keyNumber: Maybe<Scalars['String']['output']>;
  nameDirectoryOnly: Scalars['Boolean']['output'];
  routeTo: Maybe<Scalars['UInt']['output']>;
  routeToExtension: Maybe<Extension>;
  routeToNullAction: NullActionTypes;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
  voiceMailOnly: Scalars['Boolean']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface AutoAttendantKeyConnection {
  /** Information to aid in pagination. */
  edges: Array<AutoAttendantKeyModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<AutoAttendantKey>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface AutoAttendantKeyInput {
  autoAttendantKeyId?: InputMaybe<Scalars['UInt']['input']>;
  extensionAutoAttendantId?: InputMaybe<Scalars['UInt']['input']>;
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  keyNumber?: InputMaybe<Scalars['String']['input']>;
  nameDirectoryOnly?: InputMaybe<Scalars['Boolean']['input']>;
  routeTo?: InputMaybe<Scalars['UInt']['input']>;
  routeToNullAction?: InputMaybe<NullActionTypes>;
  voiceMailOnly?: InputMaybe<Scalars['Boolean']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface AutoAttendantKeyModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AutoAttendantKey;
}

export interface AutoAttendantPrompt {
  autoAttendantPromptId: Scalars['UInt']['output'];
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  extensionAutoAttendant: ExtensionAutoAttendant;
  extensionAutoAttendantId: Scalars['UInt']['output'];
  /** @deprecated  */
  extensionId: Maybe<Scalars['UInt']['output']>;
  prompt: Maybe<Prompt>;
  promptId: Maybe<Scalars['UInt']['output']>;
  sortId: Scalars['UInt']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface AutoAttendantPromptConnection {
  /** Information to aid in pagination. */
  edges: Array<AutoAttendantPromptModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<AutoAttendantPrompt>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface AutoAttendantPromptInput {
  autoAttendantPromptId?: InputMaybe<Scalars['UInt']['input']>;
  extensionAutoAttendantId?: InputMaybe<Scalars['UInt']['input']>;
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  promptId?: InputMaybe<Scalars['UInt']['input']>;
  sortId?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface AutoAttendantPromptModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AutoAttendantPrompt;
}

export interface AzureActiveDirectoryConfiguration {
  azureActiveDirectoryConfigurationId: Scalars['UInt']['output'];
  clientId: Maybe<Scalars['String']['output']>;
  clientSecretKey: Maybe<Scalars['String']['output']>;
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  filterString: Maybe<Scalars['String']['output']>;
  groupNames: Maybe<Scalars['String']['output']>;
  tenantId: Maybe<Scalars['String']['output']>;
  tokenUrlFormat: Maybe<Scalars['String']['output']>;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
  userDirectorySourceId: Scalars['UInt']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface AzureActiveDirectoryConfigurationConnection {
  /** Information to aid in pagination. */
  edges: Array<AzureActiveDirectoryConfigurationModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<AzureActiveDirectoryConfiguration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface AzureActiveDirectoryConfigurationModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AzureActiveDirectoryConfiguration;
}

export interface BannedProvisioningIp {
  bannedProvisioningIpId: Scalars['Int']['output'];
  ipAddress: Maybe<Scalars['String']['output']>;
  isUnblock: Maybe<Scalars['Int']['output']>;
  type: Maybe<BlockedIpTypes>;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface BannedProvisioningIpConnection {
  /** Information to aid in pagination. */
  edges: Array<BannedProvisioningIpModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<BannedProvisioningIp>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface BannedProvisioningIpInput {
  bannedProvisioningIpId?: InputMaybe<Scalars['Int']['input']>;
  fields: Array<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  isUnblock?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<BlockedIpTypes>;
  updateDate?: InputMaybe<Scalars['DateTime']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface BannedProvisioningIpModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: BannedProvisioningIp;
}

export interface BaseStationHandset {
  baseStationHandsetId: Scalars['UInt']['output'];
  device: Device;
  deviceId: Scalars['UInt']['output'];
  phone: Phone;
  phoneId: Scalars['UInt']['output'];
  sortId: Scalars['UInt']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface BaseStationHandsetConnection {
  /** Information to aid in pagination. */
  edges: Array<BaseStationHandsetModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<BaseStationHandset>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface BaseStationHandsetInput {
  baseStationHandsetId?: InputMaybe<Scalars['UInt']['input']>;
  device?: InputMaybe<DeviceInput>;
  deviceId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  phoneId?: InputMaybe<Scalars['UInt']['input']>;
  sortId?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface BaseStationHandsetModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: BaseStationHandset;
}

export interface BlockedIpAddress {
  blockedIpAddressId: Scalars['UInt']['output'];
  firstSeen: Scalars['UtcDateTime']['output'];
  ipAddress: Maybe<Scalars['String']['output']>;
  status: BlockedIpStatuses;
  type: BlockedIpTypes;
  updateDate: Scalars['UtcDateTime']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface BlockedIpAddressConnection {
  /** Information to aid in pagination. */
  edges: Array<BlockedIpAddressModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<BlockedIpAddress>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface BlockedIpAddressInput {
  blockedIpAddressId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BlockedIpStatuses>;
  type?: InputMaybe<BlockedIpTypes>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface BlockedIpAddressModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: BlockedIpAddress;
}

export enum BlockedIpStatuses {
  /** Banned */
  Banned = 'Banned',
  /** Requested */
  Requested = 'Requested',
  /** Unbanning */
  Unbanning = 'Unbanning'
}

export enum BlockedIpTypes {
  /** Fail2Ban */
  Fail2Ban = 'Fail2Ban',
  /** GlobalBlocklist */
  GlobalBlocklist = 'GlobalBlocklist',
  /** NDTBlocklist */
  NDTBlocklist = 'NDTBlocklist'
}

export interface BlockedPhoneNumber {
  account: Account;
  accountId: Scalars['UInt']['output'];
  blockedPhoneNumberId: Scalars['UInt']['output'];
  comment: Maybe<Scalars['String']['output']>;
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface BlockedPhoneNumberConnection {
  /** Information to aid in pagination. */
  edges: Array<BlockedPhoneNumberModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<BlockedPhoneNumber>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface BlockedPhoneNumberInput {
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  blockedPhoneNumberId?: InputMaybe<Scalars['UInt']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  fields: Array<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface BlockedPhoneNumberModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: BlockedPhoneNumber;
}

export enum CallBackTypes {
  /** Callers In The Queue */
  CallersInTheQueue = 'CallersInTheQueue',
  /** Expected Hold Time */
  ExpectedHoldTime = 'ExpectedHoldTime'
}

export interface CallDetail {
  account: Account;
  accountId: Scalars['UInt']['output'];
  callCost: Scalars['Float']['output'];
  callDetailId: Scalars['UInt']['output'];
  callDirectionTypeId: CallDirectionTypes;
  callDirectionTypeName: Maybe<Scalars['String']['output']>;
  callDispositionTypeId: CallDispositionTypes;
  callDispositionTypeName: Maybe<Scalars['String']['output']>;
  callRate: Scalars['Float']['output'];
  callRecording: Maybe<CallRecording>;
  callRecordingCallDetailConnection: CallRecordingCallDetailConnection;
  callRecordingId: Maybe<Scalars['UInt']['output']>;
  callSegmentsConnection: CallSegmentConnection;
  callerChannelId: Maybe<Scalars['String']['output']>;
  callerName: Maybe<Scalars['String']['output']>;
  destinationExtension: Maybe<Extension>;
  destinationExtensionId: Maybe<Scalars['UInt']['output']>;
  destinationIpAddress: Maybe<Scalars['String']['output']>;
  destinationNumber: Maybe<Scalars['String']['output']>;
  destinationProviderId: Maybe<Providers>;
  endTime: Maybe<Scalars['UtcDateTime']['output']>;
  originalDestinationNumber: Maybe<Scalars['String']['output']>;
  otrTriggered: Scalars['Boolean']['output'];
  phoneNumber: Maybe<PhoneNumber>;
  phoneNumberId: Maybe<Scalars['UInt']['output']>;
  providerId: Maybe<Providers>;
  queueHistoriesConnection: QueueHistoryConnection;
  queueHistoryCallDetailsConnection: QueueHistoryCallDetailConnection;
  server: Maybe<Server>;
  serverId: Maybe<Scalars['UInt']['output']>;
  serverName: Maybe<Scalars['String']['output']>;
  sipCallId: Maybe<Scalars['String']['output']>;
  sourceExtension: Maybe<Extension>;
  sourceExtensionId: Maybe<Scalars['UInt']['output']>;
  sourceIpAddress: Maybe<Scalars['String']['output']>;
  sourceNumber: Maybe<Scalars['String']['output']>;
  sourceProviderId: Maybe<Providers>;
  startTime: Scalars['UtcDateTime']['output'];
  stirShakenAttest: Maybe<Scalars['String']['output']>;
  stirShakenToken: Maybe<Scalars['String']['output']>;
  stirShakenVerification: Scalars['Int']['output'];
}


export interface CallDetailCallRecordingCallDetailConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface CallDetailCallSegmentsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface CallDetailQueueHistoriesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface CallDetailQueueHistoryCallDetailsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

export interface CallDetailAppsuiteChannel {
  callDetail: ActiveCall;
  callDetailAppsuiteChannelId: Scalars['UInt']['output'];
  callDetailId: Scalars['UInt']['output'];
  channelId: Maybe<Scalars['String']['output']>;
  extension: Extension;
  extensionId: Scalars['UInt']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface CallDetailAppsuiteChannelConnection {
  /** Information to aid in pagination. */
  edges: Array<CallDetailAppsuiteChannelModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<CallDetailAppsuiteChannel>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface CallDetailAppsuiteChannelInput {
  callDetailAppsuiteChannelId?: InputMaybe<Scalars['UInt']['input']>;
  callDetailId?: InputMaybe<Scalars['UInt']['input']>;
  channelId?: InputMaybe<Scalars['String']['input']>;
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface CallDetailAppsuiteChannelModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CallDetailAppsuiteChannel;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface CallDetailConnection {
  /** Information to aid in pagination. */
  edges: Array<CallDetailModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<CallDetail>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface CallDetailInput {
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  callCost?: InputMaybe<Scalars['Float']['input']>;
  callDetailId?: InputMaybe<Scalars['UInt']['input']>;
  callDirectionTypeId?: InputMaybe<CallDirectionTypes>;
  callDispositionTypeId?: InputMaybe<CallDispositionTypes>;
  callRate?: InputMaybe<Scalars['Float']['input']>;
  callRecordingId?: InputMaybe<Scalars['UInt']['input']>;
  callerChannelId?: InputMaybe<Scalars['String']['input']>;
  callerName?: InputMaybe<Scalars['String']['input']>;
  destinationExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  destinationIpAddress?: InputMaybe<Scalars['String']['input']>;
  destinationNumber?: InputMaybe<Scalars['String']['input']>;
  destinationProviderId?: InputMaybe<Providers>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  fields: Array<Scalars['String']['input']>;
  originalDestinationNumber?: InputMaybe<Scalars['String']['input']>;
  otrTriggered?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumberId?: InputMaybe<Scalars['UInt']['input']>;
  providerId?: InputMaybe<Providers>;
  serverId?: InputMaybe<Scalars['UInt']['input']>;
  serverName?: InputMaybe<Scalars['String']['input']>;
  sipCallId?: InputMaybe<Scalars['String']['input']>;
  sourceExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  sourceIpAddress?: InputMaybe<Scalars['String']['input']>;
  sourceNumber?: InputMaybe<Scalars['String']['input']>;
  sourceProviderId?: InputMaybe<Providers>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  stirShakenAttest?: InputMaybe<Scalars['String']['input']>;
  stirShakenToken?: InputMaybe<Scalars['String']['input']>;
  stirShakenVerification?: InputMaybe<Scalars['Int']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface CallDetailModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CallDetail;
}

export interface CallDetailReadOnly {
  account: Account;
  accountId: Scalars['UInt']['output'];
  callCost: Scalars['Float']['output'];
  callDetailId: Scalars['UInt']['output'];
  callDirectionTypeId: CallDirectionTypes;
  callDirectionTypeName: Maybe<Scalars['String']['output']>;
  callDispositionTypeId: CallDispositionTypes;
  callDispositionTypeName: Maybe<Scalars['String']['output']>;
  callRate: Scalars['Float']['output'];
  callRecording: Maybe<CallRecording>;
  callRecordingCallDetailConnection: CallRecordingCallDetailConnection;
  callRecordingId: Maybe<Scalars['UInt']['output']>;
  callSegmentsConnection: CallSegmentConnection;
  callerChannelId: Maybe<Scalars['String']['output']>;
  callerName: Maybe<Scalars['String']['output']>;
  destinationExtension: Maybe<Extension>;
  destinationExtensionId: Maybe<Scalars['UInt']['output']>;
  destinationIpAddress: Maybe<Scalars['String']['output']>;
  destinationNumber: Maybe<Scalars['String']['output']>;
  destinationProviderId: Maybe<Providers>;
  endTime: Maybe<Scalars['UtcDateTime']['output']>;
  originalDestinationNumber: Maybe<Scalars['String']['output']>;
  otrTriggered: Scalars['Boolean']['output'];
  phoneNumber: Maybe<PhoneNumber>;
  phoneNumberId: Maybe<Scalars['UInt']['output']>;
  providerId: Maybe<Providers>;
  queueHistoriesConnection: QueueHistoryConnection;
  queueHistoryCallDetailsConnection: QueueHistoryCallDetailConnection;
  server: Maybe<Server>;
  serverId: Maybe<Scalars['UInt']['output']>;
  serverName: Maybe<Scalars['String']['output']>;
  sipCallId: Maybe<Scalars['String']['output']>;
  sourceExtension: Maybe<Extension>;
  sourceExtensionId: Maybe<Scalars['UInt']['output']>;
  sourceIpAddress: Maybe<Scalars['String']['output']>;
  sourceNumber: Maybe<Scalars['String']['output']>;
  sourceProviderId: Maybe<Providers>;
  startTime: Scalars['UtcDateTime']['output'];
  stirShakenAttest: Maybe<Scalars['String']['output']>;
  stirShakenToken: Maybe<Scalars['String']['output']>;
  stirShakenVerification: Scalars['Int']['output'];
}


export interface CallDetailReadOnlyCallRecordingCallDetailConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface CallDetailReadOnlyCallSegmentsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface CallDetailReadOnlyQueueHistoriesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface CallDetailReadOnlyQueueHistoryCallDetailsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface CallDetailReadOnlyConnection {
  /** Information to aid in pagination. */
  edges: Array<CallDetailReadOnlyModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<CallDetailReadOnly>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface CallDetailReadOnlyModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CallDetailReadOnly;
}

export enum CallDirectionTypes {
  Inbound = 'Inbound',
  /** Internal */
  Internal = 'Internal',
  Outbound = 'Outbound',
  System = 'System'
}

export enum CallDispositionTypes {
  Abandoned = 'Abandoned',
  Answered = 'Answered',
  Missed = 'Missed',
  /** Queue Call Back */
  QueueCallBack = 'QueueCallBack',
  Rejected = 'Rejected',
  Unknown = 'Unknown',
  Voicemail = 'Voicemail'
}

export enum CallEvents {
  /** Attended Transfer */
  ATTENDEDTRANSFER = 'ATTENDEDTRANSFER',
  /** Blind Transfer */
  BLINDTRANSFER = 'BLINDTRANSFER',
  /** Call Parked */
  CALLPARK = 'CALLPARK',
  /** Forward */
  FORWARD = 'FORWARD',
  /** Routing */
  ROUTING = 'ROUTING'
}

export interface CallNotificationTransmission {
  callNotification: Maybe<Scalars['String']['output']>;
  callNotificationTransmissionId: Scalars['UInt']['output'];
  createDate: Maybe<Scalars['UtcDateTime']['output']>;
  transmissionStatusId: CallNotificationTransmissionStatuses;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface CallNotificationTransmissionConnection {
  /** Information to aid in pagination. */
  edges: Array<CallNotificationTransmissionModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<CallNotificationTransmission>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface CallNotificationTransmissionModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CallNotificationTransmission;
}

export enum CallNotificationTransmissionStatuses {
  /** Failed */
  Failed = 'Failed',
  /** Missed */
  Missed = 'Missed',
  /** Sending */
  Sending = 'Sending',
  /** Service Unavailable */
  ServiceUnavailable = 'ServiceUnavailable',
  /** Success */
  Success = 'Success'
}

export interface CallParkingLot {
  callDetail: ActiveCall;
  callDetailId: Scalars['UInt']['output'];
  callParkingLotId: Scalars['UInt']['output'];
  callerIdInformation: Maybe<Scalars['String']['output']>;
  parkDateTime: Scalars['UtcDateTime']['output'];
  parkedChannelId: Maybe<Scalars['String']['output']>;
  parkerExtension: Extension;
  parkerExtensionId: Scalars['UInt']['output'];
  parkingSlotNumber: Scalars['Int']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface CallParkingLotConnection {
  /** Information to aid in pagination. */
  edges: Array<CallParkingLotModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<CallParkingLot>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface CallParkingLotInput {
  callDetail?: InputMaybe<ActiveCallInput>;
  callDetailId?: InputMaybe<Scalars['UInt']['input']>;
  callParkingLotId?: InputMaybe<Scalars['UInt']['input']>;
  callerIdInformation?: InputMaybe<Scalars['String']['input']>;
  fields: Array<Scalars['String']['input']>;
  parkedChannelId?: InputMaybe<Scalars['String']['input']>;
  parkerExtension?: InputMaybe<ExtensionInput>;
  parkerExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  parkingSlotNumber?: InputMaybe<Scalars['Int']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface CallParkingLotModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CallParkingLot;
}

export interface CallParkingLotTileTicketGraphType {
  callDetail: CallDetail;
  callDetailId: Scalars['UInt']['output'];
  callParkingLotId: Scalars['UInt']['output'];
  callerIdInformation: Maybe<Scalars['String']['output']>;
  data: Array<CallParkingLotTileTicketGraphType>;
  isListItem: Scalars['Boolean']['output'];
  parkDateTime: Scalars['UtcDateTime']['output'];
  parkerExtension: Extension;
  parkerExtensionId: Scalars['UInt']['output'];
  parkingSlotNumber: Scalars['Int']['output'];
}

export interface CallParkingTileDataGraphType {
  accountId: Scalars['UInt']['output'];
  callParkingLots: Array<CallParkingLotTileTicketGraphType>;
  name: Maybe<Scalars['String']['output']>;
}

export interface CallParkingTileGraphType {
  dashboardTileId: Maybe<Scalars['Int']['output']>;
  data: Maybe<CallParkingTileDataGraphType>;
  isLcs: Scalars['Boolean']['output'];
  parameters: Maybe<CallParkingTileReportParametersGraphType>;
  runDate: Scalars['UtcDateTime']['output'];
}

export interface CallParkingTileReportParametersGraphType {
  aggregateRest: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  selectedAccount: Maybe<SelectedAccountReportParameterGraphType>;
  tileLayoutConfiguration: Maybe<TileLayoutConfigurationParameterGraphType>;
  timeZone: Maybe<TimeZoneReportParameterGraphType>;
}

export interface CallParkingTileReportParametersInput {
  aggregateRest?: InputMaybe<Scalars['Boolean']['input']>;
  fields: Array<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  selectedAccount?: InputMaybe<SelectedAccountReportParameterInput>;
  tileLayoutConfiguration?: InputMaybe<TileLayoutConfigurationParameterInput>;
  timeZone?: InputMaybe<TimeZoneReportParameterInput>;
}

export interface CallQueueExtensionsToIncludeReportParameterGraphType {
  accountId: Scalars['UInt']['output'];
  all: Scalars['Boolean']['output'];
  isAskParameter: Scalars['Boolean']['output'];
  names: Array<Maybe<Scalars['String']['output']>>;
  parameterType: ReportParameters;
  sortOrder: Maybe<Scalars['Int']['output']>;
  values: Array<Scalars['UInt']['output']>;
}

export interface CallQueueExtensionsToIncludeReportParameterInput {
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  all?: InputMaybe<Scalars['Boolean']['input']>;
  fields: Array<Scalars['String']['input']>;
  isAskParameter?: InputMaybe<Scalars['Boolean']['input']>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parameterType?: InputMaybe<ReportParameters>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  values?: InputMaybe<Array<Scalars['UInt']['input']>>;
}

export interface CallRecording {
  account: Account;
  accountId: Scalars['UInt']['output'];
  callDetail: Maybe<CallDetail>;
  callRecordingCallDetail: Maybe<CallRecordingCallDetail>;
  callRecordingId: Scalars['UInt']['output'];
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  file: Maybe<File>;
  fileId: Maybe<Scalars['UInt']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  isRetentionDeleted: Scalars['Boolean']['output'];
  isRetentionDeletedError: Scalars['Boolean']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}

export interface CallRecordingCallDetail {
  callDetail: CallDetail;
  callDetailId: Scalars['UInt']['output'];
  callRecording: CallRecording;
  callRecordingCallDetailId: Scalars['UInt']['output'];
  callRecordingId: Scalars['UInt']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface CallRecordingCallDetailConnection {
  /** Information to aid in pagination. */
  edges: Array<CallRecordingCallDetailModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<CallRecordingCallDetail>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface CallRecordingCallDetailInput {
  callDetailId?: InputMaybe<Scalars['UInt']['input']>;
  callRecordingCallDetailId?: InputMaybe<Scalars['UInt']['input']>;
  callRecordingId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface CallRecordingCallDetailModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CallRecordingCallDetail;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface CallRecordingConnection {
  /** Information to aid in pagination. */
  edges: Array<CallRecordingModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<CallRecording>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface CallRecordingInput {
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  callDetail?: InputMaybe<CallDetailInput>;
  callRecordingCallDetail?: InputMaybe<CallRecordingCallDetailInput>;
  callRecordingId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  file?: InputMaybe<FileInput>;
  fileId?: InputMaybe<Scalars['UInt']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isRetentionDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isRetentionDeletedError?: InputMaybe<Scalars['Boolean']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface CallRecordingModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CallRecording;
}

export enum CallRetentionPolicyTypes {
  /** 18 Months */
  Eighteen = 'Eighteen',
  /** Unset */
  NegativeOne = 'NegativeOne',
  /** 60 Months */
  Sixty = 'Sixty',
  /** 36 Months */
  ThirtySix = 'ThirtySix'
}

export interface CallSegment {
  callDetail: CallDetail;
  callDetailId: Scalars['UInt']['output'];
  callEventId: Maybe<CallEvents>;
  callSegmentId: Scalars['UInt']['output'];
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  duration: Maybe<Scalars['UInt']['output']>;
  endDate: Maybe<Scalars['UtcDateTime']['output']>;
  extension: Maybe<Extension>;
  extensionId: Maybe<Scalars['UInt']['output']>;
  sequence: Scalars['UInt']['output'];
  sourceExtension: Maybe<Extension>;
  sourceExtensionId: Maybe<Scalars['UInt']['output']>;
  startDate: Scalars['UtcDateTime']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface CallSegmentConnection {
  /** Information to aid in pagination. */
  edges: Array<CallSegmentModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<CallSegment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface CallSegmentInput {
  callDetailId?: InputMaybe<Scalars['UInt']['input']>;
  callEventId?: InputMaybe<CallEvents>;
  callSegmentId?: InputMaybe<Scalars['UInt']['input']>;
  duration?: InputMaybe<Scalars['UInt']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['UInt']['input']>;
  sourceExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface CallSegmentModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CallSegment;
}

export interface ClockTileDataGraphType {
  showDate: Scalars['Boolean']['output'];
  timeZone: Maybe<Scalars['String']['output']>;
}

export interface ClockTileGraphType {
  dashboardTileId: Maybe<Scalars['Int']['output']>;
  data: Maybe<ClockTileDataGraphType>;
  isLcs: Scalars['Boolean']['output'];
  parameters: Maybe<ClockTileReportParametersGraphType>;
  runDate: Scalars['UtcDateTime']['output'];
}

export interface ClockTileReportParametersGraphType {
  aggregateRest: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  showDate: Maybe<ShowDateReportParameterGraphType>;
  tileLayoutConfiguration: Maybe<TileLayoutConfigurationParameterGraphType>;
  timeZone: Maybe<TimeZoneReportParameterGraphType>;
}

export interface ClockTileReportParametersInput {
  aggregateRest?: InputMaybe<Scalars['Boolean']['input']>;
  fields: Array<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  showDate?: InputMaybe<ShowDateReportParameterInput>;
  tileLayoutConfiguration?: InputMaybe<TileLayoutConfigurationParameterInput>;
  timeZone?: InputMaybe<TimeZoneReportParameterInput>;
}

export interface ClosedException {
  closedExceptionId: Scalars['UInt']['output'];
  endDate: Maybe<Scalars['UtcDateTime']['output']>;
  endTime: Maybe<Scalars['UtcDateTime']['output']>;
  prompt: Maybe<Prompt>;
  promptId: Maybe<Scalars['UInt']['output']>;
  schedule: Schedule;
  scheduleId: Scalars['UInt']['output'];
  startDate: Maybe<Scalars['UtcDateTime']['output']>;
  startTime: Maybe<Scalars['UtcDateTime']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface ClosedExceptionConnection {
  /** Information to aid in pagination. */
  edges: Array<ClosedExceptionModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<ClosedException>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface ClosedExceptionInput {
  closedExceptionId?: InputMaybe<Scalars['UInt']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  fields: Array<Scalars['String']['input']>;
  prompt?: InputMaybe<PromptInput>;
  promptId?: InputMaybe<Scalars['UInt']['input']>;
  schedule?: InputMaybe<ScheduleInput>;
  scheduleId?: InputMaybe<Scalars['UInt']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface ClosedExceptionModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ClosedException;
}

export interface ColumnSortReportParameterGraphType {
  isAskParameter: Scalars['Boolean']['output'];
  parameterType: ReportParameters;
  sortOrder: Maybe<Scalars['Int']['output']>;
  value: Maybe<Scalars['String']['output']>;
}

export interface ColumnSortReportParameterInput {
  fields: Array<Scalars['String']['input']>;
  isAskParameter?: InputMaybe<Scalars['Boolean']['input']>;
  parameterType?: InputMaybe<ReportParameters>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
}

export interface CronJob {
  baseUrl: Maybe<Scalars['String']['output']>;
  createDate: Scalars['UtcDateTime']['output'];
  createUser: User;
  createUserId: Scalars['Int']['output'];
  cronJobExecutionsConnection: CronJobExecutionConnection;
  cronJobId: Scalars['UInt']['output'];
  cronSchedule: Maybe<Scalars['String']['output']>;
  isDisabled: Scalars['Boolean']['output'];
  isReentrant: Scalars['Boolean']['output'];
  requestBody: Maybe<Scalars['String']['output']>;
  requestMethod: HttpRequestMethods;
  requestPath: Maybe<Scalars['String']['output']>;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}


export interface CronJobCronJobExecutionsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface CronJobConnection {
  /** Information to aid in pagination. */
  edges: Array<CronJobModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<CronJob>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface CronJobExecution {
  cronJob: CronJob;
  cronJobExecutionId: Scalars['UInt']['output'];
  cronJobId: Scalars['UInt']['output'];
  endDate: Maybe<Scalars['UtcDateTime']['output']>;
  responseBody: Maybe<Scalars['String']['output']>;
  runDate: Maybe<Scalars['UtcDateTime']['output']>;
  scheduledDate: Scalars['UtcDateTime']['output'];
  status: ScheduledJobStatuses;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface CronJobExecutionConnection {
  /** Information to aid in pagination. */
  edges: Array<CronJobExecutionModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<CronJobExecution>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface CronJobExecutionInput {
  cronJob?: InputMaybe<CronJobInput>;
  cronJobExecutionId?: InputMaybe<Scalars['UInt']['input']>;
  cronJobId?: InputMaybe<Scalars['UInt']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fields: Array<Scalars['String']['input']>;
  responseBody?: InputMaybe<Scalars['String']['input']>;
  runDate?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ScheduledJobStatuses>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface CronJobExecutionModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CronJobExecution;
}

export interface CronJobInput {
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  cronJobExecutions?: InputMaybe<Array<CronJobExecutionInput>>;
  cronJobId?: InputMaybe<Scalars['UInt']['input']>;
  cronSchedule?: InputMaybe<Scalars['String']['input']>;
  fields: Array<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isReentrant?: InputMaybe<Scalars['Boolean']['input']>;
  requestBody?: InputMaybe<Scalars['String']['input']>;
  requestMethod?: InputMaybe<HttpRequestMethods>;
  requestPath?: InputMaybe<Scalars['String']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface CronJobModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CronJob;
}

export interface Dashboard {
  createDate: Scalars['UtcDateTime']['output'];
  createUserId: Maybe<Scalars['Int']['output']>;
  dashboardId: Scalars['UInt']['output'];
  dashboardTilesConnection: DashboardTileConnection;
  lastSavedColumnLayoutSize: Scalars['Int']['output'];
  name: Maybe<Scalars['String']['output']>;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUserId: Maybe<Scalars['Int']['output']>;
  user: User;
  userId: Scalars['Int']['output'];
}


export interface DashboardDashboardTilesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface DashboardConnection {
  /** Information to aid in pagination. */
  edges: Array<DashboardModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Dashboard>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface DashboardInput {
  dashboardId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  lastSavedColumnLayoutSize?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface DashboardModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Dashboard;
}

export interface DashboardTile {
  createDate: Scalars['UtcDateTime']['output'];
  createUserId: Maybe<Scalars['Int']['output']>;
  dashboard: Dashboard;
  dashboardId: Scalars['UInt']['output'];
  dashboardTileId: Scalars['UInt']['output'];
  dashboardTileLayoutConfiguration: Maybe<DashboardTileLayoutConfiguration>;
  dashboardTileParametersConnection: DashboardTileParameterConnection;
  tile: Tile;
  tileId: Tiles;
  tileViewMode: TileViewModes;
  totalMillisecondsProcessed: Scalars['UInt']['output'];
  totalTimesProcessed: Scalars['UInt']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}


export interface DashboardTileDashboardTileParametersConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface DashboardTileConnection {
  /** Information to aid in pagination. */
  edges: Array<DashboardTileModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<DashboardTile>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface DashboardTileEntityParameter {
  all: Scalars['Boolean']['output'];
  dashboardTileEntityParameterId: Scalars['UInt']['output'];
  dashboardTileParameter: Maybe<DashboardTileParameter>;
  entityIdsConnection: DashboardTileEntityParameterValueConnection;
  includeNull: Scalars['Boolean']['output'];
}


export interface DashboardTileEntityParameterEntityIdsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface DashboardTileEntityParameterConnection {
  /** Information to aid in pagination. */
  edges: Array<DashboardTileEntityParameterModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<DashboardTileEntityParameter>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface DashboardTileEntityParameterInput {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  dashboardTileEntityParameterId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  includeNull?: InputMaybe<Scalars['Boolean']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface DashboardTileEntityParameterModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DashboardTileEntityParameter;
}

export interface DashboardTileEntityParameterValue {
  dashboardTileEntityParameter: DashboardTileEntityParameter;
  dashboardTileEntityParameterId: Scalars['UInt']['output'];
  dashboardTileEntityParameterValueId: Scalars['UInt']['output'];
  entityId: Scalars['UInt']['output'];
  sortOrder: Maybe<Scalars['UInt']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface DashboardTileEntityParameterValueConnection {
  /** Information to aid in pagination. */
  edges: Array<DashboardTileEntityParameterValueModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<DashboardTileEntityParameterValue>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface DashboardTileEntityParameterValueInput {
  dashboardTileEntityParameterId?: InputMaybe<Scalars['UInt']['input']>;
  dashboardTileEntityParameterValueId?: InputMaybe<Scalars['UInt']['input']>;
  entityId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface DashboardTileEntityParameterValueModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DashboardTileEntityParameterValue;
}

export interface DashboardTileInput {
  dashboard?: InputMaybe<DashboardInput>;
  dashboardId?: InputMaybe<Scalars['UInt']['input']>;
  dashboardTileId?: InputMaybe<Scalars['UInt']['input']>;
  dashboardTileLayoutConfiguration?: InputMaybe<DashboardTileLayoutConfigurationInput>;
  dashboardTileParameters?: InputMaybe<Array<DashboardTileParameterInput>>;
  fields: Array<Scalars['String']['input']>;
  tile?: InputMaybe<TileInput>;
  tileId?: InputMaybe<Tiles>;
  tileViewMode?: InputMaybe<TileViewModes>;
  totalMillisecondsProcessed?: InputMaybe<Scalars['UInt']['input']>;
  totalTimesProcessed?: InputMaybe<Scalars['UInt']['input']>;
}

export interface DashboardTileLayoutConfiguration {
  color: Maybe<Scalars['String']['output']>;
  column: Scalars['Int']['output'];
  dashboardTile: DashboardTile;
  dashboardTileId: Scalars['UInt']['output'];
  dashboardTileLayoutConfigurationId: Scalars['UInt']['output'];
  height: Scalars['Int']['output'];
  maxHeight: Maybe<Scalars['Int']['output']>;
  maxWidth: Maybe<Scalars['Int']['output']>;
  minHeight: Maybe<Scalars['Int']['output']>;
  minWidth: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  refreshTimeSeconds: Maybe<Scalars['Int']['output']>;
  row: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface DashboardTileLayoutConfigurationConnection {
  /** Information to aid in pagination. */
  edges: Array<DashboardTileLayoutConfigurationModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<DashboardTileLayoutConfiguration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface DashboardTileLayoutConfigurationInput {
  color?: InputMaybe<Scalars['String']['input']>;
  column?: InputMaybe<Scalars['Int']['input']>;
  dashboardTileId?: InputMaybe<Scalars['UInt']['input']>;
  dashboardTileLayoutConfigurationId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  maxHeight?: InputMaybe<Scalars['Int']['input']>;
  maxWidth?: InputMaybe<Scalars['Int']['input']>;
  minHeight?: InputMaybe<Scalars['Int']['input']>;
  minWidth?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  refreshTimeSeconds?: InputMaybe<Scalars['Int']['input']>;
  row?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface DashboardTileLayoutConfigurationModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DashboardTileLayoutConfiguration;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface DashboardTileModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DashboardTile;
}

export interface DashboardTileParameter {
  dashboardTile: DashboardTile;
  dashboardTileId: Scalars['UInt']['output'];
  dashboardTileParameterId: Scalars['UInt']['output'];
  dateRange: Maybe<DashboardTileParameterDateRange>;
  entitiesToInclude: Maybe<DashboardTileEntityParameter>;
  isAskParameter: Scalars['Boolean']['output'];
  parameterType: ReportParameters;
  sortOrder: Maybe<Scalars['Int']['output']>;
  valueBool: Maybe<Scalars['Boolean']['output']>;
  valueDateRangeParameterId: Maybe<Scalars['UInt']['output']>;
  valueDateTime: Maybe<Scalars['UtcDateTime']['output']>;
  valueEntitiesToIncludeId: Maybe<Scalars['UInt']['output']>;
  valueNumeric: Maybe<Scalars['UInt']['output']>;
  valueString: Maybe<Scalars['String']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface DashboardTileParameterConnection {
  /** Information to aid in pagination. */
  edges: Array<DashboardTileParameterModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<DashboardTileParameter>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface DashboardTileParameterDateRange {
  dashboardTileParameterDateRangeId: Scalars['UInt']['output'];
  endDate: Maybe<Scalars['UtcDateTime']['output']>;
  field: Maybe<Scalars['String']['output']>;
  filterByDateRange: Maybe<Scalars['Boolean']['output']>;
  relativeDate: Maybe<RelativeDateOptions>;
  relativeEndDate: Maybe<Scalars['String']['output']>;
  relativeStartDate: Maybe<Scalars['String']['output']>;
  startDate: Maybe<Scalars['UtcDateTime']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface DashboardTileParameterDateRangeConnection {
  /** Information to aid in pagination. */
  edges: Array<DashboardTileParameterDateRangeModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<DashboardTileParameterDateRange>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface DashboardTileParameterDateRangeInput {
  dashboardTileParameterDateRangeId?: InputMaybe<Scalars['UInt']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  fields: Array<Scalars['String']['input']>;
  filterByDateRange?: InputMaybe<Scalars['Boolean']['input']>;
  relativeDate?: InputMaybe<RelativeDateOptions>;
  relativeEndDate?: InputMaybe<Scalars['String']['input']>;
  relativeStartDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface DashboardTileParameterDateRangeModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DashboardTileParameterDateRange;
}

export interface DashboardTileParameterInput {
  dashboardTile?: InputMaybe<DashboardTileInput>;
  dashboardTileId?: InputMaybe<Scalars['UInt']['input']>;
  dashboardTileParameterId?: InputMaybe<Scalars['UInt']['input']>;
  dateRange?: InputMaybe<DashboardTileParameterDateRangeInput>;
  entitiesToInclude?: InputMaybe<DashboardTileEntityParameterInput>;
  fields: Array<Scalars['String']['input']>;
  isAskParameter?: InputMaybe<Scalars['Boolean']['input']>;
  parameterType?: InputMaybe<ReportParameters>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  valueBool?: InputMaybe<Scalars['Boolean']['input']>;
  valueDateRangeParameterId?: InputMaybe<Scalars['UInt']['input']>;
  valueDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  valueEntitiesToIncludeId?: InputMaybe<Scalars['UInt']['input']>;
  valueNumeric?: InputMaybe<Scalars['UInt']['input']>;
  valueString?: InputMaybe<Scalars['String']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface DashboardTileParameterModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DashboardTileParameter;
}

export enum DayOfWeek {
  /** Friday */
  Friday = 'Friday',
  /** Monday */
  Monday = 'Monday',
  /** Saturday */
  Saturday = 'Saturday',
  /** Sunday */
  Sunday = 'Sunday',
  /** Thursday */
  Thursday = 'Thursday',
  /** Tuesday */
  Tuesday = 'Tuesday',
  /** Wednesday */
  Wednesday = 'Wednesday'
}

export interface DeleteOption {
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  dateTimeValue?: InputMaybe<Scalars['DateTime']['input']>;
  intValue?: InputMaybe<Scalars['Int']['input']>;
  option: Scalars['String']['input'];
  stringValue?: InputMaybe<Scalars['String']['input']>;
}

export interface Department {
  account: Account;
  accountId: Scalars['UInt']['output'];
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  departmentExtensionsConnection: DepartmentExtensionConnection;
  departmentId: Scalars['UInt']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  updateDate: Scalars['UtcDateTime']['output'];
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}


export interface DepartmentDepartmentExtensionsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface DepartmentConnection {
  /** Information to aid in pagination. */
  edges: Array<DepartmentModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Department>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface DepartmentExtension {
  createDate: Scalars['UtcDateTime']['output'];
  createUser: User;
  createUserId: Scalars['Int']['output'];
  department: Department;
  departmentExtensionId: Scalars['UInt']['output'];
  departmentId: Scalars['UInt']['output'];
  extension: Extension;
  extensionId: Scalars['UInt']['output'];
  updateDate: Scalars['UtcDateTime']['output'];
  updateUser: User;
  updateUserId: Scalars['Int']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface DepartmentExtensionConnection {
  /** Information to aid in pagination. */
  edges: Array<DepartmentExtensionModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<DepartmentExtension>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface DepartmentExtensionInput {
  department?: InputMaybe<DepartmentInput>;
  departmentExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  departmentId?: InputMaybe<Scalars['UInt']['input']>;
  extension?: InputMaybe<ExtensionInput>;
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface DepartmentExtensionModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DepartmentExtension;
}

export interface DepartmentInput {
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  departmentExtensions?: InputMaybe<Array<DepartmentExtensionInput>>;
  departmentId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface DepartmentModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Department;
}

export interface Device {
  account: Maybe<Account>;
  accountId: Maybe<Scalars['UInt']['output']>;
  baseStationHandsetsConnection: BaseStationHandsetConnection;
  centralId: Maybe<Scalars['UInt']['output']>;
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  description: Maybe<Scalars['String']['output']>;
  deviceId: Scalars['UInt']['output'];
  deviceType: DeviceType;
  deviceTypeId: DeviceTypes;
  devicesConnection: DeviceConnection;
  lastFirmwareReported: Maybe<Scalars['String']['output']>;
  lastProvisionedDate: Maybe<Scalars['UtcDateTime']['output']>;
  lastZtResponse: Maybe<Scalars['String']['output']>;
  macAddress: Maybe<Scalars['String']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  phone: Maybe<Phone>;
  phoneId: Maybe<Scalars['UInt']['output']>;
  serialNumber: Maybe<Scalars['String']['output']>;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
  ztStatus: Scalars['Boolean']['output'];
}


export interface DeviceBaseStationHandsetsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface DeviceDevicesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface DeviceConnection {
  /** Information to aid in pagination. */
  edges: Array<DeviceModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Device>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface DeviceInput {
  account?: InputMaybe<AccountInput>;
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  baseStationHandsets?: InputMaybe<Array<BaseStationHandsetInput>>;
  centralId?: InputMaybe<Scalars['UInt']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['UInt']['input']>;
  deviceType?: InputMaybe<DeviceTypeInput>;
  deviceTypeId?: InputMaybe<DeviceTypes>;
  devices?: InputMaybe<Array<DeviceInput>>;
  fields: Array<Scalars['String']['input']>;
  lastFirmwareReported?: InputMaybe<Scalars['String']['input']>;
  lastProvisionedDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastZtResponse?: InputMaybe<Scalars['String']['input']>;
  macAddress?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<PhoneInput>;
  phoneId?: InputMaybe<Scalars['UInt']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  ztStatus?: InputMaybe<Scalars['Boolean']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface DeviceModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Device;
}

export interface DeviceType {
  deviceSoftwareStreamTypeId: Scalars['UInt']['output'];
  deviceTypeId: Scalars['Int']['output'];
  externalProvisioningSystemTypeId: Scalars['UInt']['output'];
  name: Maybe<Scalars['String']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface DeviceTypeConnection {
  /** Information to aid in pagination. */
  edges: Array<DeviceTypeModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<DeviceType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface DeviceTypeInput {
  deviceSoftwareStreamTypeId?: InputMaybe<Scalars['UInt']['input']>;
  deviceTypeId?: InputMaybe<Scalars['Int']['input']>;
  externalProvisioningSystemTypeId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface DeviceTypeModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DeviceType;
}

export enum DeviceTypes {
  /** CCX400 */
  CCX400 = 'CCX400',
  /** CCX500 */
  CCX500 = 'CCX500',
  /** CCX600 */
  CCX600 = 'CCX600',
  /** EdgeB30 */
  EdgeB30 = 'EdgeB30',
  /** EdgeE220 */
  EdgeE220 = 'EdgeE220',
  /** EdgeE320 */
  EdgeE320 = 'EdgeE320',
  /** EdgeE350 */
  EdgeE350 = 'EdgeE350',
  /** EdgeE450 */
  EdgeE450 = 'EdgeE450',
  /** IP450 */
  IP450 = 'IP450',
  /** IP6000 */
  IP6000 = 'IP6000',
  /** Model320 */
  Model320 = 'Model320',
  /** Model330 */
  Model330 = 'Model330',
  /** Model335 */
  Model335 = 'Model335',
  /** Model430 */
  Model430 = 'Model430',
  /** Model450 */
  Model450 = 'Model450',
  /** Model550 */
  Model550 = 'Model550',
  /** Model650 */
  Model650 = 'Model650',
  /** Model840 */
  Model840 = 'Model840',
  /** RoveB2 */
  RoveB2 = 'RoveB2',
  /** RoveB4 */
  RoveB4 = 'RoveB4',
  /** Trio8300 */
  Trio8300 = 'Trio8300',
  /** Trio8500 */
  Trio8500 = 'Trio8500',
  /** Trio8800 */
  Trio8800 = 'Trio8800',
  /** TrioC60 */
  TrioC60 = 'TrioC60',
  /** VVX150 */
  VVX150 = 'VVX150',
  /** VVX250 */
  VVX250 = 'VVX250',
  /** VVX300 */
  VVX300 = 'VVX300',
  /** VVX310 */
  VVX310 = 'VVX310',
  /** VVX311 */
  VVX311 = 'VVX311',
  /** VVX350 */
  VVX350 = 'VVX350',
  /** VVX400 */
  VVX400 = 'VVX400',
  /** VVX410 */
  VVX410 = 'VVX410',
  /** VVX411 */
  VVX411 = 'VVX411',
  /** VVX450 */
  VVX450 = 'VVX450',
  /** VVX500 */
  VVX500 = 'VVX500',
  /** VVX501 */
  VVX501 = 'VVX501',
  /** VVX600 */
  VVX600 = 'VVX600',
  /** VVX601 */
  VVX601 = 'VVX601',
  /** VVXD230 */
  VVXD230 = 'VVXD230'
}

export interface EffectiveUserPreferenceInput {
  expandMenu?: InputMaybe<Scalars['Boolean']['input']>;
  fields: Array<Scalars['String']['input']>;
  mostRecentDeviceType?: InputMaybe<Scalars['String']['input']>;
  queueHistoryRegisterWrapQueues?: InputMaybe<Scalars['Boolean']['input']>;
  selectedDashboardId?: InputMaybe<Scalars['UInt']['input']>;
  showExtensionRegisterPopup?: InputMaybe<Scalars['Boolean']['input']>;
  useAlternatingRowColors?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface EffectiveUserReport {
  createDate: Maybe<Scalars['UtcDateTime']['output']>;
  createUserId: Maybe<Scalars['Int']['output']>;
  report: ReportDefinitions;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUserId: Maybe<Scalars['Int']['output']>;
  userId: Maybe<Scalars['Int']['output']>;
}

export interface ExecuteTilePostModelCallParkingTileReportParametersInput {
  dashboardTileId?: InputMaybe<Scalars['Int']['input']>;
  fields: Array<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  parameters?: InputMaybe<CallParkingTileReportParametersInput>;
  tileId?: InputMaybe<Tiles>;
  tileViewMode?: InputMaybe<TileViewModes>;
}

export interface ExecuteTilePostModelClockTileReportParametersInput {
  dashboardTileId?: InputMaybe<Scalars['Int']['input']>;
  fields: Array<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  parameters?: InputMaybe<ClockTileReportParametersInput>;
  tileId?: InputMaybe<Tiles>;
  tileViewMode?: InputMaybe<TileViewModes>;
}

export interface ExecuteTilePostModelPhoneQueuesTileReportParametersInput {
  dashboardTileId?: InputMaybe<Scalars['Int']['input']>;
  fields: Array<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  parameters?: InputMaybe<PhoneQueuesTileReportParametersInput>;
  tileId?: InputMaybe<Tiles>;
  tileViewMode?: InputMaybe<TileViewModes>;
}

export interface ExecuteTilePostModelQueueMembersTileReportParametersInput {
  dashboardTileId?: InputMaybe<Scalars['Int']['input']>;
  fields: Array<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  parameters?: InputMaybe<QueueMembersTileReportParametersInput>;
  tileId?: InputMaybe<Tiles>;
  tileViewMode?: InputMaybe<TileViewModes>;
}

export interface ExecuteTilePostModelWaitTimesTileReportParametersInput {
  dashboardTileId?: InputMaybe<Scalars['Int']['input']>;
  fields: Array<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  parameters?: InputMaybe<WaitTimesTileReportParametersInput>;
  tileId?: InputMaybe<Tiles>;
  tileViewMode?: InputMaybe<TileViewModes>;
}

export interface Extension {
  account: Account;
  accountHoldMusicFileId: Maybe<Scalars['UInt']['output']>;
  accountId: Scalars['UInt']['output'];
  accountOperatorExtensionId: Maybe<Scalars['UInt']['output']>;
  accountTimeZoneId: TimeZones;
  adminNote: Maybe<Note>;
  adminNoteId: Maybe<Scalars['UInt']['output']>;
  autoAttendantsUsingForTimeoutConnection: ExtensionAutoAttendantConnection;
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  departmentExtensionsConnection: DepartmentExtensionConnection;
  departmentName: Maybe<Scalars['String']['output']>;
  displayTimeZone: TimeZones;
  extensionAutoAttendant: Maybe<ExtensionAutoAttendant>;
  extensionExternalForward: Maybe<ExtensionExternalForward>;
  extensionFax: Maybe<ExtensionFax>;
  extensionFmFm: Maybe<ExtensionFmFm>;
  extensionHuntGroup: Maybe<ExtensionHuntGroup>;
  extensionId: Scalars['UInt']['output'];
  extensionMailbox: Maybe<ExtensionMailbox>;
  extensionNote: Maybe<Note>;
  extensionNoteId: Maybe<Scalars['UInt']['output']>;
  extensionPagingGroup: Maybe<ExtensionPagingGroup>;
  extensionPhone: Maybe<ExtensionPhone>;
  extensionQueue: Maybe<ExtensionQueue>;
  extensionQueueHoldMusicFileId: Maybe<Scalars['UInt']['output']>;
  extensionType: Maybe<ExtensionType>;
  faxEmailAddressesConnection: FaxEmailAddressConnection;
  faxesConnection: FaxConnection;
  fmFmsUsingForFinalDestinationConnection: ExtensionFmFmConnection;
  holdMusicFileId: Maybe<Scalars['UInt']['output']>;
  huntGroupsUsingForRouteBusyConnection: ExtensionHuntGroupConnection;
  huntGroupsUsingForRouteNoAnswerConnection: ExtensionHuntGroupConnection;
  isArchived: Scalars['Boolean']['output'];
  location: Maybe<Location>;
  locationId: Maybe<Scalars['UInt']['output']>;
  locationTimeZoneId: Maybe<TimeZones>;
  mailbox: Maybe<Mailbox>;
  mailboxId: Maybe<Scalars['UInt']['output']>;
  mailboxOperatorExtension: Maybe<Extension>;
  mailboxOperatorExtensionId: Maybe<Scalars['UInt']['output']>;
  name: Maybe<Scalars['String']['output']>;
  number: Scalars['UInt']['output'];
  operatorExtensionId: Maybe<Scalars['UInt']['output']>;
  phoneRegistrationRank: Scalars['Int']['output'];
  phoneStatus: Maybe<Scalars['String']['output']>;
  phonesConnection: PhoneConnection;
  queueAgentDialsConnection: QueueAgentDialConnection;
  queueExtensionStatus: Maybe<QueueExtensionStatus>;
  queuesAsAgentConnection: QueueMemberConnection;
  queuesUsingForExitRouteConnection: ExtensionQueueConnection;
  rm12Client: Maybe<Rm12Client>;
  rm12ClientToken: Maybe<Rm12ClientToken>;
  shortName: Maybe<Scalars['String']['output']>;
  timeBasedRoutesConnection: TimeBasedRouteConnection;
  timeZoneId: Maybe<TimeZones>;
  type: ExtensionTypes;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
  usersConnection: UserConnection;
}


export interface ExtensionAutoAttendantsUsingForTimeoutConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface ExtensionDepartmentExtensionsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface ExtensionFaxEmailAddressesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface ExtensionFaxesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface ExtensionFmFmsUsingForFinalDestinationConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface ExtensionHuntGroupsUsingForRouteBusyConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface ExtensionHuntGroupsUsingForRouteNoAnswerConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface ExtensionPhonesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface ExtensionQueueAgentDialsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface ExtensionQueuesAsAgentConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface ExtensionQueuesUsingForExitRouteConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface ExtensionTimeBasedRoutesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface ExtensionUsersConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

export interface ExtensionAutoAttendant {
  autoAttendantKeysConnection: AutoAttendantKeyConnection;
  autoAttendantPromptsConnection: AutoAttendantPromptConnection;
  extension: Extension;
  extensionAutoAttendantId: Scalars['UInt']['output'];
  extensionId: Scalars['UInt']['output'];
  firstPromptNotSkippable: Scalars['Boolean']['output'];
  isTimeoutVoicemailOnly: Scalars['Boolean']['output'];
  timeoutExtension: Maybe<Extension>;
  timeoutExtensionId: Maybe<Scalars['UInt']['output']>;
  timeoutNullAction: NullActionTypes;
  timeoutSeconds: Maybe<Scalars['UInt']['output']>;
}


export interface ExtensionAutoAttendantAutoAttendantKeysConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface ExtensionAutoAttendantAutoAttendantPromptsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface ExtensionAutoAttendantConnection {
  /** Information to aid in pagination. */
  edges: Array<ExtensionAutoAttendantModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<ExtensionAutoAttendant>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface ExtensionAutoAttendantInput {
  autoAttendantKeys?: InputMaybe<Array<AutoAttendantKeyInput>>;
  autoAttendantPrompts?: InputMaybe<Array<AutoAttendantPromptInput>>;
  extensionAutoAttendantId?: InputMaybe<Scalars['UInt']['input']>;
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  firstPromptNotSkippable?: InputMaybe<Scalars['Boolean']['input']>;
  isTimeoutVoicemailOnly?: InputMaybe<Scalars['Boolean']['input']>;
  timeoutExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  timeoutNullAction?: InputMaybe<NullActionTypes>;
  timeoutSeconds?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface ExtensionAutoAttendantModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ExtensionAutoAttendant;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface ExtensionConnection {
  /** Information to aid in pagination. */
  edges: Array<ExtensionModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Extension>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface ExtensionExternalForward {
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  dtmf: Maybe<Scalars['String']['output']>;
  extension: Extension;
  extensionExternalForwardId: Scalars['UInt']['output'];
  extensionId: Scalars['UInt']['output'];
  forwardToNumber: Maybe<Scalars['String']['output']>;
  isDtmf: Scalars['Boolean']['output'];
  isPassthroughOriginalCallerId: Scalars['Boolean']['output'];
  pauseSeconds: Scalars['UInt']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface ExtensionExternalForwardConnection {
  /** Information to aid in pagination. */
  edges: Array<ExtensionExternalForwardModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<ExtensionExternalForward>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface ExtensionExternalForwardInput {
  dtmf?: InputMaybe<Scalars['String']['input']>;
  extensionExternalForwardId?: InputMaybe<Scalars['UInt']['input']>;
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  forwardToNumber?: InputMaybe<Scalars['String']['input']>;
  isDtmf?: InputMaybe<Scalars['Boolean']['input']>;
  isPassthroughOriginalCallerId?: InputMaybe<Scalars['Boolean']['input']>;
  pauseSeconds?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface ExtensionExternalForwardModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ExtensionExternalForward;
}

export interface ExtensionFax {
  createDate: Scalars['UtcDateTime']['output'];
  createUserId: Maybe<Scalars['Int']['output']>;
  defaultPhoneNumber: Maybe<PhoneNumber>;
  defaultPhoneNumberId: Maybe<Scalars['UInt']['output']>;
  emailAddress: Maybe<Scalars['String']['output']>;
  extension: Extension;
  extensionFaxId: Scalars['UInt']['output'];
  extensionId: Scalars['UInt']['output'];
  faxEmailAddressesConnection: FaxEmailAddressConnection;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}


export interface ExtensionFaxFaxEmailAddressesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface ExtensionFaxConnection {
  /** Information to aid in pagination. */
  edges: Array<ExtensionFaxModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<ExtensionFax>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface ExtensionFaxInput {
  defaultPhoneNumberId?: InputMaybe<Scalars['UInt']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  extensionFaxId?: InputMaybe<Scalars['UInt']['input']>;
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  faxEmailAddresses?: InputMaybe<Array<FaxEmailAddressInput>>;
  fields: Array<Scalars['String']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface ExtensionFaxModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ExtensionFax;
}

export interface ExtensionFmFm {
  defaultPhoneNumber: Maybe<PhoneNumber>;
  defaultPhoneNumberId: Maybe<Scalars['UInt']['output']>;
  extension: Extension;
  extensionFmFmId: Scalars['UInt']['output'];
  extensionId: Scalars['UInt']['output'];
  finalDestinationExtension: Maybe<Extension>;
  finalDestinationExtensionId: Maybe<Scalars['UInt']['output']>;
  finalDestinationPhoneNumber: Maybe<Scalars['String']['output']>;
  fmFmStepsConnection: FmFmStepConnection;
  isFinalDestinationVoicemail: Scalars['Boolean']['output'];
  isGreetingDisabled: Scalars['Boolean']['output'];
  isIgnoreForward: Scalars['Boolean']['output'];
  isSendOriginalCallerId: Scalars['Boolean']['output'];
}


export interface ExtensionFmFmFmFmStepsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface ExtensionFmFmConnection {
  /** Information to aid in pagination. */
  edges: Array<ExtensionFmFmModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<ExtensionFmFm>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface ExtensionFmFmInput {
  defaultPhoneNumber?: InputMaybe<PhoneNumberInput>;
  defaultPhoneNumberId?: InputMaybe<Scalars['UInt']['input']>;
  extension?: InputMaybe<ExtensionInput>;
  extensionFmFmId?: InputMaybe<Scalars['UInt']['input']>;
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  finalDestinationExtension?: InputMaybe<ExtensionInput>;
  finalDestinationExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  finalDestinationPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  fmFmSteps?: InputMaybe<Array<FmFmStepInput>>;
  isFinalDestinationVoicemail?: InputMaybe<Scalars['Boolean']['input']>;
  isGreetingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isIgnoreForward?: InputMaybe<Scalars['Boolean']['input']>;
  isSendOriginalCallerId?: InputMaybe<Scalars['Boolean']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface ExtensionFmFmModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ExtensionFmFm;
}

export interface ExtensionGroup {
  account: Account;
  accountId: Scalars['UInt']['output'];
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  description: Maybe<Scalars['String']['output']>;
  extensionGroupCount: Scalars['UInt']['output'];
  extensionGroupExtensionsConnection: ExtensionGroupExtensionConnection;
  extensionGroupId: Scalars['UInt']['output'];
  name: Maybe<Scalars['String']['output']>;
  queueExtensionGroupsConnection: QueueExtensionGroupConnection;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}


export interface ExtensionGroupExtensionGroupExtensionsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface ExtensionGroupQueueExtensionGroupsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface ExtensionGroupConnection {
  /** Information to aid in pagination. */
  edges: Array<ExtensionGroupModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<ExtensionGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface ExtensionGroupExtension {
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  extension: Extension;
  extensionGroup: ExtensionGroup;
  extensionGroupExtensionId: Scalars['UInt']['output'];
  extensionGroupId: Scalars['UInt']['output'];
  extensionId: Scalars['UInt']['output'];
  forwardPhoneNumber: Maybe<Scalars['String']['output']>;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface ExtensionGroupExtensionConnection {
  /** Information to aid in pagination. */
  edges: Array<ExtensionGroupExtensionModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<ExtensionGroupExtension>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface ExtensionGroupExtensionInput {
  extensionGroupExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  extensionGroupId?: InputMaybe<Scalars['UInt']['input']>;
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  forwardPhoneNumber?: InputMaybe<Scalars['String']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface ExtensionGroupExtensionModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ExtensionGroupExtension;
}

export interface ExtensionGroupInput {
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extensionGroupExtensions?: InputMaybe<Array<ExtensionGroupExtensionInput>>;
  extensionGroupId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  queueExtensionGroups?: InputMaybe<Array<QueueExtensionGroupInput>>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface ExtensionGroupModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ExtensionGroup;
}

export interface ExtensionGroupSupervisee {
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  extensionGroupSuperviseeId: Scalars['UInt']['output'];
  superviseeExtensionGroup: ExtensionGroup;
  superviseeExtensionGroupId: Scalars['UInt']['output'];
  supervisorExtension: Extension;
  supervisorExtensionId: Scalars['UInt']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface ExtensionGroupSuperviseeConnection {
  /** Information to aid in pagination. */
  edges: Array<ExtensionGroupSuperviseeModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<ExtensionGroupSupervisee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface ExtensionGroupSuperviseeInput {
  extensionGroupSuperviseeId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  superviseeExtensionGroupId?: InputMaybe<Scalars['UInt']['input']>;
  supervisorExtensionId?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface ExtensionGroupSuperviseeModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ExtensionGroupSupervisee;
}

export interface ExtensionHuntGroup {
  callerIdOverride: Scalars['Boolean']['output'];
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  displayName: Maybe<Scalars['String']['output']>;
  extension: Extension;
  extensionGroupHuntGroupMembersConnection: HuntGroupExtensionGroupConnection;
  extensionHuntGroupId: Scalars['UInt']['output'];
  extensionId: Scalars['UInt']['output'];
  huntGroupExtensionGroupsConnection: HuntGroupExtensionGroupConnection;
  huntGroupMembersConnection: HuntGroupMemberConnection;
  isRouteBusyVoicemailOnly: Scalars['Boolean']['output'];
  isRouteNoAnswerVoicemailOnly: Scalars['Boolean']['output'];
  ringTimeout: Maybe<Scalars['Int']['output']>;
  routeBusyExtension: Maybe<Extension>;
  routeBusyExtensionId: Maybe<Scalars['UInt']['output']>;
  routeBusyNullAction: NullActionTypes;
  routeNoAnswerExtension: Maybe<Extension>;
  routeNoAnswerExtensionId: Maybe<Scalars['UInt']['output']>;
  routeNoAnswerNullAction: NullActionTypes;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}


export interface ExtensionHuntGroupExtensionGroupHuntGroupMembersConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface ExtensionHuntGroupHuntGroupExtensionGroupsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface ExtensionHuntGroupHuntGroupMembersConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface ExtensionHuntGroupConnection {
  /** Information to aid in pagination. */
  edges: Array<ExtensionHuntGroupModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<ExtensionHuntGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface ExtensionHuntGroupInput {
  callerIdOverride?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  extensionGroupHuntGroupMembers?: InputMaybe<Array<HuntGroupExtensionGroupInput>>;
  extensionHuntGroupId?: InputMaybe<Scalars['UInt']['input']>;
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  huntGroupExtensionGroups?: InputMaybe<Array<HuntGroupExtensionGroupInput>>;
  huntGroupMembers?: InputMaybe<Array<HuntGroupMemberInput>>;
  isRouteBusyVoicemailOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isRouteNoAnswerVoicemailOnly?: InputMaybe<Scalars['Boolean']['input']>;
  ringTimeout?: InputMaybe<Scalars['Int']['input']>;
  routeBusyExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  routeBusyNullAction?: InputMaybe<NullActionTypes>;
  routeNoAnswerExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  routeNoAnswerNullAction?: InputMaybe<NullActionTypes>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface ExtensionHuntGroupModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ExtensionHuntGroup;
}

export interface ExtensionInput {
  account?: InputMaybe<AccountInput>;
  accountHoldMusicFileId?: InputMaybe<Scalars['UInt']['input']>;
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  accountOperatorExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  accountTimeZoneId?: InputMaybe<TimeZones>;
  adminNote?: InputMaybe<NoteInput>;
  departmentExtensions?: InputMaybe<Array<DepartmentExtensionInput>>;
  departmentName?: InputMaybe<Scalars['String']['input']>;
  extensionAutoAttendant?: InputMaybe<ExtensionAutoAttendantInput>;
  extensionExternalForward?: InputMaybe<ExtensionExternalForwardInput>;
  extensionFax?: InputMaybe<ExtensionFaxInput>;
  extensionFmFm?: InputMaybe<ExtensionFmFmInput>;
  extensionHuntGroup?: InputMaybe<ExtensionHuntGroupInput>;
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  extensionMailbox?: InputMaybe<ExtensionMailboxInput>;
  extensionNote?: InputMaybe<NoteInput>;
  extensionPagingGroup?: InputMaybe<ExtensionPagingGroupInput>;
  extensionPhone?: InputMaybe<ExtensionPhoneInput>;
  extensionQueue?: InputMaybe<ExtensionQueueInput>;
  extensionQueueHoldMusicFileId?: InputMaybe<Scalars['UInt']['input']>;
  extensionType?: InputMaybe<ExtensionTypeInput>;
  faxEmailAddresses?: InputMaybe<Array<FaxEmailAddressInput>>;
  fields: Array<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<LocationInput>;
  locationId?: InputMaybe<Scalars['UInt']['input']>;
  locationTimeZoneId?: InputMaybe<TimeZones>;
  mailbox?: InputMaybe<MailboxInput>;
  mailboxId?: InputMaybe<Scalars['UInt']['input']>;
  mailboxOperatorExtension?: InputMaybe<ExtensionInput>;
  mailboxOperatorExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['UInt']['input']>;
  phones?: InputMaybe<Array<PhoneInput>>;
  queueExtensionStatus?: InputMaybe<QueueExtensionStatusInput>;
  queuesAsAgent?: InputMaybe<Array<QueueMemberInput>>;
  rm12Client?: InputMaybe<Rm12ClientInput>;
  rm12ClientToken?: InputMaybe<Rm12ClientTokenInput>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  timeBasedRoutes?: InputMaybe<Array<TimeBasedRouteInput>>;
  timeZoneId?: InputMaybe<TimeZones>;
  type?: InputMaybe<ExtensionTypes>;
  users?: InputMaybe<Array<UserInput>>;
}

export interface ExtensionMailbox {
  customerNotes: Maybe<Scalars['String']['output']>;
  extension: Extension;
  extensionId: Scalars['UInt']['output'];
  extensionMailboxId: Scalars['UInt']['output'];
  notes: Maybe<Scalars['String']['output']>;
  timeZoneId: Maybe<TimeZones>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface ExtensionMailboxConnection {
  /** Information to aid in pagination. */
  edges: Array<ExtensionMailboxModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<ExtensionMailbox>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface ExtensionMailboxInput {
  customerNotes?: InputMaybe<Scalars['String']['input']>;
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  extensionMailboxId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  timeZoneId?: InputMaybe<TimeZones>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface ExtensionMailboxModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ExtensionMailbox;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface ExtensionModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Extension;
}

export interface ExtensionPagingGroup {
  extensionId: Scalars['UInt']['output'];
  extensionPagingGroupExtension: Maybe<Extension>;
  extensionPagingGroupId: Scalars['UInt']['output'];
  pagingGroupExtensionGroupsConnection: PagingGroupExtensionGroupConnection;
  pagingGroupMembersConnection: PagingGroupMemberConnection;
}


export interface ExtensionPagingGroupPagingGroupExtensionGroupsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface ExtensionPagingGroupPagingGroupMembersConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface ExtensionPagingGroupConnection {
  /** Information to aid in pagination. */
  edges: Array<ExtensionPagingGroupModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<ExtensionPagingGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface ExtensionPagingGroupInput {
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  extensionPagingGroupExtension?: InputMaybe<ExtensionInput>;
  extensionPagingGroupId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  pagingGroupExtensionGroups?: InputMaybe<Array<PagingGroupExtensionGroupInput>>;
  pagingGroupMembers?: InputMaybe<Array<PagingGroupMemberInput>>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface ExtensionPagingGroupModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ExtensionPagingGroup;
}

export interface ExtensionPhone {
  autoAnswerPhone: Maybe<Phone>;
  autoAnswerPhoneId: Maybe<Scalars['UInt']['output']>;
  callDetail: Maybe<ActiveCall>;
  callDetailId: Maybe<Scalars['UInt']['output']>;
  defaultAreaCode: Maybe<Scalars['UInt']['output']>;
  defaultPhoneNumber: Maybe<PhoneNumber>;
  defaultPhoneNumberId: Maybe<Scalars['UInt']['output']>;
  displayName: Maybe<Scalars['String']['output']>;
  dndStatus: Maybe<Scalars['String']['output']>;
  dtmfToPlay: Maybe<Scalars['String']['output']>;
  enableDtmf: Scalars['Boolean']['output'];
  extension: Extension;
  extensionGroupSuperviseesConnection: ExtensionGroupSuperviseeConnection;
  extensionId: Scalars['UInt']['output'];
  extensionPhoneId: Scalars['UInt']['output'];
  extensionSuperviseesConnection: ExtensionSuperviseeConnection;
  forwardExtension: Maybe<Extension>;
  forwardExtensionId: Maybe<Scalars['UInt']['output']>;
  forwardExternalNumber: Maybe<Scalars['String']['output']>;
  isAutoAnswer: Scalars['Boolean']['output'];
  isAutoAnswerEnabled: Scalars['Boolean']['output'];
  isLoggedIntoQueues: Scalars['Boolean']['output'];
  isOtrEnabled: Scalars['Boolean']['output'];
  isRingAllPhones: Scalars['Boolean']['output'];
  office: Maybe<Scalars['String']['output']>;
  onCall: Scalars['Boolean']['output'];
  phonesConnection: PhoneConnection;
  ringTimeout: Scalars['UInt']['output'];
  routeBusyExtension: Maybe<Extension>;
  routeBusyExtensionId: Maybe<Scalars['UInt']['output']>;
  routeBusyNullAction: NullActionTypes;
  routeNoAnswerExtension: Maybe<Extension>;
  routeNoAnswerExtensionId: Maybe<Scalars['UInt']['output']>;
  routeNoAnswerNullAction: NullActionTypes;
  secondsToWait: Maybe<Scalars['UInt']['output']>;
}


export interface ExtensionPhoneExtensionGroupSuperviseesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface ExtensionPhoneExtensionSuperviseesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface ExtensionPhonePhonesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface ExtensionPhoneConnection {
  /** Information to aid in pagination. */
  edges: Array<ExtensionPhoneModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<ExtensionPhone>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface ExtensionPhoneInput {
  autoAnswerPhone?: InputMaybe<PhoneInput>;
  autoAnswerPhoneId?: InputMaybe<Scalars['UInt']['input']>;
  callDetailId?: InputMaybe<Scalars['UInt']['input']>;
  defaultAreaCode?: InputMaybe<Scalars['UInt']['input']>;
  defaultPhoneNumberId?: InputMaybe<Scalars['UInt']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  dndStatus?: InputMaybe<Scalars['String']['input']>;
  dtmfToPlay?: InputMaybe<Scalars['String']['input']>;
  enableDtmf?: InputMaybe<Scalars['Boolean']['input']>;
  extensionGroupSupervisees?: InputMaybe<Array<ExtensionGroupSuperviseeInput>>;
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  extensionPhoneId?: InputMaybe<Scalars['UInt']['input']>;
  extensionSupervisees?: InputMaybe<Array<ExtensionSuperviseeInput>>;
  fields: Array<Scalars['String']['input']>;
  forwardExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  forwardExternalNumber?: InputMaybe<Scalars['String']['input']>;
  isAutoAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoAnswerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isLoggedIntoQueues?: InputMaybe<Scalars['Boolean']['input']>;
  isOtrEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isRingAllPhones?: InputMaybe<Scalars['Boolean']['input']>;
  office?: InputMaybe<Scalars['String']['input']>;
  phones?: InputMaybe<Array<PhoneInput>>;
  ringTimeout?: InputMaybe<Scalars['UInt']['input']>;
  routeBusyExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  routeBusyNullAction?: InputMaybe<NullActionTypes>;
  routeNoAnswerExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  routeNoAnswerNullAction?: InputMaybe<NullActionTypes>;
  secondsToWait?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface ExtensionPhoneModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ExtensionPhone;
}

export interface ExtensionQueue {
  announcementFrequency: Maybe<Scalars['UInt']['output']>;
  callBackType: Maybe<CallBackTypes>;
  callbackAttempts: Scalars['UInt']['output'];
  callbackPrompt: Maybe<Prompt>;
  callersNeededForCallback: Scalars['UInt']['output'];
  customCallbackPromptId: Maybe<Scalars['UInt']['output']>;
  exitRouteTo: Maybe<Scalars['UInt']['output']>;
  exitRouteToExtension: Maybe<Extension>;
  exitRouteVoicemailOnly: Scalars['Boolean']['output'];
  extension: Extension;
  extensionId: Scalars['UInt']['output'];
  extensionQueueId: Scalars['UInt']['output'];
  hasPreventEmptyQueue: Scalars['Boolean']['output'];
  holdMusicPrompt: Maybe<Prompt>;
  holdMusicPromptId: Maybe<Scalars['UInt']['output']>;
  holdTimeNeededForCallback: Maybe<Scalars['UInt']['output']>;
  isAnnounceCallback: Scalars['Boolean']['output'];
  isAnnounceQueueCount: Scalars['Boolean']['output'];
  isAnnounceWaitTime: Scalars['Boolean']['output'];
  isCallBackAvailable: Scalars['Boolean']['output'];
  lastConnectedMember: Maybe<QueueMember>;
  lastConnectedMemberId: Maybe<Scalars['UInt']['output']>;
  periodicAnnouncementFrequency: Maybe<Scalars['UInt']['output']>;
  queueEmptyExitNullAction: NullActionTypes;
  queueEmptyExitRouteTo: Maybe<Scalars['UInt']['output']>;
  queueEmptyExitRouteToExtension: Maybe<Extension>;
  queueExtensionGroupMembersConnection: QueueExtensionGroupConnection;
  queueMembersConnection: QueueMemberConnection;
  queuePeriodicAnnouncementsConnection: QueuePeriodicAnnouncementConnection;
  queueStrategyId: Maybe<QueueStrategies>;
  wrapUpTime: Scalars['UInt']['output'];
}


export interface ExtensionQueueQueueExtensionGroupMembersConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface ExtensionQueueQueueMembersConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface ExtensionQueueQueuePeriodicAnnouncementsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface ExtensionQueueConnection {
  /** Information to aid in pagination. */
  edges: Array<ExtensionQueueModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<ExtensionQueue>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface ExtensionQueueInput {
  announcementFrequency?: InputMaybe<Scalars['UInt']['input']>;
  callBackType?: InputMaybe<CallBackTypes>;
  callbackAttempts?: InputMaybe<Scalars['UInt']['input']>;
  callbackPrompt?: InputMaybe<PromptInput>;
  callersNeededForCallback?: InputMaybe<Scalars['UInt']['input']>;
  customCallbackPromptId?: InputMaybe<Scalars['UInt']['input']>;
  exitRouteTo?: InputMaybe<Scalars['UInt']['input']>;
  exitRouteToExtension?: InputMaybe<ExtensionInput>;
  exitRouteVoicemailOnly?: InputMaybe<Scalars['Boolean']['input']>;
  extension?: InputMaybe<ExtensionInput>;
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  extensionQueueId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  hasPreventEmptyQueue?: InputMaybe<Scalars['Boolean']['input']>;
  holdMusicPrompt?: InputMaybe<PromptInput>;
  holdMusicPromptId?: InputMaybe<Scalars['UInt']['input']>;
  holdTimeNeededForCallback?: InputMaybe<Scalars['UInt']['input']>;
  isAnnounceCallback?: InputMaybe<Scalars['Boolean']['input']>;
  isAnnounceQueueCount?: InputMaybe<Scalars['Boolean']['input']>;
  isAnnounceWaitTime?: InputMaybe<Scalars['Boolean']['input']>;
  isCallBackAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  lastConnectedMember?: InputMaybe<QueueMemberInput>;
  lastConnectedMemberId?: InputMaybe<Scalars['UInt']['input']>;
  periodicAnnouncementFrequency?: InputMaybe<Scalars['UInt']['input']>;
  queueEmptyExitNullAction?: InputMaybe<NullActionTypes>;
  queueEmptyExitRouteTo?: InputMaybe<Scalars['UInt']['input']>;
  queueEmptyExitRouteToExtension?: InputMaybe<ExtensionInput>;
  queueExtensionGroupMembers?: InputMaybe<Array<QueueExtensionGroupInput>>;
  queueMembers?: InputMaybe<Array<QueueMemberInput>>;
  queuePeriodicAnnouncements?: InputMaybe<Array<QueuePeriodicAnnouncementInput>>;
  queueStrategyId?: InputMaybe<QueueStrategies>;
  wrapUpTime?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface ExtensionQueueModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ExtensionQueue;
}

export interface ExtensionSupervisee {
  extensionSuperviseeId: Scalars['UInt']['output'];
  superviseeExtension: Extension;
  superviseeExtensionId: Scalars['UInt']['output'];
  supervisorExtension: Extension;
  supervisorExtensionId: Scalars['UInt']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface ExtensionSuperviseeConnection {
  /** Information to aid in pagination. */
  edges: Array<ExtensionSuperviseeModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<ExtensionSupervisee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface ExtensionSuperviseeInput {
  extensionSuperviseeId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  superviseeExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  supervisorExtensionId?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface ExtensionSuperviseeModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ExtensionSupervisee;
}

export interface ExtensionType {
  description: Maybe<Scalars['String']['output']>;
  displayName: Maybe<Scalars['String']['output']>;
  extensionTypeId: ExtensionTypes;
  name: Maybe<Scalars['String']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface ExtensionTypeConnection {
  /** Information to aid in pagination. */
  edges: Array<ExtensionTypeModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<ExtensionType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface ExtensionTypeInput {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  extensionTypeId?: InputMaybe<ExtensionTypes>;
  fields: Array<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface ExtensionTypeModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ExtensionType;
}

export enum ExtensionTypes {
  /** Used for Auto Attendants */
  AutoAttendant = 'AutoAttendant',
  /** Used for Call Queues */
  CallQueue = 'CallQueue',
  /** System Name Directory Extension */
  Directory = 'Directory',
  /** Used for External Forwards */
  ExternalForward = 'ExternalForward',
  /** Used for Faxes */
  Fax = 'Fax',
  /** Used for Find Me Follow Me extensions */
  FindMeFollowMe = 'FindMeFollowMe',
  /** System Hangup Extension */
  Hangup = 'Hangup',
  /** Used for Hunt Groups */
  HuntGroup = 'HuntGroup',
  /** Used for Paging Groups */
  PagingGroup = 'PagingGroup',
  /** Used for hardphones and softphones */
  Phone = 'Phone',
  /** Used for Smart Voicemails */
  SmartVoicemail = 'SmartVoicemail',
  /** Used for VM-only extensions */
  VoiceMailbox = 'VoiceMailbox'
}

export interface ExternalNumberHistory {
  account: Account;
  accountId: Scalars['UInt']['output'];
  externalNumber: Maybe<Scalars['String']['output']>;
  externalNumberHistoryId: Scalars['UInt']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface ExternalNumberHistoryConnection {
  /** Information to aid in pagination. */
  edges: Array<ExternalNumberHistoryModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<ExternalNumberHistory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface ExternalNumberHistoryInput {
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  externalNumber?: InputMaybe<Scalars['String']['input']>;
  externalNumberHistoryId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface ExternalNumberHistoryModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ExternalNumberHistory;
}

export interface Fax {
  attachmentsConnection: FaxAttachmentConnection;
  createDate: Scalars['UtcDateTime']['output'];
  createUserId: Maybe<Scalars['Int']['output']>;
  exceptionMessage: Maybe<Scalars['String']['output']>;
  extension: Extension;
  extensionId: Scalars['UInt']['output'];
  faxId: Scalars['UInt']['output'];
  faxStatusId: FaxStatuses;
  faxStatusName: Maybe<Scalars['String']['output']>;
  faxTypeId: FaxTypes;
  from: Maybe<Scalars['String']['output']>;
  processedTime: Maybe<Scalars['UtcDateTime']['output']>;
  retries: Scalars['Int']['output'];
  to: Maybe<Scalars['String']['output']>;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}


export interface FaxAttachmentsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

export interface FaxAttachment {
  exceptionMessage: Maybe<Scalars['String']['output']>;
  fax: Fax;
  faxAttachmentId: Scalars['UInt']['output'];
  faxId: Scalars['UInt']['output'];
  faxStatusId: FaxStatuses;
  file: Maybe<File>;
  fileId: Maybe<Scalars['UInt']['output']>;
  processedTime: Maybe<Scalars['UtcDateTime']['output']>;
  retries: Scalars['Int']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface FaxAttachmentConnection {
  /** Information to aid in pagination. */
  edges: Array<FaxAttachmentModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<FaxAttachment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface FaxAttachmentInput {
  exceptionMessage?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<FaxInput>;
  faxAttachmentId?: InputMaybe<Scalars['UInt']['input']>;
  faxId?: InputMaybe<Scalars['UInt']['input']>;
  faxStatusId?: InputMaybe<FaxStatuses>;
  fields: Array<Scalars['String']['input']>;
  file?: InputMaybe<FileInput>;
  fileId?: InputMaybe<Scalars['UInt']['input']>;
  processedTime?: InputMaybe<Scalars['DateTime']['input']>;
  retries?: InputMaybe<Scalars['Int']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface FaxAttachmentModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: FaxAttachment;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface FaxConnection {
  /** Information to aid in pagination. */
  edges: Array<FaxModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Fax>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface FaxEmailAddress {
  centralId: Maybe<Scalars['UInt']['output']>;
  createDate: Scalars['UtcDateTime']['output'];
  createUserId: Maybe<Scalars['Int']['output']>;
  emailAddress: Maybe<Scalars['String']['output']>;
  extension: Extension;
  extensionId: Scalars['UInt']['output'];
  faxEmailAddressId: Scalars['UInt']['output'];
  isDomainOnly: Scalars['Boolean']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface FaxEmailAddressConnection {
  /** Information to aid in pagination. */
  edges: Array<FaxEmailAddressModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<FaxEmailAddress>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface FaxEmailAddressInput {
  centralId?: InputMaybe<Scalars['UInt']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  faxEmailAddressId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  isDomainOnly?: InputMaybe<Scalars['Boolean']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface FaxEmailAddressModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: FaxEmailAddress;
}

export enum FaxFileTypes {
  /** PDF */
  PDF = 'PDF',
  /** TIFF */
  TIFF = 'TIFF'
}

export interface FaxInput {
  attachments?: InputMaybe<Array<FaxAttachmentInput>>;
  exceptionMessage?: InputMaybe<Scalars['String']['input']>;
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  faxId?: InputMaybe<Scalars['UInt']['input']>;
  faxStatusId?: InputMaybe<FaxStatuses>;
  faxTypeId?: InputMaybe<FaxTypes>;
  fields: Array<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  processedTime?: InputMaybe<Scalars['DateTime']['input']>;
  retries?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface FaxModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Fax;
}

export enum FaxStatuses {
  /** Errored */
  Errored = 'Errored',
  /** Sending/Receiving */
  InProcess = 'InProcess',
  /** Pending */
  Pending = 'Pending',
  /** Successful */
  Successful = 'Successful'
}

export enum FaxTypes {
  /** Received */
  Received = 'Received',
  /** Sent */
  Sent = 'Sent'
}

export interface File {
  account: Account;
  accountId: Scalars['UInt']['output'];
  callRecording: Maybe<CallRecording>;
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  displayName: Maybe<Scalars['String']['output']>;
  dontSaveFile: Maybe<Scalars['Boolean']['output']>;
  faxAttachment: Maybe<FaxAttachment>;
  fileDepot: FileDepot;
  fileDepotId: Scalars['UInt']['output'];
  fileId: Scalars['UInt']['output'];
  fileName: Maybe<Scalars['String']['output']>;
  fileToken: Maybe<Scalars['String']['output']>;
  isCallRecording: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isPromptForAccountMoh: Maybe<Scalars['Boolean']['output']>;
  isPromptForExtensionQueueMoh: Maybe<Scalars['Boolean']['output']>;
  mailboxMessage: Maybe<MailboxMessage>;
  metaTag: Maybe<Scalars['String']['output']>;
  orphanDate: Maybe<Scalars['UtcDateTime']['output']>;
  path: Maybe<Scalars['String']['output']>;
  prompt: Maybe<Prompt>;
  promptType: Maybe<PromptTypes>;
  size: Scalars['UInt']['output'];
  type: Maybe<Scalars['String']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface FileConnection {
  /** Information to aid in pagination. */
  edges: Array<FileModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<File>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface FileDepot {
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  fileDepotId: Scalars['UInt']['output'];
  name: Maybe<Scalars['String']['output']>;
  path: Maybe<Scalars['String']['output']>;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface FileDepotConnection {
  /** Information to aid in pagination. */
  edges: Array<FileDepotModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<FileDepot>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface FileDepotInput {
  fields: Array<Scalars['String']['input']>;
  fileDepotId?: InputMaybe<Scalars['UInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface FileDepotModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: FileDepot;
}

export interface FileInput {
  account?: InputMaybe<AccountInput>;
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  dontSaveFile?: InputMaybe<Scalars['Boolean']['input']>;
  fields: Array<Scalars['String']['input']>;
  fileDepot?: InputMaybe<FileDepotInput>;
  fileDepotId?: InputMaybe<Scalars['UInt']['input']>;
  fileId?: InputMaybe<Scalars['UInt']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  isCallRecording?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isPromptForAccountMoh?: InputMaybe<Scalars['Boolean']['input']>;
  isPromptForExtensionQueueMoh?: InputMaybe<Scalars['Boolean']['input']>;
  metaTag?: InputMaybe<Scalars['String']['input']>;
  orphanDate?: InputMaybe<Scalars['DateTime']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  promptType?: InputMaybe<PromptTypes>;
  size?: InputMaybe<Scalars['UInt']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface FileModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: File;
}

export interface FmFmStep {
  createDate: Maybe<Scalars['UtcDateTime']['output']>;
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  extensionFmFm: ExtensionFmFm;
  extensionFmFmId: Scalars['UInt']['output'];
  fmFmStepExtensionsConnection: FmFmStepExtensionConnection;
  fmFmStepId: Scalars['UInt']['output'];
  fmFmStepPhoneNumbersConnection: FmFmStepPhoneNumberConnection;
  sequence: Scalars['UInt']['output'];
  timeout: Scalars['UInt']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}


export interface FmFmStepFmFmStepExtensionsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface FmFmStepFmFmStepPhoneNumbersConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface FmFmStepConnection {
  /** Information to aid in pagination. */
  edges: Array<FmFmStepModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<FmFmStep>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface FmFmStepExtension {
  createDate: Maybe<Scalars['UtcDateTime']['output']>;
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  extension: Extension;
  extensionId: Scalars['UInt']['output'];
  fmFmStepExtensionId: Scalars['UInt']['output'];
  fmFmStepId: Scalars['UInt']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface FmFmStepExtensionConnection {
  /** Information to aid in pagination. */
  edges: Array<FmFmStepExtensionModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<FmFmStepExtension>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface FmFmStepExtensionInput {
  extension?: InputMaybe<ExtensionInput>;
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  fmFmStepExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  fmFmStepId?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface FmFmStepExtensionModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: FmFmStepExtension;
}

export interface FmFmStepInput {
  extensionFmFm?: InputMaybe<ExtensionFmFmInput>;
  extensionFmFmId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  fmFmStepExtensions?: InputMaybe<Array<FmFmStepExtensionInput>>;
  fmFmStepId?: InputMaybe<Scalars['UInt']['input']>;
  fmFmStepPhoneNumbers?: InputMaybe<Array<FmFmStepPhoneNumberInput>>;
  sequence?: InputMaybe<Scalars['UInt']['input']>;
  timeout?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface FmFmStepModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: FmFmStep;
}

export interface FmFmStepPhoneNumber {
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  fmFmStep: FmFmStep;
  fmFmStepId: Scalars['UInt']['output'];
  fmFmStepPhoneNumberId: Scalars['UInt']['output'];
  phoneNumber: Maybe<Scalars['String']['output']>;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface FmFmStepPhoneNumberConnection {
  /** Information to aid in pagination. */
  edges: Array<FmFmStepPhoneNumberModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<FmFmStepPhoneNumber>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface FmFmStepPhoneNumberInput {
  fields: Array<Scalars['String']['input']>;
  fmFmStepId?: InputMaybe<Scalars['UInt']['input']>;
  fmFmStepPhoneNumberId?: InputMaybe<Scalars['UInt']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface FmFmStepPhoneNumberModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: FmFmStepPhoneNumber;
}

export interface GetOption {
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  dateTimeValue?: InputMaybe<Scalars['DateTime']['input']>;
  option: Scalars['String']['input'];
}

export enum HttpRequestMethods {
  /** DELETE */
  DELETE = 'DELETE',
  /** GET */
  GET = 'GET',
  /** PATCH */
  PATCH = 'PATCH',
  /** POST */
  POST = 'POST',
  /** PUT */
  PUT = 'PUT'
}

export interface HuntGroupExtensionGroup {
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  extensionGroup: ExtensionGroup;
  extensionGroupExtensionsConnection: ExtensionGroupExtensionConnection;
  extensionGroupId: Scalars['UInt']['output'];
  huntGroupExtension: ExtensionHuntGroup;
  huntGroupExtensionGroupId: Scalars['UInt']['output'];
  huntGroupExtensionId: Scalars['UInt']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}


export interface HuntGroupExtensionGroupExtensionGroupExtensionsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface HuntGroupExtensionGroupConnection {
  /** Information to aid in pagination. */
  edges: Array<HuntGroupExtensionGroupModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<HuntGroupExtensionGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface HuntGroupExtensionGroupInput {
  extensionGroupId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  huntGroupExtensionGroupId?: InputMaybe<Scalars['UInt']['input']>;
  huntGroupExtensionId?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface HuntGroupExtensionGroupModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: HuntGroupExtensionGroup;
}

export interface HuntGroupMember {
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  extension: Extension;
  extensionHuntGroup: ExtensionHuntGroup;
  extensionHuntGroupId: Scalars['UInt']['output'];
  extensionId: Scalars['UInt']['output'];
  huntGroupMemberId: Scalars['UInt']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface HuntGroupMemberConnection {
  /** Information to aid in pagination. */
  edges: Array<HuntGroupMemberModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<HuntGroupMember>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface HuntGroupMemberInput {
  extensionHuntGroupId?: InputMaybe<Scalars['UInt']['input']>;
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  huntGroupMemberId?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface HuntGroupMemberModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: HuntGroupMember;
}

/** An edge in a connection from an object to another object of type `Int`. */
export interface IntEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Scalars['Int']['output'];
}

/** A connection from an object to a list of objects of type `Int`. */
export interface IntGraphTypeConnection {
  /** Information to aid in pagination. */
  edges: Array<IntEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Scalars['Int']['output']>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface Location {
  account: Account;
  accountId: Scalars['UInt']['output'];
  accountTimeZoneId: TimeZones;
  address: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  directionalPostfix: Maybe<Scalars['String']['output']>;
  directionalPrefix: Maybe<Scalars['String']['output']>;
  displayTimeZone: TimeZones;
  houseNumber: Maybe<Scalars['String']['output']>;
  isE911Validated: Scalars['Boolean']['output'];
  locationId: Scalars['UInt']['output'];
  mostRecentE911ValidationResponse: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  phoneNumbersConnection: PhoneNumberConnection;
  postalCode: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  streetName: Maybe<Scalars['String']['output']>;
  streetNameSuffix: Maybe<Scalars['String']['output']>;
  timeZoneId: Maybe<TimeZones>;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}


export interface LocationPhoneNumbersConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface LocationConnection {
  /** Information to aid in pagination. */
  edges: Array<LocationModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Location>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface LocationInput {
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  accountTimeZoneId?: InputMaybe<TimeZones>;
  city?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  directionalPostfix?: InputMaybe<Scalars['String']['input']>;
  directionalPrefix?: InputMaybe<Scalars['String']['input']>;
  fields: Array<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  isE911Validated?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['UInt']['input']>;
  mostRecentE911ValidationResponse?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
  streetNameSuffix?: InputMaybe<Scalars['String']['input']>;
  timeZoneId?: InputMaybe<TimeZones>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface LocationModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Location;
}

export enum LogCodes {
  /** ARI Connection */
  ARIConnection = 'ARIConnection',
  /** Hung Up Call */
  HungUpCall = 'HungUpCall',
  /** Line Limit Exceeded */
  LineLimitExceeded = 'LineLimitExceeded'
}

export enum LogLevels {
  /** Critical/Fatal */
  Critical = 'Critical',
  /** Debug */
  Debug = 'Debug',
  /** Error */
  Error = 'Error',
  /** Info */
  Info = 'Info',
  /** Verbose/Trace */
  Verbose = 'Verbose',
  /** Warning */
  Warning = 'Warning'
}

export interface Mailbox {
  busyPrompt: Maybe<Prompt>;
  busyPromptId: Maybe<Scalars['UInt']['output']>;
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  discardAudioAfterEmail: Scalars['Boolean']['output'];
  emailAddress: Maybe<Scalars['String']['output']>;
  extension: Maybe<Extension>;
  firstNameInDigits: Maybe<Scalars['String']['output']>;
  isInNameDirectory: Scalars['Boolean']['output'];
  lastNameInDigits: Maybe<Scalars['String']['output']>;
  mailboxId: Scalars['UInt']['output'];
  mailboxMessagesConnection: MailboxMessageConnection;
  mailboxOperatorExtension: Maybe<Extension>;
  markReadAfterEmail: Scalars['Boolean']['output'];
  namePrompt: Maybe<Prompt>;
  namePromptId: Maybe<Scalars['UInt']['output']>;
  operatorExtensionId: Maybe<Scalars['UInt']['output']>;
  password: Maybe<Scalars['String']['output']>;
  sayCallerId: Scalars['Boolean']['output'];
  temporaryUnavailablePrompt: Maybe<Prompt>;
  temporaryUnavailablePromptId: Maybe<Scalars['UInt']['output']>;
  unavailablePrompt: Maybe<Prompt>;
  unavailablePromptId2: Maybe<Scalars['UInt']['output']>;
  unreadMailboxMessageCount: Scalars['UInt']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}


export interface MailboxMailboxMessagesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface MailboxConnection {
  /** Information to aid in pagination. */
  edges: Array<MailboxModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Mailbox>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export enum MailboxFolders {
  /** Family */
  Family = 'Family',
  /** Friends */
  Friends = 'Friends',
  /** Inbox */
  Inbox = 'Inbox',
  /** Old */
  Old = 'Old',
  /** Work */
  Work = 'Work'
}

export interface MailboxInput {
  busyPromptId?: InputMaybe<Scalars['UInt']['input']>;
  discardAudioAfterEmail?: InputMaybe<Scalars['Boolean']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  fields: Array<Scalars['String']['input']>;
  firstNameInDigits?: InputMaybe<Scalars['String']['input']>;
  isInNameDirectory?: InputMaybe<Scalars['Boolean']['input']>;
  lastNameInDigits?: InputMaybe<Scalars['String']['input']>;
  mailboxId?: InputMaybe<Scalars['UInt']['input']>;
  mailboxMessages?: InputMaybe<Array<MailboxMessageInput>>;
  mailboxOperatorExtension?: InputMaybe<ExtensionInput>;
  markReadAfterEmail?: InputMaybe<Scalars['Boolean']['input']>;
  namePromptId?: InputMaybe<Scalars['UInt']['input']>;
  operatorExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  sayCallerId?: InputMaybe<Scalars['Boolean']['input']>;
  temporaryUnavailablePromptId?: InputMaybe<Scalars['UInt']['input']>;
  unavailablePromptId2?: InputMaybe<Scalars['UInt']['input']>;
}

export interface MailboxMessage {
  callRecordingId: Maybe<Scalars['UInt']['output']>;
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  file: Maybe<File>;
  fileId: Maybe<Scalars['UInt']['output']>;
  isArchived: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  mailbox: Mailbox;
  mailboxFolderId: MailboxFolders;
  mailboxId: Scalars['UInt']['output'];
  mailboxMessageId: Scalars['UInt']['output'];
  sender: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['UtcDateTime']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface MailboxMessageConnection {
  /** Information to aid in pagination. */
  edges: Array<MailboxMessageModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<MailboxMessage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface MailboxMessageInput {
  callRecordingId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  file?: InputMaybe<FileInput>;
  fileId?: InputMaybe<Scalars['UInt']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  mailboxFolderId?: InputMaybe<MailboxFolders>;
  mailboxId?: InputMaybe<Scalars['UInt']['input']>;
  mailboxMessageId?: InputMaybe<Scalars['UInt']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface MailboxMessageModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: MailboxMessage;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface MailboxModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Mailbox;
}

export interface MailboxPostInput {
  busyPromptId?: InputMaybe<Scalars['UInt']['input']>;
  discardAudioAfterEmail?: InputMaybe<Scalars['Boolean']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  fields: Array<Scalars['String']['input']>;
  isInNameDirectory?: InputMaybe<Scalars['Boolean']['input']>;
  mailboxId?: InputMaybe<Scalars['UInt']['input']>;
  mailboxMessages?: InputMaybe<Array<MailboxMessageInput>>;
  markReadAfterEmail?: InputMaybe<Scalars['Boolean']['input']>;
  namePromptId?: InputMaybe<Scalars['UInt']['input']>;
  operatorExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  sayCallerId?: InputMaybe<Scalars['Boolean']['input']>;
  temporaryUnavailablePromptId?: InputMaybe<Scalars['UInt']['input']>;
  unavailablePromptId2?: InputMaybe<Scalars['UInt']['input']>;
}

export enum NameDirectoryPreference {
  /** Disabled */
  Disabled = 'Disabled',
  /** First and Last Name */
  FirstAndLastName = 'FirstAndLastName',
  /** First Name Only */
  FirstNameOnly = 'FirstNameOnly',
  /** Last Name Only */
  LastNameOnly = 'LastNameOnly'
}

export interface Note {
  account: Account;
  accountId: Scalars['UInt']['output'];
  createDate: Scalars['UtcDateTime']['output'];
  createUser: User;
  createUserId: Scalars['Int']['output'];
  extension: Maybe<Extension>;
  extensionId: Maybe<Scalars['UInt']['output']>;
  isSystemNote: Scalars['Boolean']['output'];
  noteId: Scalars['UInt']['output'];
  notes: Maybe<Scalars['String']['output']>;
  updateDate: Scalars['UtcDateTime']['output'];
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface NoteConnection {
  /** Information to aid in pagination. */
  edges: Array<NoteModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Note>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface NoteInput {
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  isSystemNote?: InputMaybe<Scalars['Boolean']['input']>;
  noteId?: InputMaybe<Scalars['UInt']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface NoteModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Note;
}

export enum NullActionTypes {
  /** Directory */
  Directory = 'Directory',
  /** Hangup */
  Hangup = 'Hangup',
  /** Unset */
  Unset = 'Unset',
  /** Voicemail */
  Voicemail = 'Voicemail'
}

export interface OpenSipsFraudLog {
  called_number: Maybe<Scalars['String']['output']>;
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  domain: Maybe<Scalars['String']['output']>;
  level: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  openSipsFraudLogId: Scalars['UInt']['output'];
  rule_id: Scalars['UInt']['output'];
  threshold: Scalars['Int']['output'];
  user: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['UInt']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface OpenSipsFraudLogConnection {
  /** Information to aid in pagination. */
  edges: Array<OpenSipsFraudLogModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<OpenSipsFraudLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface OpenSipsFraudLogInput {
  called_number?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  fields: Array<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  openSipsFraudLogId?: InputMaybe<Scalars['UInt']['input']>;
  rule_id?: InputMaybe<Scalars['UInt']['input']>;
  threshold?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface OpenSipsFraudLogModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: OpenSipsFraudLog;
}

export interface OpenSipsFraudWhitelist {
  callsPerMinute: Scalars['UInt']['output'];
  concurrentCalls: Scalars['UInt']['output'];
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  domain: Maybe<Scalars['String']['output']>;
  openSipsFraudWhitelistId: Scalars['UInt']['output'];
  sipUser: Maybe<Scalars['String']['output']>;
  totalCalls: Scalars['UInt']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface OpenSipsFraudWhitelistConnection {
  /** Information to aid in pagination. */
  edges: Array<OpenSipsFraudWhitelistModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<OpenSipsFraudWhitelist>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface OpenSipsFraudWhitelistInput {
  callsPerMinute?: InputMaybe<Scalars['UInt']['input']>;
  concurrentCalls?: InputMaybe<Scalars['UInt']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  fields: Array<Scalars['String']['input']>;
  openSipsFraudWhitelistId?: InputMaybe<Scalars['UInt']['input']>;
  sipUser?: InputMaybe<Scalars['String']['input']>;
  totalCalls?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface OpenSipsFraudWhitelistModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: OpenSipsFraudWhitelist;
}

export interface OpenSipsMismatchedContactAndFromLog {
  createDate: Scalars['UtcDateTime']['output'];
  domain: Maybe<Scalars['String']['output']>;
  id: Scalars['UInt']['output'];
  level: Maybe<Scalars['String']['output']>;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  uri: Maybe<Scalars['String']['output']>;
  user: Maybe<Scalars['String']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface OpenSipsMismatchedContactAndFromLogConnection {
  /** Information to aid in pagination. */
  edges: Array<OpenSipsMismatchedContactAndFromLogModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<OpenSipsMismatchedContactAndFromLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface OpenSipsMismatchedContactAndFromLogInput {
  domain?: InputMaybe<Scalars['String']['input']>;
  fields: Array<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UInt']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface OpenSipsMismatchedContactAndFromLogModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: OpenSipsMismatchedContactAndFromLog;
}

export interface OpenSipsViaLog {
  createDate: Scalars['UtcDateTime']['output'];
  domain: Maybe<Scalars['String']['output']>;
  level: Maybe<Scalars['String']['output']>;
  openSipViaLogId: Scalars['UInt']['output'];
  ruri: Maybe<Scalars['String']['output']>;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  user: Maybe<Scalars['String']['output']>;
  via_count: Scalars['Int']['output'];
  via_list: Maybe<Scalars['String']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface OpenSipsViaLogConnection {
  /** Information to aid in pagination. */
  edges: Array<OpenSipsViaLogModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<OpenSipsViaLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface OpenSipsViaLogInput {
  domain?: InputMaybe<Scalars['String']['input']>;
  fields: Array<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  openSipViaLogId?: InputMaybe<Scalars['UInt']['input']>;
  ruri?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
  via_count?: InputMaybe<Scalars['Int']['input']>;
  via_list?: InputMaybe<Scalars['String']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface OpenSipsViaLogModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: OpenSipsViaLog;
}

export interface OpenSipsZoiperProWhitelist {
  ip: Maybe<Scalars['String']['output']>;
  openSipsZoiperWhitelistId: Scalars['UInt']['output'];
  userAgentPrefix: Maybe<Scalars['String']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface OpenSipsZoiperProWhitelistConnection {
  /** Information to aid in pagination. */
  edges: Array<OpenSipsZoiperProWhitelistModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<OpenSipsZoiperProWhitelist>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface OpenSipsZoiperProWhitelistInput {
  fields: Array<Scalars['String']['input']>;
  ip?: InputMaybe<Scalars['String']['input']>;
  openSipsZoiperWhitelistId?: InputMaybe<Scalars['UInt']['input']>;
  userAgentPrefix?: InputMaybe<Scalars['String']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface OpenSipsZoiperProWhitelistModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: OpenSipsZoiperProWhitelist;
}

export interface OpensipsHardPhoneWhiteList {
  companyCode: Maybe<Scalars['String']['output']>;
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  opensipsHardPhoneWhiteListId: Scalars['UInt']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
  userName: Maybe<Scalars['String']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface OpensipsHardPhoneWhiteListConnection {
  /** Information to aid in pagination. */
  edges: Array<OpensipsHardPhoneWhiteListModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<OpensipsHardPhoneWhiteList>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface OpensipsHardPhoneWhiteListInput {
  companyCode?: InputMaybe<Scalars['String']['input']>;
  fields: Array<Scalars['String']['input']>;
  opensipsHardPhoneWhiteListId?: InputMaybe<Scalars['UInt']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface OpensipsHardPhoneWhiteListModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: OpensipsHardPhoneWhiteList;
}

export enum OrderingDirections {
  /** Asc */
  Asc = 'Asc',
  /** Desc */
  Desc = 'Desc',
  /** NotSet */
  NotSet = 'NotSet'
}

export interface OrderingOption {
  direction?: InputMaybe<OrderingDirections>;
  field: Scalars['String']['input'];
}

/** Information about pagination in a connection. */
export interface PageInfo {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
}

export interface PagingGroupExtensionGroup {
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  extensionGroup: ExtensionGroup;
  extensionGroupExtensionsConnection: ExtensionGroupExtensionConnection;
  extensionGroupId: Scalars['UInt']['output'];
  extensionPagingGroup: ExtensionPagingGroup;
  extensionPagingGroupId: Scalars['UInt']['output'];
  pagingGroupExtensionGroupId: Scalars['UInt']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}


export interface PagingGroupExtensionGroupExtensionGroupExtensionsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface PagingGroupExtensionGroupConnection {
  /** Information to aid in pagination. */
  edges: Array<PagingGroupExtensionGroupModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<PagingGroupExtensionGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface PagingGroupExtensionGroupInput {
  extensionGroupId?: InputMaybe<Scalars['UInt']['input']>;
  extensionPagingGroupId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  pagingGroupExtensionGroupId?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface PagingGroupExtensionGroupModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PagingGroupExtensionGroup;
}

export interface PagingGroupMember {
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  extension: Extension;
  extensionId: Scalars['UInt']['output'];
  extensionPagingGroup: ExtensionPagingGroup;
  extensionPagingGroupId: Scalars['UInt']['output'];
  pagingGroupMemberId: Scalars['UInt']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface PagingGroupMemberConnection {
  /** Information to aid in pagination. */
  edges: Array<PagingGroupMemberModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<PagingGroupMember>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface PagingGroupMemberInput {
  extension?: InputMaybe<ExtensionInput>;
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  extensionPagingGroup?: InputMaybe<ExtensionPagingGroupInput>;
  extensionPagingGroupId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  pagingGroupMemberId?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface PagingGroupMemberModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PagingGroupMember;
}

export interface Phone {
  adminPassword: Maybe<Scalars['String']['output']>;
  baseStationHandsetsConnection: BaseStationHandsetConnection;
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  devicesConnection: DeviceConnection;
  displayName: Maybe<Scalars['String']['output']>;
  domain: Maybe<Scalars['String']['output']>;
  extension: Extension;
  extensionId: Scalars['UInt']['output'];
  extensionPhone: Maybe<ExtensionPhone>;
  handsetIpei: Maybe<Scalars['String']['output']>;
  numberOfLineKeys: Scalars['UInt']['output'];
  phoneId: Scalars['UInt']['output'];
  phoneType: PhoneTypes;
  phoneTypeName: Maybe<Scalars['String']['output']>;
  sipUsername: Maybe<Scalars['String']['output']>;
  sipUsersConnection: SipUserConnection;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}


export interface PhoneBaseStationHandsetsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface PhoneDevicesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface PhoneSipUsersConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface PhoneConnection {
  /** Information to aid in pagination. */
  edges: Array<PhoneModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Phone>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface PhoneInput {
  adminPassword?: InputMaybe<Scalars['String']['input']>;
  baseStationHandsets?: InputMaybe<Array<BaseStationHandsetInput>>;
  devices?: InputMaybe<Array<DeviceInput>>;
  extension?: InputMaybe<ExtensionInput>;
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  extensionPhone?: InputMaybe<ExtensionPhoneInput>;
  fields: Array<Scalars['String']['input']>;
  handsetIpei?: InputMaybe<Scalars['String']['input']>;
  numberOfLineKeys?: InputMaybe<Scalars['UInt']['input']>;
  phoneId?: InputMaybe<Scalars['UInt']['input']>;
  phoneType?: InputMaybe<PhoneTypes>;
  sipUsers?: InputMaybe<Array<SipUserInput>>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface PhoneModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Phone;
}

export interface PhoneNumber {
  account: Maybe<Account>;
  accountId: Maybe<Scalars['UInt']['output']>;
  accountScheduleId: Maybe<Scalars['UInt']['output']>;
  accountTimeZoneId: Maybe<TimeZones>;
  allowOutboundCalls: Scalars['Boolean']['output'];
  centralId: Maybe<Scalars['UInt']['output']>;
  closedExceptionPromptId: Maybe<Scalars['UInt']['output']>;
  closedExceptionStatus: Scalars['Boolean']['output'];
  closedExtension: Maybe<Extension>;
  closedExtensionId: Maybe<Scalars['UInt']['output']>;
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  datePorted: Maybe<Scalars['UtcDateTime']['output']>;
  displayExtensionNumber: Maybe<Scalars['UInt']['output']>;
  displayName: Maybe<Scalars['String']['output']>;
  displayTimeZone: TimeZones;
  extensionFax: Maybe<ExtensionFax>;
  faxExtension: Maybe<Extension>;
  faxExtensionId: Maybe<Scalars['UInt']['output']>;
  faxesUsingForCallerIdConnection: ExtensionFaxConnection;
  isActive: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  isE911Registered: Scalars['Boolean']['output'];
  isPorted: Scalars['Boolean']['output'];
  location: Maybe<Location>;
  locationId: Maybe<Scalars['UInt']['output']>;
  locationTimeZoneId: Maybe<TimeZones>;
  notes: Maybe<Scalars['String']['output']>;
  openExtension: Maybe<Extension>;
  openExtensionId: Maybe<Scalars['UInt']['output']>;
  phoneNumber: Scalars['String']['output'];
  phoneNumberId: Scalars['UInt']['output'];
  phoneNumberStatus: Scalars['Boolean']['output'];
  phonesUsingForCallerIdConnection: ExtensionPhoneConnection;
  portedComments: Maybe<Scalars['String']['output']>;
  providerId: Providers;
  routeTo: Maybe<Scalars['String']['output']>;
  schedule: Maybe<Schedule>;
  scheduleId: Maybe<Scalars['UInt']['output']>;
  timeZoneId: Maybe<TimeZones>;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}


export interface PhoneNumberFaxesUsingForCallerIdConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface PhoneNumberPhonesUsingForCallerIdConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface PhoneNumberConnection {
  /** Information to aid in pagination. */
  edges: Array<PhoneNumberModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<PhoneNumber>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface PhoneNumberInput {
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  accountScheduleId?: InputMaybe<Scalars['UInt']['input']>;
  accountTimeZoneId?: InputMaybe<TimeZones>;
  allowOutboundCalls?: InputMaybe<Scalars['Boolean']['input']>;
  centralId?: InputMaybe<Scalars['UInt']['input']>;
  closedExtension?: InputMaybe<ExtensionInput>;
  closedExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  datePorted?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  faxExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isE911Registered?: InputMaybe<Scalars['Boolean']['input']>;
  isPorted?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['UInt']['input']>;
  locationTimeZoneId?: InputMaybe<TimeZones>;
  notes?: InputMaybe<Scalars['String']['input']>;
  openExtension?: InputMaybe<ExtensionInput>;
  openExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberId?: InputMaybe<Scalars['UInt']['input']>;
  portedComments?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Providers>;
  routeTo?: InputMaybe<Scalars['String']['input']>;
  scheduleId?: InputMaybe<Scalars['UInt']['input']>;
  timeZoneId?: InputMaybe<TimeZones>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface PhoneNumberModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PhoneNumber;
}

export interface PhoneQueueTileTicketGraphType {
  averageHoldLast30Minutes: Scalars['Seconds']['output'];
  averageHoldToday: Scalars['Seconds']['output'];
  callsAbandoned: Scalars['Int']['output'];
  callsWaiting: Scalars['Int']['output'];
  data: Array<PhoneQueueTileTicketGraphType>;
  isListItem: Scalars['Boolean']['output'];
  loggedInAgents: Scalars['Int']['output'];
  oldestCall: Scalars['Seconds']['output'];
  oldestCallWaiting: Scalars['Seconds']['output'];
  queueExtensionId: Scalars['UInt']['output'];
  queueName: Maybe<Scalars['String']['output']>;
  queueNumber: Maybe<Scalars['String']['output']>;
}

export interface PhoneQueuesTileDataGraphType {
  queues: Array<PhoneQueueTileTicketGraphType>;
}

export interface PhoneQueuesTileGraphType {
  dashboardTileId: Maybe<Scalars['Int']['output']>;
  data: Maybe<PhoneQueuesTileDataGraphType>;
  isLcs: Scalars['Boolean']['output'];
  parameters: Maybe<PhoneQueuesTileReportParametersGraphType>;
  runDate: Scalars['UtcDateTime']['output'];
}

export interface PhoneQueuesTileReportParametersGraphType {
  aggregateRest: Scalars['Boolean']['output'];
  callQueueExtensions: Maybe<CallQueueExtensionsToIncludeReportParameterGraphType>;
  limit: Scalars['Int']['output'];
  selectedAccount: Maybe<SelectedAccountReportParameterGraphType>;
  tileLayoutConfiguration: Maybe<TileLayoutConfigurationParameterGraphType>;
  timeZone: Maybe<TimeZoneReportParameterGraphType>;
}

export interface PhoneQueuesTileReportParametersInput {
  aggregateRest?: InputMaybe<Scalars['Boolean']['input']>;
  callQueueExtensions?: InputMaybe<CallQueueExtensionsToIncludeReportParameterInput>;
  fields: Array<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  selectedAccount?: InputMaybe<SelectedAccountReportParameterInput>;
  tileLayoutConfiguration?: InputMaybe<TileLayoutConfigurationParameterInput>;
  timeZone?: InputMaybe<TimeZoneReportParameterInput>;
}

export enum PhoneTypes {
  /** rmAppSuitePro Devices */
  Appsuite = 'Appsuite',
  /** Rove Handset */
  Handset = 'Handset',
  /** Hardphone Devices */
  Hardphone = 'Hardphone',
  /** Softphone Devices */
  Softphone = 'Softphone'
}

export interface Privilege {
  categoryId: Scalars['Int']['output'];
  description: Maybe<Scalars['String']['output']>;
  displayName: Maybe<Scalars['String']['output']>;
  isAdd: Scalars['Boolean']['output'];
  isDelete: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isEdit: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isHidden: Scalars['Boolean']['output'];
  isSystem: Scalars['Boolean']['output'];
  isView: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  privilegeCategory: Maybe<PrivilegeCategory>;
  privilegeId: Scalars['Int']['output'];
  sortOrder: Scalars['UInt']['output'];
}

export interface PrivilegeCategory {
  description: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  privilegeCategoryId: Scalars['Int']['output'];
  sortOrder: Scalars['UInt']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface PrivilegeCategoryConnection {
  /** Information to aid in pagination. */
  edges: Array<PrivilegeCategoryModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<PrivilegeCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface PrivilegeCategoryModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivilegeCategory;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface PrivilegeConnection {
  /** Information to aid in pagination. */
  edges: Array<PrivilegeModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Privilege>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface PrivilegeModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Privilege;
}

export interface Prompt {
  account: Maybe<Account>;
  accountId: Maybe<Scalars['UInt']['output']>;
  accountMusicOnHoldConnection: AccountConnection;
  autoAttendantPromptsConnection: AutoAttendantPromptConnection;
  closedExceptionPromptsConnection: ClosedExceptionConnection;
  copyMohFile: Maybe<Scalars['Boolean']['output']>;
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  dontDeleteFileOnUpdate: Maybe<Scalars['Boolean']['output']>;
  file: Maybe<File>;
  fileId: Maybe<Scalars['UInt']['output']>;
  isActive: Scalars['Boolean']['output'];
  isInUse: Scalars['Boolean']['output'];
  isReusable: Scalars['Boolean']['output'];
  mailboxBusyPromptsConnection: MailboxConnection;
  mailboxNamePromptsConnection: MailboxConnection;
  mailboxTemporaryUnavailablePromptsConnection: MailboxConnection;
  mailboxUnavailablePromptsConnection: MailboxConnection;
  name: Maybe<Scalars['String']['output']>;
  promptId: Scalars['UInt']['output'];
  promptTypeName: Maybe<Scalars['String']['output']>;
  queueCallbackPromptsConnection: ExtensionQueueConnection;
  queueMusicOnHoldConnection: ExtensionQueueConnection;
  queuePeriodicAnnouncementsConnection: QueuePeriodicAnnouncementConnection;
  typeId: PromptTypes;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}


export interface PromptAccountMusicOnHoldConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface PromptAutoAttendantPromptsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface PromptClosedExceptionPromptsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface PromptMailboxBusyPromptsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface PromptMailboxNamePromptsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface PromptMailboxTemporaryUnavailablePromptsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface PromptMailboxUnavailablePromptsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface PromptQueueCallbackPromptsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface PromptQueueMusicOnHoldConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface PromptQueuePeriodicAnnouncementsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface PromptConnection {
  /** Information to aid in pagination. */
  edges: Array<PromptModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Prompt>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface PromptInput {
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  copyMohFile?: InputMaybe<Scalars['Boolean']['input']>;
  dontDeleteFileOnUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  fields: Array<Scalars['String']['input']>;
  file?: InputMaybe<FileInput>;
  fileId?: InputMaybe<Scalars['UInt']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isReusable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  promptId?: InputMaybe<Scalars['UInt']['input']>;
  typeId?: InputMaybe<PromptTypes>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface PromptModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Prompt;
}

export enum PromptTypes {
  /** Auto Attendant */
  AutoAttendant = 'AutoAttendant',
  /** Closed Exception */
  ClosedException = 'ClosedException',
  /** Music On Hold */
  MusicOnHold = 'MusicOnHold',
  /** Periodic Announcement */
  PeriodicAnnouncement = 'PeriodicAnnouncement',
  /** Queue Callback */
  QueueCallback = 'QueueCallback',
  /** System Prompt */
  SystemPrompt = 'SystemPrompt',
  /** Voice Mail Greeting */
  VoiceMailGreeting = 'VoiceMailGreeting'
}

export interface ProviderCallRate {
  area: Scalars['Int']['output'];
  code: Maybe<Scalars['String']['output']>;
  destination: Maybe<Scalars['String']['output']>;
  providerCallRateId: Scalars['Int']['output'];
  providerId: Providers;
  providerTypeName: Maybe<Scalars['String']['output']>;
  rate: Scalars['Float']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  zone: Scalars['Int']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface ProviderCallRateConnection {
  /** Information to aid in pagination. */
  edges: Array<ProviderCallRateModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<ProviderCallRate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface ProviderCallRateInput {
  area?: InputMaybe<Scalars['Int']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  destination?: InputMaybe<Scalars['String']['input']>;
  fields: Array<Scalars['String']['input']>;
  providerCallRateId?: InputMaybe<Scalars['Int']['input']>;
  providerId?: InputMaybe<Providers>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  zone?: InputMaybe<Scalars['Int']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface ProviderCallRateModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ProviderCallRate;
}

export enum Providers {
  /** Inteliquent */
  Inteliquent = 'Inteliquent',
  /** Lumen */
  Lumen = 'Lumen',
  /** NDT */
  NDT = 'NDT',
  /** Time Warner */
  TimeWarner = 'TimeWarner',
  /** Twilio */
  Twilio = 'Twilio'
}

export interface QueueAgentDial {
  agentExtension: Extension;
  agentExtensionId: Scalars['UInt']['output'];
  dialEndTime: Maybe<Scalars['UtcDateTime']['output']>;
  dialStartTime: Scalars['UtcDateTime']['output'];
  dialStatus: QueueAgentDialStatuses;
  queueAgentDialId: Scalars['UInt']['output'];
  queueHistory: QueueHistory;
  queueHistoryId: Scalars['UInt']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface QueueAgentDialConnection {
  /** Information to aid in pagination. */
  edges: Array<QueueAgentDialModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<QueueAgentDial>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface QueueAgentDialInput {
  agentExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  dialEndTime?: InputMaybe<Scalars['DateTime']['input']>;
  dialStatus?: InputMaybe<QueueAgentDialStatuses>;
  fields: Array<Scalars['String']['input']>;
  queueAgentDialId?: InputMaybe<Scalars['UInt']['input']>;
  queueHistoryId?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface QueueAgentDialModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: QueueAgentDial;
}

export enum QueueAgentDialStatuses {
  /** Queue Dial Answered */
  QueueDialAnswered = 'QueueDialAnswered',
  /** Queue Dial Initiated */
  QueueDialInitiated = 'QueueDialInitiated',
  /** Queue Dial Rejected */
  QueueDialRejected = 'QueueDialRejected'
}

export interface QueueAgentLogin {
  agentExtension: Extension;
  agentExtensionId: Scalars['UInt']['output'];
  logInTime: Scalars['UtcDateTime']['output'];
  logOutTime: Maybe<Scalars['UtcDateTime']['output']>;
  queueAgentLoginId: Scalars['UInt']['output'];
  queueExtension: Extension;
  queueExtensionId: Scalars['UInt']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface QueueAgentLoginConnection {
  /** Information to aid in pagination. */
  edges: Array<QueueAgentLoginModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<QueueAgentLogin>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface QueueAgentLoginInput {
  agentExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  logOutTime?: InputMaybe<Scalars['DateTime']['input']>;
  queueAgentLoginId?: InputMaybe<Scalars['UInt']['input']>;
  queueExtensionId?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface QueueAgentLoginModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: QueueAgentLogin;
}

export enum QueueAgentStatus {
  /** Available */
  Available = 'Available',
  /** DND */
  DND = 'DND',
  /** On The Phone */
  OnThePhone = 'OnThePhone',
  /** Ringing */
  Ringing = 'Ringing'
}

export interface QueueCallbackDial {
  dialEndTime: Maybe<Scalars['UtcDateTime']['output']>;
  dialStartTime: Scalars['UtcDateTime']['output'];
  queueCallbackDialId: Scalars['UInt']['output'];
  queueHistory: QueueHistory;
  queueHistoryId: Scalars['UInt']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface QueueCallbackDialConnection {
  /** Information to aid in pagination. */
  edges: Array<QueueCallbackDialModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<QueueCallbackDial>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface QueueCallbackDialInput {
  dialEndTime?: InputMaybe<Scalars['DateTime']['input']>;
  fields: Array<Scalars['String']['input']>;
  queueCallbackDialId?: InputMaybe<Scalars['UInt']['input']>;
  queueHistoryId?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface QueueCallbackDialModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: QueueCallbackDial;
}

export enum QueueCallerStatus {
  /** Abandoned */
  Abandoned = 'Abandoned',
  /** Callback Requested */
  CallbackRequested = 'CallbackRequested',
  /** Cleared From Queue */
  ClearedFromQueue = 'ClearedFromQueue',
  /** Connected */
  Connected = 'Connected',
  /** Dialing An Agent */
  DialingAnAgent = 'DialingAnAgent',
  /** Initiate Queue Callback */
  InitiateQueueCallback = 'InitiateQueueCallback',
  /** To Exit Route */
  ToExitRoute = 'ToExitRoute',
  /** Waiting */
  Waiting = 'Waiting'
}

export interface QueueDataPointGraphType {
  averageMinutesWaiting: Scalars['Decimal']['output'];
  timestamp: Scalars['UtcDateTime']['output'];
}

export interface QueueDataPointSummaryGraphType {
  dataPoints: Array<QueueDataPointGraphType>;
  queueId: Scalars['UInt']['output'];
  queueName: Maybe<Scalars['String']['output']>;
}

export interface QueueExtensionGroup {
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  extensionGroup: ExtensionGroup;
  extensionGroupId: Scalars['UInt']['output'];
  extensionQueue: ExtensionQueue;
  extensionQueueId: Scalars['UInt']['output'];
  queueExtensionGroupId: Scalars['UInt']['output'];
  queueExtensionId: Scalars['UInt']['output'];
  queueMembersConnection: QueueMemberConnection;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}


export interface QueueExtensionGroupQueueMembersConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface QueueExtensionGroupConnection {
  /** Information to aid in pagination. */
  edges: Array<QueueExtensionGroupModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<QueueExtensionGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface QueueExtensionGroupInput {
  extensionGroupId?: InputMaybe<Scalars['UInt']['input']>;
  extensionQueueId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  queueExtensionGroupId?: InputMaybe<Scalars['UInt']['input']>;
  queueExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  queueMembers?: InputMaybe<Array<QueueMemberInput>>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface QueueExtensionGroupModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: QueueExtensionGroup;
}

export interface QueueExtensionStatus {
  agentExtension: Extension;
  agentExtensionId: Scalars['UInt']['output'];
  endWrapUpTime: Maybe<Scalars['UtcDateTime']['output']>;
  extensionStatus: QueueAgentStatus;
  lastAttemptTime: Maybe<Scalars['UtcDateTime']['output']>;
  queueExtensionStatusId: Scalars['UInt']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface QueueExtensionStatusConnection {
  /** Information to aid in pagination. */
  edges: Array<QueueExtensionStatusModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<QueueExtensionStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface QueueExtensionStatusInput {
  agentExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  endWrapUpTime?: InputMaybe<Scalars['DateTime']['input']>;
  extensionStatus?: InputMaybe<QueueAgentStatus>;
  fields: Array<Scalars['String']['input']>;
  lastAttemptTime?: InputMaybe<Scalars['DateTime']['input']>;
  queueExtensionStatusId?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface QueueExtensionStatusModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: QueueExtensionStatus;
}

export interface QueueHistory {
  activeCall: Maybe<ActiveCall>;
  agentExtension: Maybe<Extension>;
  agentExtensionId: Maybe<Scalars['UInt']['output']>;
  agentExtensionNumber: Scalars['UInt']['output'];
  answeredDateTime: Maybe<Scalars['UtcDateTime']['output']>;
  callAbandonedDateTime: Maybe<Scalars['UtcDateTime']['output']>;
  callCompleteDateTime: Maybe<Scalars['UtcDateTime']['output']>;
  callDetail: Maybe<CallDetail>;
  callDetailId: Maybe<Scalars['UInt']['output']>;
  callDispositionId: Maybe<QueueHistoryDisposition>;
  callbackAttempts: Scalars['Int']['output'];
  callbackCompleteDateTime: Maybe<Scalars['UtcDateTime']['output']>;
  callbackFailedDateTime: Maybe<Scalars['UtcDateTime']['output']>;
  callbackNamePromptFile: Maybe<File>;
  callbackNamePromptFileId: Maybe<Scalars['UInt']['output']>;
  callbackRequestDateTime: Maybe<Scalars['UtcDateTime']['output']>;
  callerIdName: Maybe<Scalars['String']['output']>;
  callerIdNumber: Maybe<Scalars['String']['output']>;
  callerStatus: QueueCallerStatus;
  callerStatusDescription: Maybe<Scalars['String']['output']>;
  enqueuedDateTime: Scalars['UtcDateTime']['output'];
  initialWaitTimeEstimate: Scalars['UInt']['output'];
  initialWaitTimeEstimateAlternate: Scalars['UInt']['output'];
  isCallbackRequested: Scalars['Boolean']['output'];
  lastAgentDialAttempt: Maybe<Scalars['UtcDateTime']['output']>;
  lastCallbackDialAttempt: Maybe<Scalars['UtcDateTime']['output']>;
  queueAgentDialsConnection: QueueAgentDialConnection;
  queueCallbackDialsConnection: QueueCallbackDialConnection;
  queueExtension: Extension;
  queueExtensionId: Scalars['UInt']['output'];
  queueHistoryCallDetailsConnection: QueueHistoryCallDetailConnection;
  queueHistoryId: Scalars['UInt']['output'];
  startPosition: Scalars['Int']['output'];
  waitTime: Maybe<Scalars['UInt']['output']>;
}


export interface QueueHistoryQueueAgentDialsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface QueueHistoryQueueCallbackDialsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface QueueHistoryQueueHistoryCallDetailsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

export interface QueueHistoryCallDetail {
  agentChannelId: Maybe<Scalars['String']['output']>;
  callDetail: CallDetail;
  callDetailId: Scalars['UInt']['output'];
  queueHistory: QueueHistory;
  queueHistoryCallDetailId: Scalars['UInt']['output'];
  queueHistoryId: Scalars['UInt']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface QueueHistoryCallDetailConnection {
  /** Information to aid in pagination. */
  edges: Array<QueueHistoryCallDetailModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<QueueHistoryCallDetail>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface QueueHistoryCallDetailInput {
  agentChannelId?: InputMaybe<Scalars['String']['input']>;
  callDetailId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  queueHistoryCallDetailId?: InputMaybe<Scalars['UInt']['input']>;
  queueHistoryId?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface QueueHistoryCallDetailModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: QueueHistoryCallDetail;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface QueueHistoryConnection {
  /** Information to aid in pagination. */
  edges: Array<QueueHistoryModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<QueueHistory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export enum QueueHistoryDisposition {
  /** Call Abandoned */
  CallAbandoned = 'CallAbandoned',
  /** Callback Failed */
  CallbackFailed = 'CallbackFailed',
  /** Callback Rejected */
  CallbackRejected = 'CallbackRejected',
  /** Caller Selected Exit Route */
  CallerSelectedExitRoute = 'CallerSelectedExitRoute',
  /** Connected To Agent */
  ConnectedToAgent = 'ConnectedToAgent',
  /** Manually Cleared */
  ManuallyCleared = 'ManuallyCleared'
}

export interface QueueHistoryInput {
  agentExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  answeredDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  callAbandonedDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  callCompleteDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  callDetailId?: InputMaybe<Scalars['UInt']['input']>;
  callDispositionId?: InputMaybe<QueueHistoryDisposition>;
  callbackAttempts?: InputMaybe<Scalars['Int']['input']>;
  callbackCompleteDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  callbackFailedDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  callbackNamePromptFileId?: InputMaybe<Scalars['UInt']['input']>;
  callbackRequestDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  callerIdName?: InputMaybe<Scalars['String']['input']>;
  callerIdNumber?: InputMaybe<Scalars['String']['input']>;
  callerStatus?: InputMaybe<QueueCallerStatus>;
  fields: Array<Scalars['String']['input']>;
  initialWaitTimeEstimate?: InputMaybe<Scalars['UInt']['input']>;
  initialWaitTimeEstimateAlternate?: InputMaybe<Scalars['UInt']['input']>;
  isCallbackRequested?: InputMaybe<Scalars['Boolean']['input']>;
  lastAgentDialAttempt?: InputMaybe<Scalars['DateTime']['input']>;
  lastCallbackDialAttempt?: InputMaybe<Scalars['DateTime']['input']>;
  queueExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  queueHistoryId?: InputMaybe<Scalars['UInt']['input']>;
  startPosition?: InputMaybe<Scalars['Int']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface QueueHistoryModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: QueueHistory;
}

export interface QueueLog {
  agentExtension: Extension;
  agentExtensionId: Scalars['UInt']['output'];
  callDetail: CallDetail;
  callDetailId: Scalars['UInt']['output'];
  eventDate: Scalars['UtcDateTime']['output'];
  loggedEvent: Maybe<Scalars['String']['output']>;
  queueExtension: Extension;
  queueExtensionId: Scalars['UInt']['output'];
  queueLogId: Scalars['UInt']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface QueueLogConnection {
  /** Information to aid in pagination. */
  edges: Array<QueueLogModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<QueueLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface QueueLogInput {
  agentExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  callDetailId?: InputMaybe<Scalars['UInt']['input']>;
  eventDate?: InputMaybe<Scalars['DateTime']['input']>;
  fields: Array<Scalars['String']['input']>;
  loggedEvent?: InputMaybe<Scalars['String']['input']>;
  queueExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  queueLogId?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface QueueLogModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: QueueLog;
}

export enum QueueManagementStrategy {
  /** Managed Queues */
  ManagedQueues = 'ManagedQueues',
  /** Standard Queues */
  StandardQueues = 'StandardQueues'
}

export interface QueueMember {
  agentExtension: Extension;
  agentExtensionId: Scalars['UInt']['output'];
  agentStatus: Maybe<QueueAgentStatus>;
  assignmentUpdatedBy: Scalars['UInt']['output'];
  assignmentUpdatedByExtension: Maybe<Extension>;
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  endWrapUpTime: Maybe<Scalars['UtcDateTime']['output']>;
  extensionQueue: ExtensionQueue;
  extensionQueueId: Scalars['UInt']['output'];
  isAssigned: Scalars['Boolean']['output'];
  isLoggedIn: Scalars['Boolean']['output'];
  queueExtensionGroup: Maybe<QueueExtensionGroup>;
  queueExtensionGroupId: Maybe<Scalars['UInt']['output']>;
  queueExtensionId: Scalars['UInt']['output'];
  queueExtensionStatus: Maybe<QueueExtensionStatus>;
  queueMemberId: Scalars['UInt']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface QueueMemberConnection {
  /** Information to aid in pagination. */
  edges: Array<QueueMemberModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<QueueMember>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface QueueMemberInput {
  agentExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  agentStatus?: InputMaybe<QueueAgentStatus>;
  assignmentUpdatedBy?: InputMaybe<Scalars['UInt']['input']>;
  endWrapUpTime?: InputMaybe<Scalars['DateTime']['input']>;
  extensionQueueId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  isAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  isLoggedIn?: InputMaybe<Scalars['Boolean']['input']>;
  queueExtensionGroup?: InputMaybe<QueueExtensionGroupInput>;
  queueExtensionGroupId?: InputMaybe<Scalars['UInt']['input']>;
  queueExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  queueExtensionStatus?: InputMaybe<QueueExtensionStatusInput>;
  queueMemberId?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface QueueMemberModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: QueueMember;
}

export interface QueueMemberTileTicketGraphType {
  agentExtension: Scalars['String']['output'];
  agentExtensionId: Maybe<Scalars['String']['output']>;
  agentName: Maybe<Scalars['String']['output']>;
  availability: Maybe<Scalars['String']['output']>;
  avgCallTime: Scalars['Seconds']['output'];
  callCount: Scalars['Int']['output'];
  callsPerHour: Scalars['Decimal']['output'];
  currentTime: Scalars['Seconds']['output'];
  data: Array<QueueMemberTileTicketGraphType>;
  isListItem: Scalars['Boolean']['output'];
  outboundCallCount: Scalars['Int']['output'];
  overallTalkTime: Scalars['Seconds']['output'];
  queueMemberId: Scalars['UInt']['output'];
  queues: Maybe<Scalars['String']['output']>;
  timeSinceLastCall: Scalars['Seconds']['output'];
}

export interface QueueMembersTileDataGraphType {
  members: Array<QueueMemberTileTicketGraphType>;
}

export interface QueueMembersTileGraphType {
  dashboardTileId: Maybe<Scalars['Int']['output']>;
  data: Maybe<QueueMembersTileDataGraphType>;
  isLcs: Scalars['Boolean']['output'];
  parameters: Maybe<QueueMembersTileReportParametersGraphType>;
  runDate: Scalars['UtcDateTime']['output'];
}

export interface QueueMembersTileReportParametersGraphType {
  aggregateRest: Scalars['Boolean']['output'];
  callQueueExtensions: Maybe<CallQueueExtensionsToIncludeReportParameterGraphType>;
  columnSort: Maybe<ColumnSortReportParameterGraphType>;
  limit: Scalars['Int']['output'];
  selectedAccount: Maybe<SelectedAccountReportParameterGraphType>;
  tileLayoutConfiguration: Maybe<TileLayoutConfigurationParameterGraphType>;
  timeZone: Maybe<TimeZoneReportParameterGraphType>;
}

export interface QueueMembersTileReportParametersInput {
  aggregateRest?: InputMaybe<Scalars['Boolean']['input']>;
  callQueueExtensions?: InputMaybe<CallQueueExtensionsToIncludeReportParameterInput>;
  columnSort?: InputMaybe<ColumnSortReportParameterInput>;
  fields: Array<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  selectedAccount?: InputMaybe<SelectedAccountReportParameterInput>;
  tileLayoutConfiguration?: InputMaybe<TileLayoutConfigurationParameterInput>;
  timeZone?: InputMaybe<TimeZoneReportParameterInput>;
}

export interface QueuePeriodicAnnouncement {
  createDate: Scalars['UtcDateTime']['output'];
  createUserId: Maybe<Scalars['Int']['output']>;
  extensionQueue: ExtensionQueue;
  extensionQueueId: Scalars['UInt']['output'];
  prompt: Prompt;
  promptId: Scalars['UInt']['output'];
  /** @deprecated  */
  queueExtensionId: Scalars['UInt']['output'];
  queuePeriodicAnnouncementId: Scalars['UInt']['output'];
  sortOrder: Scalars['UInt']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface QueuePeriodicAnnouncementConnection {
  /** Information to aid in pagination. */
  edges: Array<QueuePeriodicAnnouncementModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<QueuePeriodicAnnouncement>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface QueuePeriodicAnnouncementInput {
  extensionQueueId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  promptId?: InputMaybe<Scalars['UInt']['input']>;
  queueExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  queuePeriodicAnnouncementId?: InputMaybe<Scalars['UInt']['input']>;
  sortOrder?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface QueuePeriodicAnnouncementModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: QueuePeriodicAnnouncement;
}

export enum QueueStrategies {
  /** Fewest Calls */
  FewestCalls = 'FewestCalls',
  /** Least Recent */
  LeastRecent = 'LeastRecent',
  /** Round Robin */
  RoundRobin = 'RoundRobin'
}

export interface Rm12Client {
  broadcastUser: Scalars['Boolean']['output'];
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  dbid: Maybe<Scalars['String']['output']>;
  extension: Extension;
  extensionId: Scalars['UInt']['output'];
  location: Scalars['String']['output'];
  locationId: Scalars['Int']['output'];
  rM12ClientId: Scalars['UInt']['output'];
  rm12UserId: Scalars['Int']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
  username: Maybe<Scalars['String']['output']>;
  versionNumber: Scalars['Float']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface Rm12ClientConnection {
  /** Information to aid in pagination. */
  edges: Array<Rm12ClientModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Rm12Client>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface Rm12ClientInput {
  broadcastUser?: InputMaybe<Scalars['Boolean']['input']>;
  dbid?: InputMaybe<Scalars['String']['input']>;
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  rM12ClientId?: InputMaybe<Scalars['UInt']['input']>;
  rm12UserId?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  versionNumber?: InputMaybe<Scalars['Float']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface Rm12ClientModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Rm12Client;
}

export enum RelativeDateOptions {
  /** EndOfWeek */
  EndOfWeek = 'EndOfWeek',
  /** FifteenDays */
  FifteenDays = 'FifteenDays',
  /** FirstOfWeek */
  FirstOfWeek = 'FirstOfWeek',
  /** LastQuarter */
  LastQuarter = 'LastQuarter',
  /** LastWeekday */
  LastWeekday = 'LastWeekday',
  /** NinetyDays */
  NinetyDays = 'NinetyDays',
  /** OneMonthAgo */
  OneMonthAgo = 'OneMonthAgo',
  /** OneWeekAgo */
  OneWeekAgo = 'OneWeekAgo',
  /** OneYearAgo */
  OneYearAgo = 'OneYearAgo',
  /** PreviousTwelveMonths */
  PreviousTwelveMonths = 'PreviousTwelveMonths',
  /** SixMonths */
  SixMonths = 'SixMonths',
  /** ThisQuarter */
  ThisQuarter = 'ThisQuarter',
  /** Today */
  Today = 'Today',
  /** TwoDays */
  TwoDays = 'TwoDays',
  /** TwoWeeks */
  TwoWeeks = 'TwoWeeks',
  /** Yesterday */
  Yesterday = 'Yesterday'
}

export interface Report {
  description: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  reportDefinition: Maybe<ReportDefinitions>;
  reportId: Scalars['UInt']['output'];
  reportParametersConnection: ReportParameterConnection;
}


export interface ReportReportParametersConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface ReportConnection {
  /** Information to aid in pagination. */
  edges: Array<ReportModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Report>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export enum ReportDefinitions {
  /** Abandoned Calls */
  AbandonedCalls = 'AbandonedCalls',
  /** Active Extensions */
  ActiveExtensions = 'ActiveExtensions',
  /** Daily Call Volume */
  DailyCallVolume = 'DailyCallVolume',
  /** Extension Detail Report */
  ExtensionDetail = 'ExtensionDetail',
  /** Extension Statistics */
  ExtensionStatistics = 'ExtensionStatistics',
  /** Extension Summary Report */
  ExtensionSummary = 'ExtensionSummary',
  /** Hourly Call Volume */
  HourlyCallVolume = 'HourlyCallVolume',
  /** Hunt Group Extension */
  HuntGroupExtension = 'HuntGroupExtension',
  /** Inbound Calls By Phone Number */
  InboundCallsByPhoneNumber = 'InboundCallsByPhoneNumber',
  /** InternationalCalls */
  InternationalCalls = 'InternationalCalls',
  /** Missed Calls */
  MissedCalls = 'MissedCalls',
  /** System International Calls */
  SystemInternationalCalls = 'SystemInternationalCalls',
  /** Top Callers Report */
  TopCallers = 'TopCallers',
  /** Week Day Call Volume */
  WeekDayCallVolume = 'WeekDayCallVolume'
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface ReportModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Report;
}

export interface ReportParameter {
  description: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  reportParameterId: Scalars['UInt']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface ReportParameterConnection {
  /** Information to aid in pagination. */
  edges: Array<ReportParameterModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<ReportParameter>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface ReportParameterInput {
  description?: InputMaybe<Scalars['String']['input']>;
  fields: Array<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reportParameterId?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface ReportParameterModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ReportParameter;
}

export enum ReportParameters {
  /** Aggregate Queues */
  AggregateQueues = 'AggregateQueues',
  /** Auto Attendant Extensions To Include */
  AutoAttendantExtensionsToInclude = 'AutoAttendantExtensionsToInclude',
  /** Bar Graph Source */
  BarGraphSource = 'BarGraphSource',
  /** Boolean */
  Boolean = 'Boolean',
  /** CallDirectionsToInclude */
  CallDirectionsToInclude = 'CallDirectionsToInclude',
  /** CallDispositionsToInclude */
  CallDispositionsToInclude = 'CallDispositionsToInclude',
  /** Call Queue Extensions To Include */
  CallQueueExtensionsToInclude = 'CallQueueExtensionsToInclude',
  /** Column Sort */
  ColumnSort = 'ColumnSort',
  /** Data To Include */
  DataToInclude = 'DataToInclude',
  /** Date Range */
  DateRange = 'DateRange',
  /** Date Range Select */
  DateRangeSelect = 'DateRangeSelect',
  /** Days of the Week */
  DaysOfTheWeek = 'DaysOfTheWeek',
  /** End Hour */
  EndHour = 'EndHour',
  /** Exclude Internal Calls */
  ExcludeInternal = 'ExcludeInternal',
  /** Extension Groups To Include */
  ExtensionGroupsToInclude = 'ExtensionGroupsToInclude',
  /** Extension Sort By */
  ExtensionSortBy = 'ExtensionSortBy',
  /** Extensions To Include */
  ExtensionsToInclude = 'ExtensionsToInclude',
  /** Group By Extension */
  GroupByExtension = 'GroupByExtension',
  /** Include Not Missed Calls */
  IncludeNotMissedCalls = 'IncludeNotMissedCalls',
  /** Number of Callers */
  NumberOfCallers = 'NumberOfCallers',
  /** Phone Numbers To Include */
  PhoneNumbersToInclude = 'PhoneNumbersToInclude',
  /** Selected Account */
  SelectedAccount = 'SelectedAccount',
  /** Show Date */
  ShowDate = 'ShowDate',
  /** Single Date */
  SingleDate = 'SingleDate',
  /** Sort By */
  SortBy = 'SortBy',
  /** Start Hour */
  StartHour = 'StartHour',
  /** Summary Only */
  SummaryOnly = 'SummaryOnly',
  /** Time Range */
  TimeRange = 'TimeRange',
  /** Time Zone */
  TimeZone = 'TimeZone'
}

export interface Rm12ClientToken {
  accountId: Scalars['UInt']['output'];
  accountShortName: Maybe<Scalars['String']['output']>;
  extension: Extension;
  extensionId: Scalars['UInt']['output'];
  rm12ClientTokenId: Scalars['UInt']['output'];
  token: Scalars['Guid']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface Rm12ClientTokenConnection {
  /** Information to aid in pagination. */
  edges: Array<Rm12ClientTokenModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Rm12ClientToken>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface Rm12ClientTokenInput {
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  accountShortName?: InputMaybe<Scalars['String']['input']>;
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  rm12ClientTokenId?: InputMaybe<Scalars['UInt']['input']>;
  token?: InputMaybe<Scalars['ID']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface Rm12ClientTokenModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Rm12ClientToken;
}

export interface Role {
  account: Maybe<Account>;
  accountId: Maybe<Scalars['UInt']['output']>;
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  description: Maybe<Scalars['String']['output']>;
  hasAllExtensionRecordings: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  roleCallRecordingExtensionGroupsConnection: RoleCallRecordingExtensionGroupConnection;
  roleCallRecordingExtensionsConnection: RoleCallRecordingExtensionConnection;
  roleId: Scalars['UInt']['output'];
  rolePrivilegesConnection: RolePrivilegeConnection;
  roleReportsConnection: RoleReportConnection;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
  userRolesConnection: UserRoleConnection;
  userRolesCount: Scalars['UInt']['output'];
}


export interface RoleRoleCallRecordingExtensionGroupsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface RoleRoleCallRecordingExtensionsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface RoleRolePrivilegesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface RoleRoleReportsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface RoleUserRolesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

export interface RoleCallRecordingExtension {
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  extension: Extension;
  extensionId: Scalars['UInt']['output'];
  isInclude: Scalars['Boolean']['output'];
  role: Role;
  roleCallRecordingExtensionId: Scalars['UInt']['output'];
  roleId: Scalars['UInt']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface RoleCallRecordingExtensionConnection {
  /** Information to aid in pagination. */
  edges: Array<RoleCallRecordingExtensionModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<RoleCallRecordingExtension>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface RoleCallRecordingExtensionGroup {
  extensionGroup: ExtensionGroup;
  extensionGroupId: Scalars['UInt']['output'];
  isInclude: Scalars['Boolean']['output'];
  role: Role;
  roleCallRecordingExtensionGroupId: Scalars['UInt']['output'];
  roleId: Scalars['UInt']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface RoleCallRecordingExtensionGroupConnection {
  /** Information to aid in pagination. */
  edges: Array<RoleCallRecordingExtensionGroupModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<RoleCallRecordingExtensionGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface RoleCallRecordingExtensionGroupInput {
  extensionGroupId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  isInclude?: InputMaybe<Scalars['Boolean']['input']>;
  roleCallRecordingExtensionGroupId?: InputMaybe<Scalars['UInt']['input']>;
  roleId?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface RoleCallRecordingExtensionGroupModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: RoleCallRecordingExtensionGroup;
}

export interface RoleCallRecordingExtensionInput {
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  isInclude?: InputMaybe<Scalars['Boolean']['input']>;
  roleCallRecordingExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  roleId?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface RoleCallRecordingExtensionModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: RoleCallRecordingExtension;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface RoleConnection {
  /** Information to aid in pagination. */
  edges: Array<RoleModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Role>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface RoleInput {
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fields: Array<Scalars['String']['input']>;
  hasAllExtensionRecordings?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  roleCallRecordingExtensionGroups?: InputMaybe<Array<RoleCallRecordingExtensionGroupInput>>;
  roleCallRecordingExtensions?: InputMaybe<Array<RoleCallRecordingExtensionInput>>;
  roleId?: InputMaybe<Scalars['UInt']['input']>;
  roleReports?: InputMaybe<Array<RoleReportInput>>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface RoleModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Role;
}

export interface RolePrivilege {
  accountId: Maybe<Scalars['UInt']['output']>;
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  isAdd: Scalars['Boolean']['output'];
  isDelete: Scalars['Boolean']['output'];
  isEdit: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isView: Scalars['Boolean']['output'];
  privilege: Privilege;
  privilegeId: Scalars['Int']['output'];
  role: Role;
  roleId: Scalars['UInt']['output'];
  rolePrivilegeId: Scalars['UInt']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface RolePrivilegeConnection {
  /** Information to aid in pagination. */
  edges: Array<RolePrivilegeModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<RolePrivilege>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface RolePrivilegeInput {
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  isAdd?: InputMaybe<Scalars['Boolean']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  isEdit?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isView?: InputMaybe<Scalars['Boolean']['input']>;
  privilegeId?: InputMaybe<Scalars['Int']['input']>;
  roleId?: InputMaybe<Scalars['UInt']['input']>;
  rolePrivilegeId?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface RolePrivilegeModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: RolePrivilege;
}

export interface RoleReport {
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  report: Report;
  reportId: Scalars['Int']['output'];
  role: Role;
  roleId: Scalars['UInt']['output'];
  roleReportId: Scalars['UInt']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface RoleReportConnection {
  /** Information to aid in pagination. */
  edges: Array<RoleReportModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<RoleReport>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface RoleReportInput {
  fields: Array<Scalars['String']['input']>;
  reportId?: InputMaybe<Scalars['Int']['input']>;
  roleId?: InputMaybe<Scalars['UInt']['input']>;
  roleReportId?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface RoleReportModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: RoleReport;
}

export interface RootMutation {
  appSuiteWakeupEvent: Maybe<Scalars['Boolean']['output']>;
  calculateCurrentCallCosts: Maybe<Scalars['Boolean']['output']>;
  cleanUpCallsForCrashedAsteriskPod: Maybe<Scalars['Boolean']['output']>;
  clear: Maybe<Scalars['Boolean']['output']>;
  combineVoicemailAndCallRecordingFiles: Maybe<Scalars['Boolean']['output']>;
  contactFromMismatchAlert: Maybe<Scalars['Boolean']['output']>;
  deleteAccessToken: Scalars['Boolean']['output'];
  deleteAccessTokenPrivilege: Scalars['Boolean']['output'];
  deleteAccessTokenPrivileges: Scalars['Boolean']['output'];
  deleteAccessTokens: Scalars['Boolean']['output'];
  deleteAccount: Scalars['Boolean']['output'];
  deleteAccounts: Scalars['Boolean']['output'];
  deleteActiveCall: Scalars['Boolean']['output'];
  deleteActiveCallSegment: Scalars['Boolean']['output'];
  deleteActiveCallSegments: Scalars['Boolean']['output'];
  deleteActiveCalls: Scalars['Boolean']['output'];
  deleteAllowedIpAddress: Scalars['Boolean']['output'];
  deleteAllowedIpAddresses: Scalars['Boolean']['output'];
  deleteAutoAttendantKey: Scalars['Boolean']['output'];
  deleteAutoAttendantKeys: Scalars['Boolean']['output'];
  deleteAutoAttendantPrompt: Scalars['Boolean']['output'];
  deleteAutoAttendantPrompts: Scalars['Boolean']['output'];
  deleteAzureActiveDirectoryConfiguration: Scalars['Boolean']['output'];
  deleteAzureActiveDirectoryConfigurations: Scalars['Boolean']['output'];
  deleteBannedProvisioningIp: Scalars['Boolean']['output'];
  deleteBannedProvisioningIps: Scalars['Boolean']['output'];
  deleteBaseStationHandset: Scalars['Boolean']['output'];
  deleteBaseStationHandsets: Scalars['Boolean']['output'];
  deleteBlockedIpAddress: Scalars['Boolean']['output'];
  deleteBlockedIpAddresses: Scalars['Boolean']['output'];
  deleteBlockedPhoneNumber: Scalars['Boolean']['output'];
  deleteBlockedPhoneNumbers: Scalars['Boolean']['output'];
  deleteCallDetail: Scalars['Boolean']['output'];
  deleteCallDetailAppsuiteChannel: Scalars['Boolean']['output'];
  deleteCallDetailAppsuiteChannels: Scalars['Boolean']['output'];
  deleteCallDetails: Scalars['Boolean']['output'];
  deleteCallParkingLot: Scalars['Boolean']['output'];
  deleteCallParkingLots: Scalars['Boolean']['output'];
  deleteCallRecording: Scalars['Boolean']['output'];
  deleteCallRecordingCallDetail: Scalars['Boolean']['output'];
  deleteCallRecordingCallDetails: Scalars['Boolean']['output'];
  deleteCallRecordings: Scalars['Boolean']['output'];
  deleteCallSegment: Scalars['Boolean']['output'];
  deleteCallSegments: Scalars['Boolean']['output'];
  deleteClosedException: Scalars['Boolean']['output'];
  deleteClosedExceptions: Scalars['Boolean']['output'];
  deleteCronJob: Scalars['Boolean']['output'];
  deleteCronJobExecution: Scalars['Boolean']['output'];
  deleteCronJobExecutions: Scalars['Boolean']['output'];
  deleteCronJobs: Scalars['Boolean']['output'];
  deleteDashboard: Scalars['Boolean']['output'];
  deleteDashboardTile: Scalars['Boolean']['output'];
  deleteDashboardTileEntityParameter: Scalars['Boolean']['output'];
  deleteDashboardTileEntityParameterValue: Scalars['Boolean']['output'];
  deleteDashboardTileEntityParameterValues: Scalars['Boolean']['output'];
  deleteDashboardTileEntityParameters: Scalars['Boolean']['output'];
  deleteDashboardTileLayoutConfiguration: Scalars['Boolean']['output'];
  deleteDashboardTileLayoutConfigurations: Scalars['Boolean']['output'];
  deleteDashboardTileParameter: Scalars['Boolean']['output'];
  deleteDashboardTileParameterDateRange: Scalars['Boolean']['output'];
  deleteDashboardTileParameterDateRanges: Scalars['Boolean']['output'];
  deleteDashboardTileParameters: Scalars['Boolean']['output'];
  deleteDashboardTiles: Scalars['Boolean']['output'];
  deleteDashboards: Scalars['Boolean']['output'];
  deleteDepartment: Scalars['Boolean']['output'];
  deleteDepartmentExtension: Scalars['Boolean']['output'];
  deleteDepartmentExtensions: Scalars['Boolean']['output'];
  deleteDepartments: Scalars['Boolean']['output'];
  deleteDevice: Scalars['Boolean']['output'];
  deleteDevices: Scalars['Boolean']['output'];
  deleteExtension: Scalars['Boolean']['output'];
  deleteExtensionAutoAttendant: Scalars['Boolean']['output'];
  deleteExtensionAutoAttendants: Scalars['Boolean']['output'];
  deleteExtensionExternalForward: Scalars['Boolean']['output'];
  deleteExtensionExternalForwards: Scalars['Boolean']['output'];
  deleteExtensionFax: Scalars['Boolean']['output'];
  deleteExtensionFaxes: Scalars['Boolean']['output'];
  deleteExtensionFmFm: Scalars['Boolean']['output'];
  deleteExtensionFmFms: Scalars['Boolean']['output'];
  deleteExtensionGroup: Scalars['Boolean']['output'];
  deleteExtensionGroupExtension: Scalars['Boolean']['output'];
  deleteExtensionGroupExtensions: Scalars['Boolean']['output'];
  deleteExtensionGroupSupervisee: Scalars['Boolean']['output'];
  deleteExtensionGroupSupervisees: Scalars['Boolean']['output'];
  deleteExtensionGroups: Scalars['Boolean']['output'];
  deleteExtensionHuntGroup: Scalars['Boolean']['output'];
  deleteExtensionHuntGroups: Scalars['Boolean']['output'];
  deleteExtensionMailbox: Scalars['Boolean']['output'];
  deleteExtensionMailboxes: Scalars['Boolean']['output'];
  deleteExtensionPagingGroup: Scalars['Boolean']['output'];
  deleteExtensionPagingGroups: Scalars['Boolean']['output'];
  deleteExtensionPhone: Scalars['Boolean']['output'];
  deleteExtensionPhones: Scalars['Boolean']['output'];
  deleteExtensionQueue: Scalars['Boolean']['output'];
  deleteExtensionQueues: Scalars['Boolean']['output'];
  deleteExtensionSupervisee: Scalars['Boolean']['output'];
  deleteExtensionSupervisees: Scalars['Boolean']['output'];
  deleteExtensions: Scalars['Boolean']['output'];
  deleteExternalNumberHistories: Scalars['Boolean']['output'];
  deleteExternalNumberHistory: Scalars['Boolean']['output'];
  deleteFax: Scalars['Boolean']['output'];
  deleteFaxAttachment: Scalars['Boolean']['output'];
  deleteFaxAttachments: Scalars['Boolean']['output'];
  deleteFaxEmailAddress: Scalars['Boolean']['output'];
  deleteFaxEmailAddresses: Scalars['Boolean']['output'];
  deleteFaxes: Scalars['Boolean']['output'];
  deleteFile: Scalars['Boolean']['output'];
  deleteFileDepot: Scalars['Boolean']['output'];
  deleteFileDepots: Scalars['Boolean']['output'];
  deleteFiles: Scalars['Boolean']['output'];
  deleteFmFmStep: Scalars['Boolean']['output'];
  deleteFmFmStepExtension: Scalars['Boolean']['output'];
  deleteFmFmStepExtensions: Scalars['Boolean']['output'];
  deleteFmFmStepPhoneNumber: Scalars['Boolean']['output'];
  deleteFmFmStepPhoneNumbers: Scalars['Boolean']['output'];
  deleteFmFmSteps: Scalars['Boolean']['output'];
  deleteHuntGroupExtensionGroup: Scalars['Boolean']['output'];
  deleteHuntGroupExtensionGroups: Scalars['Boolean']['output'];
  deleteHuntGroupMember: Scalars['Boolean']['output'];
  deleteHuntGroupMembers: Scalars['Boolean']['output'];
  deleteLocation: Scalars['Boolean']['output'];
  deleteLocations: Scalars['Boolean']['output'];
  deleteMailbox: Scalars['Boolean']['output'];
  deleteMailboxMessage: Scalars['Boolean']['output'];
  deleteMailboxMessages: Scalars['Boolean']['output'];
  deleteMailboxes: Scalars['Boolean']['output'];
  deleteNote: Scalars['Boolean']['output'];
  deleteNotes: Scalars['Boolean']['output'];
  deleteOpenSipsFraudLog: Scalars['Boolean']['output'];
  deleteOpenSipsFraudLogs: Scalars['Boolean']['output'];
  deleteOpenSipsFraudWhitelist: Scalars['Boolean']['output'];
  deleteOpenSipsFraudWhitelists: Scalars['Boolean']['output'];
  deleteOpenSipsMismatchedContactAndFromLog: Scalars['Boolean']['output'];
  deleteOpenSipsMismatchedContactAndFromLogs: Scalars['Boolean']['output'];
  deleteOpenSipsViaLog: Scalars['Boolean']['output'];
  deleteOpenSipsViaLogs: Scalars['Boolean']['output'];
  deleteOpenSipsZoiperProWhitelist: Scalars['Boolean']['output'];
  deleteOpenSipsZoiperProWhitelists: Scalars['Boolean']['output'];
  deleteOpensipsHardPhoneWhiteList: Scalars['Boolean']['output'];
  deleteOpensipsHardPhoneWhiteLists: Scalars['Boolean']['output'];
  deletePagingGroupExtensionGroup: Scalars['Boolean']['output'];
  deletePagingGroupExtensionGroups: Scalars['Boolean']['output'];
  deletePagingGroupMember: Scalars['Boolean']['output'];
  deletePagingGroupMembers: Scalars['Boolean']['output'];
  deleteParametersFromDashboardTile: Maybe<Scalars['Boolean']['output']>;
  deletePhone: Scalars['Boolean']['output'];
  deletePhoneNumber: Scalars['Boolean']['output'];
  deletePhoneNumbers: Scalars['Boolean']['output'];
  deletePhones: Scalars['Boolean']['output'];
  deletePrompt: Scalars['Boolean']['output'];
  deletePrompts: Scalars['Boolean']['output'];
  deleteProviderCallRate: Scalars['Boolean']['output'];
  deleteProviderCallRates: Scalars['Boolean']['output'];
  deleteQueueAgentDial: Scalars['Boolean']['output'];
  deleteQueueAgentDials: Scalars['Boolean']['output'];
  deleteQueueAgentLogin: Scalars['Boolean']['output'];
  deleteQueueAgentLogins: Scalars['Boolean']['output'];
  deleteQueueCallbackDial: Scalars['Boolean']['output'];
  deleteQueueCallbackDials: Scalars['Boolean']['output'];
  deleteQueueExtensionGroup: Scalars['Boolean']['output'];
  deleteQueueExtensionGroups: Scalars['Boolean']['output'];
  deleteQueueExtensionStatus: Scalars['Boolean']['output'];
  deleteQueueExtensionStatuses: Scalars['Boolean']['output'];
  deleteQueueHistories: Scalars['Boolean']['output'];
  deleteQueueHistory: Scalars['Boolean']['output'];
  deleteQueueHistoryCallDetail: Scalars['Boolean']['output'];
  deleteQueueHistoryCallDetails: Scalars['Boolean']['output'];
  deleteQueueLog: Scalars['Boolean']['output'];
  deleteQueueLogs: Scalars['Boolean']['output'];
  deleteQueueMember: Scalars['Boolean']['output'];
  deleteQueueMembers: Scalars['Boolean']['output'];
  deleteQueuePeriodicAnnouncement: Scalars['Boolean']['output'];
  deleteQueuePeriodicAnnouncements: Scalars['Boolean']['output'];
  deleteRM12Client: Scalars['Boolean']['output'];
  deleteRM12Clients: Scalars['Boolean']['output'];
  deleteRm12ClientToken: Scalars['Boolean']['output'];
  deleteRm12ClientTokens: Scalars['Boolean']['output'];
  deleteRole: Scalars['Boolean']['output'];
  deleteRoleCallRecordingExtension: Scalars['Boolean']['output'];
  deleteRoleCallRecordingExtensionGroup: Scalars['Boolean']['output'];
  deleteRoleCallRecordingExtensionGroups: Scalars['Boolean']['output'];
  deleteRoleCallRecordingExtensions: Scalars['Boolean']['output'];
  deleteRoleLinksFromUser: Maybe<Scalars['Boolean']['output']>;
  deleteRolePrivilege: Scalars['Boolean']['output'];
  deleteRolePrivileges: Scalars['Boolean']['output'];
  deleteRolePrivilegesFromRole: Maybe<Scalars['Boolean']['output']>;
  deleteRoleReport: Scalars['Boolean']['output'];
  deleteRoleReports: Scalars['Boolean']['output'];
  deleteRoleReportsFromRole: Maybe<Scalars['Boolean']['output']>;
  deleteRoles: Scalars['Boolean']['output'];
  deleteSchedule: Scalars['Boolean']['output'];
  deleteScheduleDetail: Scalars['Boolean']['output'];
  deleteScheduleDetails: Scalars['Boolean']['output'];
  deleteScheduledJob: Scalars['Boolean']['output'];
  deleteScheduledJobs: Scalars['Boolean']['output'];
  deleteSchedules: Scalars['Boolean']['output'];
  deleteServer: Scalars['Boolean']['output'];
  deleteServers: Scalars['Boolean']['output'];
  deleteSipUser: Scalars['Boolean']['output'];
  deleteSipUsers: Scalars['Boolean']['output'];
  deleteSystemLog: Scalars['Boolean']['output'];
  deleteSystemLogs: Scalars['Boolean']['output'];
  deleteTile: Scalars['Boolean']['output'];
  deleteTileSet: Scalars['Boolean']['output'];
  deleteTileSetType: Scalars['Boolean']['output'];
  deleteTileSetTypes: Scalars['Boolean']['output'];
  deleteTileSets: Scalars['Boolean']['output'];
  deleteTileViewModeBound: Scalars['Boolean']['output'];
  deleteTileViewModeBounds: Scalars['Boolean']['output'];
  deleteTiles: Scalars['Boolean']['output'];
  deleteTimeBasedRoute: Scalars['Boolean']['output'];
  deleteTimeBasedRoutes: Scalars['Boolean']['output'];
  deleteUser: Scalars['Boolean']['output'];
  deleteUserCallRecordingExtension: Scalars['Boolean']['output'];
  deleteUserCallRecordingExtensionGroup: Scalars['Boolean']['output'];
  deleteUserCallRecordingExtensionGroups: Scalars['Boolean']['output'];
  deleteUserCallRecordingExtensions: Scalars['Boolean']['output'];
  deleteUserLinksFromRole: Maybe<Scalars['Boolean']['output']>;
  deleteUserPreference: Scalars['Boolean']['output'];
  deleteUserPreferences: Scalars['Boolean']['output'];
  deleteUserPrivilege: Scalars['Boolean']['output'];
  deleteUserPrivileges: Scalars['Boolean']['output'];
  deleteUserPrivilegesFromUser: Maybe<Scalars['Boolean']['output']>;
  deleteUserReport: Scalars['Boolean']['output'];
  deleteUserReports: Scalars['Boolean']['output'];
  deleteUserRole: Scalars['Boolean']['output'];
  deleteUserRoles: Scalars['Boolean']['output'];
  deleteUsers: Scalars['Boolean']['output'];
  deleteWebhookRegistration: Scalars['Boolean']['output'];
  deleteWebhookRegistrationFromWebhookRegistration: Maybe<Scalars['Boolean']['output']>;
  deleteWebhookRegistrations: Scalars['Boolean']['output'];
  mailboxMessageChangedProcessing: Maybe<Scalars['Boolean']['output']>;
  mergeDepartments: Maybe<Scalars['Boolean']['output']>;
  rebootAccountPhones: Maybe<Scalars['Boolean']['output']>;
  rebootAllDevicesOnAccount: Maybe<Scalars['Boolean']['output']>;
  rebootDevices: Maybe<Scalars['Boolean']['output']>;
  resetElevatedAccountLogLevels: Maybe<Scalars['Boolean']['output']>;
  retryE911RegistrationsForNewPhoneNumbers: Maybe<Scalars['Boolean']['output']>;
  saveAccessToken: AccessToken;
  saveAccessTokenPrivilege: AccessTokenPrivilege;
  saveAccessTokenPrivileges: Array<AccessTokenPrivilege>;
  saveAccessTokens: Array<AccessToken>;
  saveAccount: Account;
  saveAccounts: Array<Account>;
  saveActiveCall: ActiveCall;
  saveActiveCallSegment: ActiveCallSegment;
  saveActiveCallSegments: Array<ActiveCallSegment>;
  saveActiveCalls: Array<ActiveCall>;
  saveAllowedIpAddress: AllowedIpAddress;
  saveAllowedIpAddresses: Array<AllowedIpAddress>;
  saveAutoAttendantKey: AutoAttendantKey;
  saveAutoAttendantKeys: Array<AutoAttendantKey>;
  saveAutoAttendantPrompt: AutoAttendantPrompt;
  saveAutoAttendantPrompts: Array<AutoAttendantPrompt>;
  saveBannedProvisioningIp: BannedProvisioningIp;
  saveBannedProvisioningIps: Array<BannedProvisioningIp>;
  saveBaseStationHandset: BaseStationHandset;
  saveBaseStationHandsets: Array<BaseStationHandset>;
  saveBlockedIpAddress: BlockedIpAddress;
  saveBlockedIpAddresses: Array<BlockedIpAddress>;
  saveBlockedPhoneNumber: BlockedPhoneNumber;
  saveBlockedPhoneNumbers: Array<BlockedPhoneNumber>;
  saveCallDetail: CallDetail;
  saveCallDetailAppsuiteChannel: CallDetailAppsuiteChannel;
  saveCallDetailAppsuiteChannels: Array<CallDetailAppsuiteChannel>;
  saveCallDetails: Array<CallDetail>;
  saveCallParkingLot: CallParkingLot;
  saveCallParkingLots: Array<CallParkingLot>;
  saveCallRecording: CallRecording;
  saveCallRecordingCallDetail: CallRecordingCallDetail;
  saveCallRecordingCallDetails: Array<CallRecordingCallDetail>;
  saveCallRecordings: Array<CallRecording>;
  saveCallSegment: CallSegment;
  saveCallSegments: Array<CallSegment>;
  saveClosedException: ClosedException;
  saveClosedExceptions: Array<ClosedException>;
  saveCronJob: CronJob;
  saveCronJobExecution: CronJobExecution;
  saveCronJobExecutions: Array<CronJobExecution>;
  saveCronJobs: Array<CronJob>;
  saveDashboard: Dashboard;
  saveDashboardTile: DashboardTile;
  saveDashboardTileEntityParameter: DashboardTileEntityParameter;
  saveDashboardTileEntityParameterValue: DashboardTileEntityParameterValue;
  saveDashboardTileEntityParameterValues: Array<DashboardTileEntityParameterValue>;
  saveDashboardTileEntityParameters: Array<DashboardTileEntityParameter>;
  saveDashboardTileLayoutConfiguration: DashboardTileLayoutConfiguration;
  saveDashboardTileLayoutConfigurations: Array<DashboardTileLayoutConfiguration>;
  saveDashboardTileParameter: DashboardTileParameter;
  saveDashboardTileParameterDateRange: DashboardTileParameterDateRange;
  saveDashboardTileParameterDateRanges: Array<DashboardTileParameterDateRange>;
  saveDashboardTileParameters: Array<DashboardTileParameter>;
  saveDashboardTiles: Array<DashboardTile>;
  saveDashboards: Array<Dashboard>;
  saveDepartment: Department;
  saveDepartmentExtension: DepartmentExtension;
  saveDepartmentExtensions: Array<DepartmentExtension>;
  saveDepartments: Array<Department>;
  saveDevice: Device;
  saveDevices: Array<Device>;
  saveExtension: Extension;
  saveExtensionAutoAttendant: ExtensionAutoAttendant;
  saveExtensionAutoAttendants: Array<ExtensionAutoAttendant>;
  saveExtensionExternalForward: ExtensionExternalForward;
  saveExtensionExternalForwards: Array<ExtensionExternalForward>;
  saveExtensionFax: ExtensionFax;
  saveExtensionFaxes: Array<ExtensionFax>;
  saveExtensionFmFm: ExtensionFmFm;
  saveExtensionFmFms: Array<ExtensionFmFm>;
  saveExtensionGroup: ExtensionGroup;
  saveExtensionGroupExtension: ExtensionGroupExtension;
  saveExtensionGroupExtensions: Array<ExtensionGroupExtension>;
  saveExtensionGroupSupervisee: ExtensionGroupSupervisee;
  saveExtensionGroupSupervisees: Array<ExtensionGroupSupervisee>;
  saveExtensionGroups: Array<ExtensionGroup>;
  saveExtensionHuntGroup: ExtensionHuntGroup;
  saveExtensionHuntGroups: Array<ExtensionHuntGroup>;
  saveExtensionMailbox: ExtensionMailbox;
  saveExtensionMailboxes: Array<ExtensionMailbox>;
  saveExtensionPagingGroup: ExtensionPagingGroup;
  saveExtensionPagingGroups: Array<ExtensionPagingGroup>;
  saveExtensionPhone: ExtensionPhone;
  saveExtensionPhones: Array<ExtensionPhone>;
  saveExtensionQueue: ExtensionQueue;
  saveExtensionQueues: Array<ExtensionQueue>;
  saveExtensionSupervisee: ExtensionSupervisee;
  saveExtensionSupervisees: Array<ExtensionSupervisee>;
  saveExtensions: Array<Extension>;
  saveExternalNumberHistories: Array<ExternalNumberHistory>;
  saveExternalNumberHistory: ExternalNumberHistory;
  saveFax: Fax;
  saveFaxAttachment: FaxAttachment;
  saveFaxAttachments: Array<FaxAttachment>;
  saveFaxEmailAddress: FaxEmailAddress;
  saveFaxEmailAddresses: Array<FaxEmailAddress>;
  saveFaxes: Array<Fax>;
  saveFile: File;
  saveFileDepot: FileDepot;
  saveFileDepots: Array<FileDepot>;
  saveFiles: Array<File>;
  saveFmFmStep: FmFmStep;
  saveFmFmStepExtension: FmFmStepExtension;
  saveFmFmStepExtensions: Array<FmFmStepExtension>;
  saveFmFmStepPhoneNumber: FmFmStepPhoneNumber;
  saveFmFmStepPhoneNumbers: Array<FmFmStepPhoneNumber>;
  saveFmFmSteps: Array<FmFmStep>;
  saveHuntGroupExtensionGroup: HuntGroupExtensionGroup;
  saveHuntGroupExtensionGroups: Array<HuntGroupExtensionGroup>;
  saveHuntGroupMember: HuntGroupMember;
  saveHuntGroupMembers: Array<HuntGroupMember>;
  saveLocation: Location;
  saveLocations: Array<Location>;
  saveMailbox: Mailbox;
  saveMailboxMessage: MailboxMessage;
  saveMailboxMessages: Array<MailboxMessage>;
  saveMailboxes: Array<Mailbox>;
  saveNote: Note;
  saveNotes: Array<Note>;
  saveOpenSipsFraudLog: OpenSipsFraudLog;
  saveOpenSipsFraudLogs: Array<OpenSipsFraudLog>;
  saveOpenSipsFraudWhitelist: OpenSipsFraudWhitelist;
  saveOpenSipsFraudWhitelists: Array<OpenSipsFraudWhitelist>;
  saveOpenSipsMismatchedContactAndFromLog: OpenSipsMismatchedContactAndFromLog;
  saveOpenSipsMismatchedContactAndFromLogs: Array<OpenSipsMismatchedContactAndFromLog>;
  saveOpenSipsViaLog: OpenSipsViaLog;
  saveOpenSipsViaLogs: Array<OpenSipsViaLog>;
  saveOpenSipsZoiperProWhitelist: OpenSipsZoiperProWhitelist;
  saveOpenSipsZoiperProWhitelists: Array<OpenSipsZoiperProWhitelist>;
  saveOpensipsHardPhoneWhiteList: OpensipsHardPhoneWhiteList;
  saveOpensipsHardPhoneWhiteLists: Array<OpensipsHardPhoneWhiteList>;
  savePagingGroupExtensionGroup: PagingGroupExtensionGroup;
  savePagingGroupExtensionGroups: Array<PagingGroupExtensionGroup>;
  savePagingGroupMember: PagingGroupMember;
  savePagingGroupMembers: Array<PagingGroupMember>;
  savePhone: Phone;
  savePhoneNumber: PhoneNumber;
  savePhoneNumbers: Array<PhoneNumber>;
  savePhones: Array<Phone>;
  savePreferencesForUser: Maybe<Array<Scalars['UInt']['output']>>;
  savePrompt: Prompt;
  savePromptFromStasisForPrompt: Maybe<Array<Scalars['UInt']['output']>>;
  savePrompts: Array<Prompt>;
  saveProviderCallRate: ProviderCallRate;
  saveProviderCallRates: Array<ProviderCallRate>;
  saveQueueAgentDial: QueueAgentDial;
  saveQueueAgentDials: Array<QueueAgentDial>;
  saveQueueAgentLogin: QueueAgentLogin;
  saveQueueAgentLogins: Array<QueueAgentLogin>;
  saveQueueCallbackDial: QueueCallbackDial;
  saveQueueCallbackDials: Array<QueueCallbackDial>;
  saveQueueExtensionGroup: QueueExtensionGroup;
  saveQueueExtensionGroups: Array<QueueExtensionGroup>;
  saveQueueExtensionStatus: QueueExtensionStatus;
  saveQueueExtensionStatuses: Array<QueueExtensionStatus>;
  saveQueueHistories: Array<QueueHistory>;
  saveQueueHistory: QueueHistory;
  saveQueueHistoryCallDetail: QueueHistoryCallDetail;
  saveQueueHistoryCallDetails: Array<QueueHistoryCallDetail>;
  saveQueueLog: QueueLog;
  saveQueueLogs: Array<QueueLog>;
  saveQueueMember: QueueMember;
  saveQueueMembers: Array<QueueMember>;
  saveQueuePeriodicAnnouncement: QueuePeriodicAnnouncement;
  saveQueuePeriodicAnnouncements: Array<QueuePeriodicAnnouncement>;
  saveRM12Client: Rm12Client;
  saveRM12Clients: Array<Rm12Client>;
  saveRm12ClientToken: Rm12ClientToken;
  saveRm12ClientTokens: Array<Rm12ClientToken>;
  saveRole: Role;
  saveRoleCallRecordingExtension: RoleCallRecordingExtension;
  saveRoleCallRecordingExtensionGroup: RoleCallRecordingExtensionGroup;
  saveRoleCallRecordingExtensionGroups: Array<RoleCallRecordingExtensionGroup>;
  saveRoleCallRecordingExtensions: Array<RoleCallRecordingExtension>;
  saveRoleLinksForUser: Maybe<Array<Scalars['UInt']['output']>>;
  saveRolePrivilege: RolePrivilege;
  saveRolePrivileges: Array<RolePrivilege>;
  saveRolePrivilegesForRole: Maybe<Array<Scalars['UInt']['output']>>;
  saveRoleReport: RoleReport;
  saveRoleReports: Array<RoleReport>;
  saveRoleReportsForRole: Maybe<Array<Scalars['UInt']['output']>>;
  saveRoles: Array<Role>;
  saveSchedule: Schedule;
  saveScheduleDetail: ScheduleDetail;
  saveScheduleDetails: Array<ScheduleDetail>;
  saveScheduledJob: ScheduledJob;
  saveScheduledJobs: Array<ScheduledJob>;
  saveSchedules: Array<Schedule>;
  saveServer: Server;
  saveServers: Array<Server>;
  saveSipUser: SipUser;
  saveSipUsers: Array<SipUser>;
  saveSystemLog: SystemLog;
  saveSystemLogs: Array<SystemLog>;
  saveTile: Tile;
  saveTileSet: TileSet;
  saveTileSetType: TileSetType;
  saveTileSetTypes: Array<TileSetType>;
  saveTileSets: Array<TileSet>;
  saveTileViewModeBound: TileViewModeBound;
  saveTileViewModeBounds: Array<TileViewModeBound>;
  saveTiles: Array<Tile>;
  saveTimeBasedRoute: TimeBasedRoute;
  saveTimeBasedRoutes: Array<TimeBasedRoute>;
  saveUser: User;
  saveUserCallRecordingExtension: UserCallRecordingExtension;
  saveUserCallRecordingExtensionGroup: UserCallRecordingExtensionGroup;
  saveUserCallRecordingExtensionGroups: Array<UserCallRecordingExtensionGroup>;
  saveUserCallRecordingExtensions: Array<UserCallRecordingExtension>;
  saveUserLinksForRole: Maybe<Array<Scalars['UInt']['output']>>;
  saveUserPreference: UserPreference;
  saveUserPreferences: Array<UserPreference>;
  saveUserPrivilege: UserPrivilege;
  saveUserPrivileges: Array<UserPrivilege>;
  saveUserPrivilegesForUser: Maybe<Array<Scalars['UInt']['output']>>;
  saveUserReport: UserReport;
  saveUserReports: Array<UserReport>;
  saveUserRole: UserRole;
  saveUserRoles: Array<UserRole>;
  saveUsers: Array<User>;
  saveWebhookRegistration: WebhookRegistration;
  saveWebhookRegistrations: Array<WebhookRegistration>;
  sendUserPasswordResetRequest: Maybe<Scalars['Boolean']['output']>;
  setIsOtrEnabledOffForExtensions: Maybe<Scalars['Boolean']['output']>;
  updateConfigurationFromParameters: Maybe<Scalars['Boolean']['output']>;
}


export interface RootMutationAppSuiteWakeupEventArgs {
  accountShortName?: InputMaybe<Scalars['String']['input']>;
  callDetailId: Scalars['UInt']['input'];
  callerChannelId?: InputMaybe<Scalars['String']['input']>;
  callerName?: InputMaybe<Scalars['String']['input']>;
  extensionId: Scalars['UInt']['input'];
}


export interface RootMutationCleanUpCallsForCrashedAsteriskPodArgs {
  podName?: InputMaybe<Scalars['String']['input']>;
}


export interface RootMutationClearArgs {
  departmentId: Scalars['UInt']['input'];
}


export interface RootMutationCombineVoicemailAndCallRecordingFilesArgs {
  mailboxMessage: MailboxMessageInput;
}


export interface RootMutationContactFromMismatchAlertArgs {
  request: OpenSipsMismatchedContactAndFromLogInput;
}


export interface RootMutationDeleteAccessTokenArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteAccessTokenPrivilegeArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteAccessTokenPrivilegesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteAccessTokensArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteAccountArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteAccountsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteActiveCallArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteActiveCallSegmentArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteActiveCallSegmentsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteActiveCallsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteAllowedIpAddressArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteAllowedIpAddressesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteAutoAttendantKeyArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteAutoAttendantKeysArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteAutoAttendantPromptArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteAutoAttendantPromptsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteAzureActiveDirectoryConfigurationArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteAzureActiveDirectoryConfigurationsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteBannedProvisioningIpArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['Int']['input']>;
}


export interface RootMutationDeleteBannedProvisioningIpsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['Int']['input']>;
}


export interface RootMutationDeleteBaseStationHandsetArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteBaseStationHandsetsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteBlockedIpAddressArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteBlockedIpAddressesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteBlockedPhoneNumberArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteBlockedPhoneNumbersArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteCallDetailArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteCallDetailAppsuiteChannelArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteCallDetailAppsuiteChannelsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteCallDetailsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteCallParkingLotArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteCallParkingLotsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteCallRecordingArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteCallRecordingCallDetailArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteCallRecordingCallDetailsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteCallRecordingsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteCallSegmentArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteCallSegmentsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteClosedExceptionArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteClosedExceptionsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteCronJobArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteCronJobExecutionArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteCronJobExecutionsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteCronJobsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteDashboardArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteDashboardTileArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteDashboardTileEntityParameterArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteDashboardTileEntityParameterValueArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteDashboardTileEntityParameterValuesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteDashboardTileEntityParametersArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteDashboardTileLayoutConfigurationArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteDashboardTileLayoutConfigurationsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteDashboardTileParameterArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteDashboardTileParameterDateRangeArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteDashboardTileParameterDateRangesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteDashboardTileParametersArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteDashboardTilesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteDashboardsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteDepartmentArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteDepartmentExtensionArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteDepartmentExtensionsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteDepartmentsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteDeviceArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteDevicesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExtensionArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExtensionAutoAttendantArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExtensionAutoAttendantsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExtensionExternalForwardArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExtensionExternalForwardsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExtensionFaxArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExtensionFaxesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExtensionFmFmArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExtensionFmFmsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExtensionGroupArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExtensionGroupExtensionArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExtensionGroupExtensionsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExtensionGroupSuperviseeArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExtensionGroupSuperviseesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExtensionGroupsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExtensionHuntGroupArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExtensionHuntGroupsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExtensionMailboxArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExtensionMailboxesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExtensionPagingGroupArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExtensionPagingGroupsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExtensionPhoneArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExtensionPhonesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExtensionQueueArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExtensionQueuesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExtensionSuperviseeArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExtensionSuperviseesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExtensionsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExternalNumberHistoriesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteExternalNumberHistoryArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteFaxArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteFaxAttachmentArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteFaxAttachmentsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteFaxEmailAddressArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteFaxEmailAddressesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteFaxesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteFileArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteFileDepotArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteFileDepotsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteFilesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteFmFmStepArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteFmFmStepExtensionArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteFmFmStepExtensionsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteFmFmStepPhoneNumberArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteFmFmStepPhoneNumbersArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteFmFmStepsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteHuntGroupExtensionGroupArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteHuntGroupExtensionGroupsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteHuntGroupMemberArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteHuntGroupMembersArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteLocationArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteLocationsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteMailboxArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteMailboxMessageArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteMailboxMessagesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteMailboxesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteNoteArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteNotesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteOpenSipsFraudLogArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteOpenSipsFraudLogsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteOpenSipsFraudWhitelistArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteOpenSipsFraudWhitelistsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteOpenSipsMismatchedContactAndFromLogArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteOpenSipsMismatchedContactAndFromLogsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteOpenSipsViaLogArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteOpenSipsViaLogsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteOpenSipsZoiperProWhitelistArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteOpenSipsZoiperProWhitelistsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteOpensipsHardPhoneWhiteListArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteOpensipsHardPhoneWhiteListsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeletePagingGroupExtensionGroupArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeletePagingGroupExtensionGroupsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeletePagingGroupMemberArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeletePagingGroupMembersArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteParametersFromDashboardTileArgs {
  dashboardTileIds: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeletePhoneArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeletePhoneNumberArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeletePhoneNumbersArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeletePhonesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeletePromptArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeletePromptsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteProviderCallRateArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['Int']['input']>;
}


export interface RootMutationDeleteProviderCallRatesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['Int']['input']>;
}


export interface RootMutationDeleteQueueAgentDialArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteQueueAgentDialsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteQueueAgentLoginArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteQueueAgentLoginsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteQueueCallbackDialArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteQueueCallbackDialsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteQueueExtensionGroupArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteQueueExtensionGroupsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteQueueExtensionStatusArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteQueueExtensionStatusesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteQueueHistoriesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteQueueHistoryArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteQueueHistoryCallDetailArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteQueueHistoryCallDetailsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteQueueLogArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteQueueLogsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteQueueMemberArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteQueueMembersArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteQueuePeriodicAnnouncementArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteQueuePeriodicAnnouncementsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteRm12ClientArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteRm12ClientsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteRm12ClientTokenArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteRm12ClientTokensArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteRoleArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteRoleCallRecordingExtensionArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteRoleCallRecordingExtensionGroupArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteRoleCallRecordingExtensionGroupsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteRoleCallRecordingExtensionsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteRoleLinksFromUserArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  itemIds: Array<Scalars['UInt']['input']>;
  userId: Scalars['UInt']['input'];
}


export interface RootMutationDeleteRolePrivilegeArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteRolePrivilegesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteRolePrivilegesFromRoleArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  itemIds: Array<Scalars['UInt']['input']>;
  roleId: Scalars['UInt']['input'];
}


export interface RootMutationDeleteRoleReportArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteRoleReportsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteRoleReportsFromRoleArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  roleId: Scalars['UInt']['input'];
  roleReportIds: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteRolesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteScheduleArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteScheduleDetailArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteScheduleDetailsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteScheduledJobArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteScheduledJobsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteSchedulesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteServerArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteServersArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteSipUserArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteSipUsersArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteSystemLogArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteSystemLogsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteTileArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteTileSetArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteTileSetTypeArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteTileSetTypesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteTileSetsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteTileViewModeBoundArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['Int']['input']>;
}


export interface RootMutationDeleteTileViewModeBoundsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['Int']['input']>;
}


export interface RootMutationDeleteTilesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteTimeBasedRouteArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteTimeBasedRoutesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteUserArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['Int']['input']>;
}


export interface RootMutationDeleteUserCallRecordingExtensionArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteUserCallRecordingExtensionGroupArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteUserCallRecordingExtensionGroupsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteUserCallRecordingExtensionsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteUserLinksFromRoleArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  itemIds: Array<Scalars['UInt']['input']>;
  roleId: Scalars['UInt']['input'];
}


export interface RootMutationDeleteUserPreferenceArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteUserPreferencesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteUserPrivilegeArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteUserPrivilegesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteUserPrivilegesFromUserArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  itemIds: Array<Scalars['UInt']['input']>;
  userId: Scalars['Int']['input'];
}


export interface RootMutationDeleteUserReportArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteUserReportsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteUserRoleArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteUserRolesArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteUsersArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['Int']['input']>;
}


export interface RootMutationDeleteWebhookRegistrationArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootMutationDeleteWebhookRegistrationFromWebhookRegistrationArgs {
  currentUserAccountId?: InputMaybe<Scalars['UInt']['input']>;
  request: WebhookRegistrationRequestInput;
}


export interface RootMutationDeleteWebhookRegistrationsArgs {
  deleteOptions?: InputMaybe<Array<DeleteOption>>;
  ids: Array<Scalars['UInt']['input']>;
}


export interface RootMutationMailboxMessageChangedProcessingArgs {
  mailboxId: Scalars['UInt']['input'];
}


export interface RootMutationMergeDepartmentsArgs {
  destinationDepartmentId: Scalars['UInt']['input'];
  sourceDepartmentId: Scalars['UInt']['input'];
}


export interface RootMutationRebootAccountPhonesArgs {
  accountId: Scalars['UInt']['input'];
}


export interface RootMutationRebootAllDevicesOnAccountArgs {
  accountId: Scalars['UInt']['input'];
}


export interface RootMutationRebootDevicesArgs {
  deviceIds: Array<Scalars['UInt']['input']>;
}


export interface RootMutationSaveAccessTokenArgs {
  accessToken: AccessTokenInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveAccessTokenPrivilegeArgs {
  accessTokenPrivilege: AccessTokenPrivilegeInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveAccessTokenPrivilegesArgs {
  accessTokenPrivileges: Array<AccessTokenPrivilegeInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveAccessTokensArgs {
  accessTokens: Array<AccessTokenInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveAccountArgs {
  account: AccountInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveAccountsArgs {
  accounts: Array<AccountInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveActiveCallArgs {
  activeCall: ActiveCallInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveActiveCallSegmentArgs {
  activeCallSegment: ActiveCallSegmentInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveActiveCallSegmentsArgs {
  activeCallSegments: Array<ActiveCallSegmentInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveActiveCallsArgs {
  activeCalls: Array<ActiveCallInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveAllowedIpAddressArgs {
  allowedIpAddress: AllowedIpAddressInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveAllowedIpAddressesArgs {
  allowedIpAddresses: Array<AllowedIpAddressInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveAutoAttendantKeyArgs {
  autoAttendantKey: AutoAttendantKeyInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveAutoAttendantKeysArgs {
  autoAttendantKeys: Array<AutoAttendantKeyInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveAutoAttendantPromptArgs {
  autoAttendantPrompt: AutoAttendantPromptInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveAutoAttendantPromptsArgs {
  autoAttendantPrompts: Array<AutoAttendantPromptInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveBannedProvisioningIpArgs {
  bannedProvisioningIp: BannedProvisioningIpInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveBannedProvisioningIpsArgs {
  bannedProvisioningIps: Array<BannedProvisioningIpInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveBaseStationHandsetArgs {
  baseStationHandset: BaseStationHandsetInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveBaseStationHandsetsArgs {
  baseStationHandsets: Array<BaseStationHandsetInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveBlockedIpAddressArgs {
  blockedIpAddress: BlockedIpAddressInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveBlockedIpAddressesArgs {
  blockedIpAddresses: Array<BlockedIpAddressInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveBlockedPhoneNumberArgs {
  blockedPhoneNumber: BlockedPhoneNumberInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveBlockedPhoneNumbersArgs {
  blockedPhoneNumbers: Array<BlockedPhoneNumberInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveCallDetailArgs {
  callDetail: CallDetailInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveCallDetailAppsuiteChannelArgs {
  callDetailAppsuiteChannel: CallDetailAppsuiteChannelInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveCallDetailAppsuiteChannelsArgs {
  callDetailAppsuiteChannels: Array<CallDetailAppsuiteChannelInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveCallDetailsArgs {
  callDetails: Array<CallDetailInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveCallParkingLotArgs {
  callParkingLot: CallParkingLotInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveCallParkingLotsArgs {
  callParkingLots: Array<CallParkingLotInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveCallRecordingArgs {
  callRecording: CallRecordingInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveCallRecordingCallDetailArgs {
  callRecordingCallDetail: CallRecordingCallDetailInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveCallRecordingCallDetailsArgs {
  callRecordingCallDetails: Array<CallRecordingCallDetailInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveCallRecordingsArgs {
  callRecordings: Array<CallRecordingInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveCallSegmentArgs {
  callSegment: CallSegmentInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveCallSegmentsArgs {
  callSegments: Array<CallSegmentInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveClosedExceptionArgs {
  closedException: ClosedExceptionInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveClosedExceptionsArgs {
  closedExceptions: Array<ClosedExceptionInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveCronJobArgs {
  cronJob: CronJobInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveCronJobExecutionArgs {
  cronJobExecution: CronJobExecutionInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveCronJobExecutionsArgs {
  cronJobExecutions: Array<CronJobExecutionInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveCronJobsArgs {
  cronJobs: Array<CronJobInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveDashboardArgs {
  dashboard: DashboardInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveDashboardTileArgs {
  dashboardTile: DashboardTileInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveDashboardTileEntityParameterArgs {
  dashboardTileEntityParameter: DashboardTileEntityParameterInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveDashboardTileEntityParameterValueArgs {
  dashboardTileEntityParameterValue: DashboardTileEntityParameterValueInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveDashboardTileEntityParameterValuesArgs {
  dashboardTileEntityParameterValues: Array<DashboardTileEntityParameterValueInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveDashboardTileEntityParametersArgs {
  dashboardTileEntityParameters: Array<DashboardTileEntityParameterInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveDashboardTileLayoutConfigurationArgs {
  dashboardTileLayoutConfiguration: DashboardTileLayoutConfigurationInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveDashboardTileLayoutConfigurationsArgs {
  dashboardTileLayoutConfigurations: Array<DashboardTileLayoutConfigurationInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveDashboardTileParameterArgs {
  dashboardTileParameter: DashboardTileParameterInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveDashboardTileParameterDateRangeArgs {
  dashboardTileParameterDateRange: DashboardTileParameterDateRangeInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveDashboardTileParameterDateRangesArgs {
  dashboardTileParameterDateRanges: Array<DashboardTileParameterDateRangeInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveDashboardTileParametersArgs {
  dashboardTileParameters: Array<DashboardTileParameterInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveDashboardTilesArgs {
  dashboardTiles: Array<DashboardTileInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveDashboardsArgs {
  dashboards: Array<DashboardInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveDepartmentArgs {
  department: DepartmentInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveDepartmentExtensionArgs {
  departmentExtension: DepartmentExtensionInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveDepartmentExtensionsArgs {
  departmentExtensions: Array<DepartmentExtensionInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveDepartmentsArgs {
  departments: Array<DepartmentInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveDeviceArgs {
  device: DeviceInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveDevicesArgs {
  devices: Array<DeviceInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExtensionArgs {
  extension: ExtensionInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExtensionAutoAttendantArgs {
  extensionAutoAttendant: ExtensionAutoAttendantInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExtensionAutoAttendantsArgs {
  extensionAutoAttendants: Array<ExtensionAutoAttendantInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExtensionExternalForwardArgs {
  extensionExternalForward: ExtensionExternalForwardInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExtensionExternalForwardsArgs {
  extensionExternalForwards: Array<ExtensionExternalForwardInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExtensionFaxArgs {
  extensionFax: ExtensionFaxInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExtensionFaxesArgs {
  extensionFaxes: Array<ExtensionFaxInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExtensionFmFmArgs {
  extensionFmFm: ExtensionFmFmInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExtensionFmFmsArgs {
  extensionFmFms: Array<ExtensionFmFmInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExtensionGroupArgs {
  extensionGroup: ExtensionGroupInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExtensionGroupExtensionArgs {
  extensionGroupExtension: ExtensionGroupExtensionInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExtensionGroupExtensionsArgs {
  extensionGroupExtensions: Array<ExtensionGroupExtensionInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExtensionGroupSuperviseeArgs {
  extensionGroupSupervisee: ExtensionGroupSuperviseeInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExtensionGroupSuperviseesArgs {
  extensionGroupSupervisees: Array<ExtensionGroupSuperviseeInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExtensionGroupsArgs {
  extensionGroups: Array<ExtensionGroupInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExtensionHuntGroupArgs {
  extensionHuntGroup: ExtensionHuntGroupInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExtensionHuntGroupsArgs {
  extensionHuntGroups: Array<ExtensionHuntGroupInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExtensionMailboxArgs {
  extensionMailbox: ExtensionMailboxInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExtensionMailboxesArgs {
  extensionMailboxes: Array<ExtensionMailboxInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExtensionPagingGroupArgs {
  extensionPagingGroup: ExtensionPagingGroupInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExtensionPagingGroupsArgs {
  extensionPagingGroups: Array<ExtensionPagingGroupInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExtensionPhoneArgs {
  extensionPhone: ExtensionPhoneInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExtensionPhonesArgs {
  extensionPhones: Array<ExtensionPhoneInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExtensionQueueArgs {
  extensionQueue: ExtensionQueueInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExtensionQueuesArgs {
  extensionQueues: Array<ExtensionQueueInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExtensionSuperviseeArgs {
  extensionSupervisee: ExtensionSuperviseeInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExtensionSuperviseesArgs {
  extensionSupervisees: Array<ExtensionSuperviseeInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExtensionsArgs {
  extensions: Array<ExtensionInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExternalNumberHistoriesArgs {
  externalNumberHistories: Array<ExternalNumberHistoryInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveExternalNumberHistoryArgs {
  externalNumberHistory: ExternalNumberHistoryInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveFaxArgs {
  fax: FaxInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveFaxAttachmentArgs {
  faxAttachment: FaxAttachmentInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveFaxAttachmentsArgs {
  faxAttachments: Array<FaxAttachmentInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveFaxEmailAddressArgs {
  faxEmailAddress: FaxEmailAddressInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveFaxEmailAddressesArgs {
  faxEmailAddresses: Array<FaxEmailAddressInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveFaxesArgs {
  faxes: Array<FaxInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveFileArgs {
  file: FileInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveFileDepotArgs {
  fileDepot: FileDepotInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveFileDepotsArgs {
  fileDepots: Array<FileDepotInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveFilesArgs {
  files: Array<FileInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveFmFmStepArgs {
  fmFmStep: FmFmStepInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveFmFmStepExtensionArgs {
  fmFmStepExtension: FmFmStepExtensionInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveFmFmStepExtensionsArgs {
  fmFmStepExtensions: Array<FmFmStepExtensionInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveFmFmStepPhoneNumberArgs {
  fmFmStepPhoneNumber: FmFmStepPhoneNumberInput;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveFmFmStepPhoneNumbersArgs {
  fmFmStepPhoneNumbers: Array<FmFmStepPhoneNumberInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveFmFmStepsArgs {
  fmFmSteps: Array<FmFmStepInput>;
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveHuntGroupExtensionGroupArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  huntGroupExtensionGroup: HuntGroupExtensionGroupInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveHuntGroupExtensionGroupsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  huntGroupExtensionGroups: Array<HuntGroupExtensionGroupInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveHuntGroupMemberArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  huntGroupMember: HuntGroupMemberInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveHuntGroupMembersArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  huntGroupMembers: Array<HuntGroupMemberInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveLocationArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  location: LocationInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveLocationsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  locations: Array<LocationInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveMailboxArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  mailbox: MailboxPostInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveMailboxMessageArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  mailboxMessage: MailboxMessageInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveMailboxMessagesArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  mailboxMessages: Array<MailboxMessageInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveMailboxesArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  mailboxes: Array<MailboxPostInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveNoteArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  note: NoteInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveNotesArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  notes: Array<NoteInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveOpenSipsFraudLogArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  openSipsFraudLog: OpenSipsFraudLogInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveOpenSipsFraudLogsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  openSipsFraudLogs: Array<OpenSipsFraudLogInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveOpenSipsFraudWhitelistArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  openSipsFraudWhitelist: OpenSipsFraudWhitelistInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveOpenSipsFraudWhitelistsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  openSipsFraudWhitelists: Array<OpenSipsFraudWhitelistInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveOpenSipsMismatchedContactAndFromLogArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  openSipsMismatchedContactAndFromLog: OpenSipsMismatchedContactAndFromLogInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveOpenSipsMismatchedContactAndFromLogsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  openSipsMismatchedContactAndFromLogs: Array<OpenSipsMismatchedContactAndFromLogInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveOpenSipsViaLogArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  openSipsViaLog: OpenSipsViaLogInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveOpenSipsViaLogsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  openSipsViaLogs: Array<OpenSipsViaLogInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveOpenSipsZoiperProWhitelistArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  openSipsZoiperProWhitelist: OpenSipsZoiperProWhitelistInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveOpenSipsZoiperProWhitelistsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  openSipsZoiperProWhitelists: Array<OpenSipsZoiperProWhitelistInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveOpensipsHardPhoneWhiteListArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  opensipsHardPhoneWhiteList: OpensipsHardPhoneWhiteListInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveOpensipsHardPhoneWhiteListsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  opensipsHardPhoneWhiteLists: Array<OpensipsHardPhoneWhiteListInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSavePagingGroupExtensionGroupArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  pagingGroupExtensionGroup: PagingGroupExtensionGroupInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSavePagingGroupExtensionGroupsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  pagingGroupExtensionGroups: Array<PagingGroupExtensionGroupInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSavePagingGroupMemberArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  pagingGroupMember: PagingGroupMemberInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSavePagingGroupMembersArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  pagingGroupMembers: Array<PagingGroupMemberInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSavePhoneArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  phone: PhoneInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSavePhoneNumberArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  phoneNumber: PhoneNumberInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSavePhoneNumbersArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  phoneNumbers: Array<PhoneNumberInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSavePhonesArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  phones: Array<PhoneInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSavePreferencesForUserArgs {
  items: Array<UserPreferenceInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  userId: Scalars['Int']['input'];
}


export interface RootMutationSavePromptArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  prompt: PromptInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSavePromptFromStasisForPromptArgs {
  prompt: Array<PromptInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
}


export interface RootMutationSavePromptsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  prompts: Array<PromptInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveProviderCallRateArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  providerCallRate: ProviderCallRateInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveProviderCallRatesArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  providerCallRates: Array<ProviderCallRateInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveQueueAgentDialArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  queueAgentDial: QueueAgentDialInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveQueueAgentDialsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  queueAgentDials: Array<QueueAgentDialInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveQueueAgentLoginArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  queueAgentLogin: QueueAgentLoginInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveQueueAgentLoginsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  queueAgentLogins: Array<QueueAgentLoginInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveQueueCallbackDialArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  queueCallbackDial: QueueCallbackDialInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveQueueCallbackDialsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  queueCallbackDials: Array<QueueCallbackDialInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveQueueExtensionGroupArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  queueExtensionGroup: QueueExtensionGroupInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveQueueExtensionGroupsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  queueExtensionGroups: Array<QueueExtensionGroupInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveQueueExtensionStatusArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  queueExtensionStatus: QueueExtensionStatusInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveQueueExtensionStatusesArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  queueExtensionStatuses: Array<QueueExtensionStatusInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveQueueHistoriesArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  queueHistories: Array<QueueHistoryInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveQueueHistoryArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  queueHistory: QueueHistoryInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveQueueHistoryCallDetailArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  queueHistoryCallDetail: QueueHistoryCallDetailInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveQueueHistoryCallDetailsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  queueHistoryCallDetails: Array<QueueHistoryCallDetailInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveQueueLogArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  queueLog: QueueLogInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveQueueLogsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  queueLogs: Array<QueueLogInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveQueueMemberArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  queueMember: QueueMemberInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveQueueMembersArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  queueMembers: Array<QueueMemberInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveQueuePeriodicAnnouncementArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  queuePeriodicAnnouncement: QueuePeriodicAnnouncementInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveQueuePeriodicAnnouncementsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  queuePeriodicAnnouncements: Array<QueuePeriodicAnnouncementInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveRm12ClientArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  rM12Client: Rm12ClientInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveRm12ClientsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  rM12Clients: Array<Rm12ClientInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveRm12ClientTokenArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  rm12ClientToken: Rm12ClientTokenInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveRm12ClientTokensArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  rm12ClientTokens: Array<Rm12ClientTokenInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveRoleArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  role: RoleInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveRoleCallRecordingExtensionArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  roleCallRecordingExtension: RoleCallRecordingExtensionInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveRoleCallRecordingExtensionGroupArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  roleCallRecordingExtensionGroup: RoleCallRecordingExtensionGroupInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveRoleCallRecordingExtensionGroupsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  roleCallRecordingExtensionGroups: Array<RoleCallRecordingExtensionGroupInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveRoleCallRecordingExtensionsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  roleCallRecordingExtensions: Array<RoleCallRecordingExtensionInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveRoleLinksForUserArgs {
  items: Array<UserRoleInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  userId: Scalars['Int']['input'];
}


export interface RootMutationSaveRolePrivilegeArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  rolePrivilege: RolePrivilegeInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveRolePrivilegesArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  rolePrivileges: Array<RolePrivilegeInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveRolePrivilegesForRoleArgs {
  items: Array<RolePrivilegeInput>;
  roleId: Scalars['UInt']['input'];
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveRoleReportArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  roleReport: RoleReportInput;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveRoleReportsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  roleReports: Array<RoleReportInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveRoleReportsForRoleArgs {
  items: Array<RoleReportInput>;
  roleId: Scalars['UInt']['input'];
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveRolesArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  roles: Array<RoleInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveScheduleArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  schedule: ScheduleInput;
}


export interface RootMutationSaveScheduleDetailArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  scheduleDetail: ScheduleDetailInput;
}


export interface RootMutationSaveScheduleDetailsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  scheduleDetails: Array<ScheduleDetailInput>;
}


export interface RootMutationSaveScheduledJobArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  scheduledJob: ScheduledJobInput;
}


export interface RootMutationSaveScheduledJobsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  scheduledJobs: Array<ScheduledJobInput>;
}


export interface RootMutationSaveSchedulesArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  schedules: Array<ScheduleInput>;
}


export interface RootMutationSaveServerArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  server: ServerInput;
}


export interface RootMutationSaveServersArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  servers: Array<ServerInput>;
}


export interface RootMutationSaveSipUserArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  sipUser: SipUserInput;
}


export interface RootMutationSaveSipUsersArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  sipUsers: Array<SipUserInput>;
}


export interface RootMutationSaveSystemLogArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  systemLog: SystemLogInput;
}


export interface RootMutationSaveSystemLogsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  systemLogs: Array<SystemLogInput>;
}


export interface RootMutationSaveTileArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  tile: TileInput;
}


export interface RootMutationSaveTileSetArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  tileSet: TileSetInput;
}


export interface RootMutationSaveTileSetTypeArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  tileSetType: TileSetTypeInput;
}


export interface RootMutationSaveTileSetTypesArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  tileSetTypes: Array<TileSetTypeInput>;
}


export interface RootMutationSaveTileSetsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  tileSets: Array<TileSetInput>;
}


export interface RootMutationSaveTileViewModeBoundArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  tileViewModeBound: TileViewModeBoundInput;
}


export interface RootMutationSaveTileViewModeBoundsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  tileViewModeBounds: Array<TileViewModeBoundInput>;
}


export interface RootMutationSaveTilesArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  tiles: Array<TileInput>;
}


export interface RootMutationSaveTimeBasedRouteArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  timeBasedRoute: TimeBasedRouteInput;
}


export interface RootMutationSaveTimeBasedRoutesArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  timeBasedRoutes: Array<TimeBasedRouteInput>;
}


export interface RootMutationSaveUserArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  user: UserPostInput;
}


export interface RootMutationSaveUserCallRecordingExtensionArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  userCallRecordingExtension: UserCallRecordingExtensionInput;
}


export interface RootMutationSaveUserCallRecordingExtensionGroupArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  userCallRecordingExtensionGroup: UserCallRecordingExtensionGroupInput;
}


export interface RootMutationSaveUserCallRecordingExtensionGroupsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  userCallRecordingExtensionGroups: Array<UserCallRecordingExtensionGroupInput>;
}


export interface RootMutationSaveUserCallRecordingExtensionsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  userCallRecordingExtensions: Array<UserCallRecordingExtensionInput>;
}


export interface RootMutationSaveUserLinksForRoleArgs {
  items: Array<UserRoleInput>;
  roleId: Scalars['UInt']['input'];
  saveOptions?: InputMaybe<Array<SaveOption>>;
}


export interface RootMutationSaveUserPreferenceArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  userPreference: UserPreferenceInput;
}


export interface RootMutationSaveUserPreferencesArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  userPreferences: Array<UserPreferenceInput>;
}


export interface RootMutationSaveUserPrivilegeArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  userPrivilege: UserPrivilegeInput;
}


export interface RootMutationSaveUserPrivilegesArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  userPrivileges: Array<UserPrivilegeInput>;
}


export interface RootMutationSaveUserPrivilegesForUserArgs {
  items: Array<UserPrivilegeInput>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  userId: Scalars['Int']['input'];
}


export interface RootMutationSaveUserReportArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  userReport: UserReportInput;
}


export interface RootMutationSaveUserReportsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  userReports: Array<UserReportInput>;
}


export interface RootMutationSaveUserRoleArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  userRole: UserRoleInput;
}


export interface RootMutationSaveUserRolesArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  userRoles: Array<UserRoleInput>;
}


export interface RootMutationSaveUsersArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  users: Array<UserPostInput>;
}


export interface RootMutationSaveWebhookRegistrationArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  webhookRegistration: WebhookRegistrationInput;
}


export interface RootMutationSaveWebhookRegistrationsArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  saveOptions?: InputMaybe<Array<SaveOption>>;
  webhookRegistrations: Array<WebhookRegistrationInput>;
}


export interface RootMutationSendUserPasswordResetRequestArgs {
  accountShortName?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  encryptedPasswordResetVerificationUrl?: InputMaybe<Scalars['String']['input']>;
  tokenExpirationValueFromSystemPreferences: Scalars['Float']['input'];
}


export interface RootMutationSetIsOtrEnabledOffForExtensionsArgs {
  accountId: Scalars['UInt']['input'];
}


export interface RootMutationUpdateConfigurationFromParametersArgs {
  dashboardTileId: Scalars['Int']['input'];
  tileLayoutConfiguration: TileLayoutConfigurationParameterInput;
}

export interface RootQuery {
  accessToken: AccessToken;
  accessTokenPrivilege: AccessTokenPrivilege;
  accessTokenPrivilegesConnection: AccessTokenPrivilegeConnection;
  accessTokensConnection: AccessTokenConnection;
  account: Account;
  accountsConnection: AccountConnection;
  activeCall: ActiveCall;
  activeCallActiveCallsForExtensionById: Maybe<Array<ActiveCall>>;
  activeCallActiveRingingCallsForExtensionById: Maybe<Array<ActiveCall>>;
  activeCallNonInternalActiveCallsForAccountById: Maybe<Array<ActiveCall>>;
  activeCallReadOnliesConnection: ActiveCallReadOnlyConnection;
  activeCallReadOnly: ActiveCallReadOnly;
  activeCallSegment: ActiveCallSegment;
  activeCallSegmentsConnection: ActiveCallSegmentConnection;
  activeCallsConnection: ActiveCallConnection;
  allowedIpAddress: AllowedIpAddress;
  allowedIpAddressesConnection: AllowedIpAddressConnection;
  areaCodeRisk: AreaCodeRisk;
  areaCodeRisksConnection: AreaCodeRiskConnection;
  autoAttendantKey: AutoAttendantKey;
  autoAttendantKeysConnection: AutoAttendantKeyConnection;
  autoAttendantPrompt: AutoAttendantPrompt;
  autoAttendantPromptsConnection: AutoAttendantPromptConnection;
  azureActiveDirectoryConfiguration: AzureActiveDirectoryConfiguration;
  azureActiveDirectoryConfigurationsConnection: AzureActiveDirectoryConfigurationConnection;
  bannedProvisioningIp: BannedProvisioningIp;
  bannedProvisioningIpsConnection: BannedProvisioningIpConnection;
  baseStationHandset: BaseStationHandset;
  baseStationHandsetsConnection: BaseStationHandsetConnection;
  blockedIpAddress: BlockedIpAddress;
  blockedIpAddressesConnection: BlockedIpAddressConnection;
  blockedPhoneNumber: BlockedPhoneNumber;
  blockedPhoneNumbersConnection: BlockedPhoneNumberConnection;
  callDetail: CallDetail;
  callDetailAppsuiteChannel: CallDetailAppsuiteChannel;
  callDetailAppsuiteChannelsConnection: CallDetailAppsuiteChannelConnection;
  callDetailReadOnliesConnection: CallDetailReadOnlyConnection;
  callDetailReadOnly: CallDetailReadOnly;
  callDetailsConnection: CallDetailConnection;
  callNotificationTransmission: CallNotificationTransmission;
  callNotificationTransmissionsConnection: CallNotificationTransmissionConnection;
  callParkingLot: CallParkingLot;
  callParkingLotsConnection: CallParkingLotConnection;
  callRecording: CallRecording;
  callRecordingCallDetail: CallRecordingCallDetail;
  callRecordingCallDetailsConnection: CallRecordingCallDetailConnection;
  callRecordingsConnection: CallRecordingConnection;
  callSegment: CallSegment;
  callSegmentsConnection: CallSegmentConnection;
  checkForMatchingSipUser: Maybe<Scalars['Boolean']['output']>;
  checkIfZoiperPro: Maybe<Scalars['Boolean']['output']>;
  checkWhitelist: Maybe<Scalars['Int']['output']>;
  closedException: ClosedException;
  closedExceptionsConnection: ClosedExceptionConnection;
  countForAccessTokenConnection: IntGraphTypeConnection;
  countForAccessTokenPrivilegeConnection: IntGraphTypeConnection;
  countForAccountConnection: IntGraphTypeConnection;
  countForActiveCallConnection: IntGraphTypeConnection;
  countForActiveCallReadOnlyConnection: IntGraphTypeConnection;
  countForActiveCallSegmentConnection: IntGraphTypeConnection;
  countForAllowedIpAddressConnection: IntGraphTypeConnection;
  countForAreaCodeRiskConnection: IntGraphTypeConnection;
  countForAutoAttendantKeyConnection: IntGraphTypeConnection;
  countForAutoAttendantPromptConnection: IntGraphTypeConnection;
  countForAzureActiveDirectoryConfigurationConnection: IntGraphTypeConnection;
  countForBannedProvisioningIpConnection: IntGraphTypeConnection;
  countForBaseStationHandsetConnection: IntGraphTypeConnection;
  countForBlockedIpAddressConnection: IntGraphTypeConnection;
  countForBlockedPhoneNumberConnection: IntGraphTypeConnection;
  countForCallDetailAppsuiteChannelConnection: IntGraphTypeConnection;
  countForCallDetailConnection: IntGraphTypeConnection;
  countForCallDetailReadOnlyConnection: IntGraphTypeConnection;
  countForCallNotificationTransmissionConnection: IntGraphTypeConnection;
  countForCallParkingLotConnection: IntGraphTypeConnection;
  countForCallRecordingCallDetailConnection: IntGraphTypeConnection;
  countForCallRecordingConnection: IntGraphTypeConnection;
  countForCallSegmentConnection: IntGraphTypeConnection;
  countForClosedExceptionConnection: IntGraphTypeConnection;
  countForCronJobConnection: IntGraphTypeConnection;
  countForCronJobExecutionConnection: IntGraphTypeConnection;
  countForDashboardConnection: IntGraphTypeConnection;
  countForDashboardTileConnection: IntGraphTypeConnection;
  countForDashboardTileEntityParameterConnection: IntGraphTypeConnection;
  countForDashboardTileEntityParameterValueConnection: IntGraphTypeConnection;
  countForDashboardTileLayoutConfigurationConnection: IntGraphTypeConnection;
  countForDashboardTileParameterConnection: IntGraphTypeConnection;
  countForDashboardTileParameterDateRangeConnection: IntGraphTypeConnection;
  countForDepartmentConnection: IntGraphTypeConnection;
  countForDepartmentExtensionConnection: IntGraphTypeConnection;
  countForDeviceConnection: IntGraphTypeConnection;
  countForDeviceTypeConnection: IntGraphTypeConnection;
  countForExtensionAutoAttendantConnection: IntGraphTypeConnection;
  countForExtensionConnection: IntGraphTypeConnection;
  countForExtensionExternalForwardConnection: IntGraphTypeConnection;
  countForExtensionFaxConnection: IntGraphTypeConnection;
  countForExtensionFmFmConnection: IntGraphTypeConnection;
  countForExtensionGroupConnection: IntGraphTypeConnection;
  countForExtensionGroupExtensionConnection: IntGraphTypeConnection;
  countForExtensionGroupSuperviseeConnection: IntGraphTypeConnection;
  countForExtensionHuntGroupConnection: IntGraphTypeConnection;
  countForExtensionMailboxConnection: IntGraphTypeConnection;
  countForExtensionPagingGroupConnection: IntGraphTypeConnection;
  countForExtensionPhoneConnection: IntGraphTypeConnection;
  countForExtensionQueueConnection: IntGraphTypeConnection;
  countForExtensionSuperviseeConnection: IntGraphTypeConnection;
  countForExtensionTypeConnection: IntGraphTypeConnection;
  countForExternalNumberHistoryConnection: IntGraphTypeConnection;
  countForFaxAttachmentConnection: IntGraphTypeConnection;
  countForFaxConnection: IntGraphTypeConnection;
  countForFaxEmailAddressConnection: IntGraphTypeConnection;
  countForFileConnection: IntGraphTypeConnection;
  countForFileDepotConnection: IntGraphTypeConnection;
  countForFmFmStepConnection: IntGraphTypeConnection;
  countForFmFmStepExtensionConnection: IntGraphTypeConnection;
  countForFmFmStepPhoneNumberConnection: IntGraphTypeConnection;
  countForHuntGroupExtensionGroupConnection: IntGraphTypeConnection;
  countForHuntGroupMemberConnection: IntGraphTypeConnection;
  countForLocationConnection: IntGraphTypeConnection;
  countForMailboxConnection: IntGraphTypeConnection;
  countForMailboxMessageConnection: IntGraphTypeConnection;
  countForNoteConnection: IntGraphTypeConnection;
  countForOpenSipsFraudLogConnection: IntGraphTypeConnection;
  countForOpenSipsFraudWhitelistConnection: IntGraphTypeConnection;
  countForOpenSipsMismatchedContactAndFromLogConnection: IntGraphTypeConnection;
  countForOpenSipsViaLogConnection: IntGraphTypeConnection;
  countForOpenSipsZoiperProWhitelistConnection: IntGraphTypeConnection;
  countForOpensipsHardPhoneWhiteListConnection: IntGraphTypeConnection;
  countForPagingGroupExtensionGroupConnection: IntGraphTypeConnection;
  countForPagingGroupMemberConnection: IntGraphTypeConnection;
  countForPhoneConnection: IntGraphTypeConnection;
  countForPhoneNumberConnection: IntGraphTypeConnection;
  countForPrivilegeCategoryConnection: IntGraphTypeConnection;
  countForPrivilegeConnection: IntGraphTypeConnection;
  countForPromptConnection: IntGraphTypeConnection;
  countForProviderCallRateConnection: IntGraphTypeConnection;
  countForQueueAgentDialConnection: IntGraphTypeConnection;
  countForQueueAgentLoginConnection: IntGraphTypeConnection;
  countForQueueCallbackDialConnection: IntGraphTypeConnection;
  countForQueueExtensionGroupConnection: IntGraphTypeConnection;
  countForQueueExtensionStatusConnection: IntGraphTypeConnection;
  countForQueueHistoryCallDetailConnection: IntGraphTypeConnection;
  countForQueueHistoryConnection: IntGraphTypeConnection;
  countForQueueLogConnection: IntGraphTypeConnection;
  countForQueueMemberConnection: IntGraphTypeConnection;
  countForQueuePeriodicAnnouncementConnection: IntGraphTypeConnection;
  countForRM12ClientConnection: IntGraphTypeConnection;
  countForReportConnection: IntGraphTypeConnection;
  countForReportParameterConnection: IntGraphTypeConnection;
  countForRm12ClientTokenConnection: IntGraphTypeConnection;
  countForRoleCallRecordingExtensionConnection: IntGraphTypeConnection;
  countForRoleCallRecordingExtensionGroupConnection: IntGraphTypeConnection;
  countForRoleConnection: IntGraphTypeConnection;
  countForRolePrivilegeConnection: IntGraphTypeConnection;
  countForRoleReportConnection: IntGraphTypeConnection;
  countForScheduleConnection: IntGraphTypeConnection;
  countForScheduleDetailConnection: IntGraphTypeConnection;
  countForScheduledJobConnection: IntGraphTypeConnection;
  countForServerConnection: IntGraphTypeConnection;
  countForSipUserConnection: IntGraphTypeConnection;
  countForSipUserRegistrationConnection: IntGraphTypeConnection;
  countForSystemLogConnection: IntGraphTypeConnection;
  countForTileConnection: IntGraphTypeConnection;
  countForTileSetConnection: IntGraphTypeConnection;
  countForTileSetTypeConnection: IntGraphTypeConnection;
  countForTileViewModeBoundConnection: IntGraphTypeConnection;
  countForTimeBasedRouteConnection: IntGraphTypeConnection;
  countForUserCallRecordingExtensionConnection: IntGraphTypeConnection;
  countForUserCallRecordingExtensionGroupConnection: IntGraphTypeConnection;
  countForUserConnection: IntGraphTypeConnection;
  countForUserDirectorySourceConnection: IntGraphTypeConnection;
  countForUserPreferenceConnection: IntGraphTypeConnection;
  countForUserPreferenceDefinitionConnection: IntGraphTypeConnection;
  countForUserPrivilegeConnection: IntGraphTypeConnection;
  countForUserReportConnection: IntGraphTypeConnection;
  countForUserRoleConnection: IntGraphTypeConnection;
  countForWebhookRegistrationConnection: IntGraphTypeConnection;
  cronJob: CronJob;
  cronJobExecution: CronJobExecution;
  cronJobExecutionsConnection: CronJobExecutionConnection;
  cronJobsConnection: CronJobConnection;
  dashboard: Dashboard;
  dashboardTile: DashboardTile;
  dashboardTileEntityParameter: DashboardTileEntityParameter;
  dashboardTileEntityParameterValue: DashboardTileEntityParameterValue;
  dashboardTileEntityParameterValuesConnection: DashboardTileEntityParameterValueConnection;
  dashboardTileEntityParametersConnection: DashboardTileEntityParameterConnection;
  dashboardTileLayoutConfiguration: DashboardTileLayoutConfiguration;
  dashboardTileLayoutConfigurationsConnection: DashboardTileLayoutConfigurationConnection;
  dashboardTileParameter: DashboardTileParameter;
  dashboardTileParameterDateRange: DashboardTileParameterDateRange;
  dashboardTileParameterDateRangesConnection: DashboardTileParameterDateRangeConnection;
  dashboardTileParametersConnection: DashboardTileParameterConnection;
  dashboardTilesConnection: DashboardTileConnection;
  dashboardsConnection: DashboardConnection;
  department: Department;
  departmentExtension: DepartmentExtension;
  departmentExtensionsConnection: DepartmentExtensionConnection;
  departmentsConnection: DepartmentConnection;
  device: Device;
  deviceType: DeviceType;
  deviceTypesConnection: DeviceTypeConnection;
  devicesConnection: DeviceConnection;
  doesCallDetailExist: Maybe<Scalars['Boolean']['output']>;
  extension: Extension;
  extensionAllExtensionsForDepartment: Maybe<Array<Extension>>;
  extensionAutoAttendant: ExtensionAutoAttendant;
  extensionAutoAttendantExtensionIdsByAccountId: Maybe<Array<Scalars['UInt']['output']>>;
  extensionAutoAttendantsConnection: ExtensionAutoAttendantConnection;
  extensionCallQueueExtensionIdsByAccountId: Maybe<Array<Scalars['UInt']['output']>>;
  extensionExtensionByNumberAndAccount: Maybe<Extension>;
  extensionExtensionBySipUserNameAndAccountShortName: Maybe<Extension>;
  extensionExtensionIdsByAccountId: Maybe<Array<Scalars['UInt']['output']>>;
  extensionExtensionIdsByPhoneNumbers: Maybe<Array<Scalars['UInt']['output']>>;
  extensionExtensionNames: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  extensionExtensionNumbersAndNamesByAccountId: Maybe<Array<Extension>>;
  extensionExtensionsAndDefaultNumbersByAccountId: Maybe<Array<Extension>>;
  extensionExtensionsByNumbersAndAccount: Maybe<Array<Extension>>;
  extensionExternalForward: ExtensionExternalForward;
  extensionExternalForwardsConnection: ExtensionExternalForwardConnection;
  extensionFax: ExtensionFax;
  extensionFaxesConnection: ExtensionFaxConnection;
  extensionFmFm: ExtensionFmFm;
  extensionFmFmsConnection: ExtensionFmFmConnection;
  extensionGroup: ExtensionGroup;
  extensionGroupExtension: ExtensionGroupExtension;
  extensionGroupExtensionsConnection: ExtensionGroupExtensionConnection;
  extensionGroupSupervisee: ExtensionGroupSupervisee;
  extensionGroupSuperviseesConnection: ExtensionGroupSuperviseeConnection;
  extensionGroupsConnection: ExtensionGroupConnection;
  extensionHuntGroup: ExtensionHuntGroup;
  extensionHuntGroupsConnection: ExtensionHuntGroupConnection;
  extensionMailbox: ExtensionMailbox;
  extensionMailboxesConnection: ExtensionMailboxConnection;
  extensionPagingGroup: ExtensionPagingGroup;
  extensionPagingGroupsConnection: ExtensionPagingGroupConnection;
  extensionPhone: ExtensionPhone;
  extensionPhonesConnection: ExtensionPhoneConnection;
  extensionQueue: ExtensionQueue;
  extensionQueueExtensionsByAccount: Maybe<Array<Extension>>;
  extensionQueuesConnection: ExtensionQueueConnection;
  extensionSupervisee: ExtensionSupervisee;
  extensionSuperviseesConnection: ExtensionSuperviseeConnection;
  extensionType: ExtensionType;
  extensionTypesConnection: ExtensionTypeConnection;
  extensionsConnection: ExtensionConnection;
  externalNumberHistoriesConnection: ExternalNumberHistoryConnection;
  externalNumberHistory: ExternalNumberHistory;
  fax: Fax;
  faxAttachment: FaxAttachment;
  faxAttachmentsConnection: FaxAttachmentConnection;
  faxEmailAddress: FaxEmailAddress;
  faxEmailAddressesConnection: FaxEmailAddressConnection;
  faxesConnection: FaxConnection;
  file: File;
  fileDepot: FileDepot;
  fileDepotsConnection: FileDepotConnection;
  filesConnection: FileConnection;
  fmFmStep: FmFmStep;
  fmFmStepExtension: FmFmStepExtension;
  fmFmStepExtensionsConnection: FmFmStepExtensionConnection;
  fmFmStepPhoneNumber: FmFmStepPhoneNumber;
  fmFmStepPhoneNumbersConnection: FmFmStepPhoneNumberConnection;
  fmFmStepsConnection: FmFmStepConnection;
  fraudAlert: Maybe<Scalars['Int']['output']>;
  getAnnouncementFrequency: Maybe<Scalars['Int']['output']>;
  getExtensionFax: Maybe<ExtensionFax>;
  getExtensionId: Maybe<Scalars['UInt']['output']>;
  huntGroupExtensionGroup: HuntGroupExtensionGroup;
  huntGroupExtensionGroupsConnection: HuntGroupExtensionGroupConnection;
  huntGroupMember: HuntGroupMember;
  huntGroupMembersConnection: HuntGroupMemberConnection;
  isCallCostOverDailyLimit: Maybe<Scalars['Boolean']['output']>;
  isExtensionIdOnAccount: Maybe<Scalars['Boolean']['output']>;
  isNdt1Account: Maybe<Scalars['Boolean']['output']>;
  isPhoneNumberOutboundEnabled: Maybe<Scalars['Boolean']['output']>;
  location: Location;
  locationsConnection: LocationConnection;
  mailbox: Mailbox;
  mailboxMessage: MailboxMessage;
  mailboxMessageMailboxMessage: Maybe<MailboxMessage>;
  mailboxMessageNumberOfReadMessagesForMailbox: Maybe<Scalars['Int']['output']>;
  mailboxMessageNumberOfUnreadMessagesForMailbox: Maybe<Scalars['Int']['output']>;
  mailboxMessagesConnection: MailboxMessageConnection;
  mailboxesConnection: MailboxConnection;
  note: Note;
  notesConnection: NoteConnection;
  openSipsFraudLog: OpenSipsFraudLog;
  openSipsFraudLogsConnection: OpenSipsFraudLogConnection;
  openSipsFraudWhitelist: OpenSipsFraudWhitelist;
  openSipsFraudWhitelistsConnection: OpenSipsFraudWhitelistConnection;
  openSipsMismatchedContactAndFromLog: OpenSipsMismatchedContactAndFromLog;
  openSipsMismatchedContactAndFromLogsConnection: OpenSipsMismatchedContactAndFromLogConnection;
  openSipsViaLog: OpenSipsViaLog;
  openSipsViaLogsConnection: OpenSipsViaLogConnection;
  openSipsZoiperProWhitelist: OpenSipsZoiperProWhitelist;
  openSipsZoiperProWhitelistsConnection: OpenSipsZoiperProWhitelistConnection;
  opensipsHardPhoneWhiteList: OpensipsHardPhoneWhiteList;
  opensipsHardPhoneWhiteListsConnection: OpensipsHardPhoneWhiteListConnection;
  pagingGroupExtensionGroup: PagingGroupExtensionGroup;
  pagingGroupExtensionGroupsConnection: PagingGroupExtensionGroupConnection;
  pagingGroupMember: PagingGroupMember;
  pagingGroupMembersConnection: PagingGroupMemberConnection;
  phone: Phone;
  phoneNumber: PhoneNumber;
  phoneNumberAccountPhoneNumbersAndNames: Maybe<Array<PhoneNumber>>;
  phoneNumberCreateUser: Maybe<User>;
  phoneNumberPhoneNumberIds: Maybe<Array<Scalars['UInt']['output']>>;
  phoneNumberPhoneNumbers: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  phoneNumberUpdateUser: Maybe<User>;
  phoneNumbersConnection: PhoneNumberConnection;
  phonesConnection: PhoneConnection;
  privilege: Privilege;
  privilegeCategoriesConnection: PrivilegeCategoryConnection;
  privilegeCategory: PrivilegeCategory;
  privilegesConnection: PrivilegeConnection;
  processPendingFaxes: Maybe<Array<Scalars['UInt']['output']>>;
  processStuckFaxes: Maybe<Array<Scalars['UInt']['output']>>;
  prompt: Prompt;
  promptsConnection: PromptConnection;
  providerCallRate: ProviderCallRate;
  providerCallRateProviderCallRate: Maybe<ProviderCallRate>;
  providerCallRatesConnection: ProviderCallRateConnection;
  queueAgentDial: QueueAgentDial;
  queueAgentDialsConnection: QueueAgentDialConnection;
  queueAgentLogin: QueueAgentLogin;
  queueAgentLoginsConnection: QueueAgentLoginConnection;
  queueCallbackDial: QueueCallbackDial;
  queueCallbackDialsConnection: QueueCallbackDialConnection;
  queueExtensionGroup: QueueExtensionGroup;
  queueExtensionGroupsConnection: QueueExtensionGroupConnection;
  queueExtensionStatus: QueueExtensionStatus;
  queueExtensionStatusesConnection: QueueExtensionStatusConnection;
  queueHistoriesConnection: QueueHistoryConnection;
  queueHistory: QueueHistory;
  queueHistoryCallDetail: QueueHistoryCallDetail;
  queueHistoryCallDetailsConnection: QueueHistoryCallDetailConnection;
  queueHistoryCallersWaitingByExtensionIds: Maybe<Array<QueueHistory>>;
  queueHistoryQueueHistoryById: Maybe<QueueHistory>;
  queueLog: QueueLog;
  queueLogsConnection: QueueLogConnection;
  queueMember: QueueMember;
  queueMemberQueueMemberById: Maybe<QueueMember>;
  queueMemberQueueMembersByAgentExtensionId: Maybe<Array<QueueMember>>;
  queueMemberQueueMembersByExtensionIds: Maybe<Array<QueueMember>>;
  queueMembersConnection: QueueMemberConnection;
  queuePeriodicAnnouncement: QueuePeriodicAnnouncement;
  queuePeriodicAnnouncementsConnection: QueuePeriodicAnnouncementConnection;
  rM12Client: Rm12Client;
  rM12ClientsConnection: Rm12ClientConnection;
  report: Report;
  reportAllReports: Maybe<Array<Report>>;
  reportParameter: ReportParameter;
  reportParametersConnection: ReportParameterConnection;
  reportsConnection: ReportConnection;
  rm12ClientToken: Rm12ClientToken;
  rm12ClientTokensConnection: Rm12ClientTokenConnection;
  role: Role;
  roleCallRecordingExtension: RoleCallRecordingExtension;
  roleCallRecordingExtensionGroup: RoleCallRecordingExtensionGroup;
  roleCallRecordingExtensionGroupsConnection: RoleCallRecordingExtensionGroupConnection;
  roleCallRecordingExtensionsConnection: RoleCallRecordingExtensionConnection;
  roleCreateUser: Maybe<User>;
  roleLinksForUserConnection: UserRoleConnection;
  rolePrivilege: RolePrivilege;
  rolePrivilegesConnection: RolePrivilegeConnection;
  rolePrivilegesForRoleConnection: RolePrivilegeConnection;
  roleReport: RoleReport;
  roleReportsConnection: RoleReportConnection;
  roleReportsForRoleConnection: RoleReportConnection;
  roleRolePrivilege: Maybe<RolePrivilege>;
  roleRoleReport: Maybe<RoleReport>;
  roleUpdateUser: Maybe<User>;
  roleUserLink: Maybe<UserRole>;
  rolesConnection: RoleConnection;
  runCallParkingTile: CallParkingTileGraphType;
  runClockTile: ClockTileGraphType;
  runPhoneQueuesTile: PhoneQueuesTileGraphType;
  runQueueMembersTile: QueueMembersTileGraphType;
  runWaitTimesGraphTile: WaitTimesGraphTileGraphType;
  saveEffectiveUserPreferencesForUser: Maybe<Array<Scalars['UInt']['output']>>;
  saveNewAccountForAccount: Maybe<Scalars['UInt']['output']>;
  saveWebhookRegistrationForWebhookRegistration: Maybe<Scalars['UInt']['output']>;
  schedule: Schedule;
  scheduleDetail: ScheduleDetail;
  scheduleDetailsConnection: ScheduleDetailConnection;
  scheduledJob: ScheduledJob;
  scheduledJobsConnection: ScheduledJobConnection;
  schedulesConnection: ScheduleConnection;
  searchDevices: Maybe<Array<Device>>;
  searchPhoneNumbers: Maybe<Array<PhoneNumber>>;
  searchSoftphoneUsernames: Maybe<Array<SipUser>>;
  server: Server;
  serversConnection: ServerConnection;
  sipUser: SipUser;
  sipUserAppSuiteSipUserByExtensionId: Maybe<SipUser>;
  sipUserRegistration: SipUserRegistration;
  sipUserRegistrationsConnection: SipUserRegistrationConnection;
  sipUserSipDomain: Maybe<Scalars['String']['output']>;
  sipUsersConnection: SipUserConnection;
  systemLog: SystemLog;
  systemLogsConnection: SystemLogConnection;
  tile: Tile;
  tileSet: TileSet;
  tileSetType: TileSetType;
  tileSetTypesConnection: TileSetTypeConnection;
  tileSetsConnection: TileSetConnection;
  tileViewModeBound: TileViewModeBound;
  tileViewModeBoundsConnection: TileViewModeBoundConnection;
  tilesConnection: TileConnection;
  timeBasedRoute: TimeBasedRoute;
  timeBasedRouteCurrentTimeBasedRoute: Maybe<TimeBasedRoute>;
  timeBasedRouteNextTimeBasedRoute: Maybe<TimeBasedRoute>;
  timeBasedRoutesConnection: TimeBasedRouteConnection;
  user: User;
  userAccountShortNameByUserId: Maybe<Scalars['String']['output']>;
  userCallRecordingExtension: UserCallRecordingExtension;
  userCallRecordingExtensionGroup: UserCallRecordingExtensionGroup;
  userCallRecordingExtensionGroupsConnection: UserCallRecordingExtensionGroupConnection;
  userCallRecordingExtensionsConnection: UserCallRecordingExtensionConnection;
  userDirectorySource: UserDirectorySource;
  userDirectorySourcesConnection: UserDirectorySourceConnection;
  userEffectiveReportsForCurrentUser: Maybe<Array<EffectiveUserReport>>;
  userLinksForRoleConnection: UserRoleConnection;
  userPreference: UserPreference;
  userPreferenceDefinition: UserPreferenceDefinition;
  userPreferenceDefinitionsConnection: UserPreferenceDefinitionConnection;
  userPreferencesConnection: UserPreferenceConnection;
  userPrivilege: UserPrivilege;
  userPrivilegesConnection: UserPrivilegeConnection;
  userPrivilegesForUserConnection: UserPrivilegeConnection;
  userReport: UserReport;
  userReportsConnection: UserReportConnection;
  userRole: UserRole;
  userRoleLink: Maybe<UserRole>;
  userRolesConnection: UserRoleConnection;
  userUserPrivilege: Maybe<UserPrivilege>;
  usersConnection: UserConnection;
  validateAndGetPresenceAccount: Maybe<Array<Account>>;
  viaAlert: Maybe<Scalars['Int']['output']>;
  webhookRegistration: WebhookRegistration;
  webhookRegistrationsConnection: WebhookRegistrationConnection;
}


export interface RootQueryAccessTokenArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryAccessTokenPrivilegeArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryAccessTokenPrivilegesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryAccessTokensConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryAccountArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryAccountsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryActiveCallArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryActiveCallActiveCallsForExtensionByIdArgs {
  checkOnlyInboundAndOutboundCalls: Scalars['Boolean']['input'];
  extensionId: Scalars['UInt']['input'];
}


export interface RootQueryActiveCallActiveRingingCallsForExtensionByIdArgs {
  extensionId: Scalars['UInt']['input'];
}


export interface RootQueryActiveCallNonInternalActiveCallsForAccountByIdArgs {
  accountId: Scalars['UInt']['input'];
}


export interface RootQueryActiveCallReadOnliesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryActiveCallReadOnlyArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryActiveCallSegmentArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryActiveCallSegmentsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryActiveCallsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryAllowedIpAddressArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryAllowedIpAddressesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryAreaCodeRiskArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryAreaCodeRisksConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryAutoAttendantKeyArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryAutoAttendantKeysConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryAutoAttendantPromptArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryAutoAttendantPromptsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryAzureActiveDirectoryConfigurationArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryAzureActiveDirectoryConfigurationsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryBannedProvisioningIpArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['Int']['input']>;
}


export interface RootQueryBannedProvisioningIpsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryBaseStationHandsetArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryBaseStationHandsetsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryBlockedIpAddressArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryBlockedIpAddressesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryBlockedPhoneNumberArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryBlockedPhoneNumbersConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryCallDetailArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryCallDetailAppsuiteChannelArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryCallDetailAppsuiteChannelsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryCallDetailReadOnliesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryCallDetailReadOnlyArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryCallDetailsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryCallNotificationTransmissionArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryCallNotificationTransmissionsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryCallParkingLotArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryCallParkingLotsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryCallRecordingArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryCallRecordingCallDetailArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryCallRecordingCallDetailsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryCallRecordingsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryCallSegmentArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryCallSegmentsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryCheckForMatchingSipUserArgs {
  sipUserName?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCheckIfZoiperProArgs {
  domain?: InputMaybe<Scalars['String']['input']>;
  sipUser?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCheckWhitelistArgs {
  domain?: InputMaybe<Scalars['String']['input']>;
  ruleName?: InputMaybe<Scalars['String']['input']>;
  sipuser?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['UInt']['input'];
}


export interface RootQueryClosedExceptionArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryClosedExceptionsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryCountForAccessTokenConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForAccessTokenPrivilegeConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForAccountConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForActiveCallConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForActiveCallReadOnlyConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForActiveCallSegmentConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForAllowedIpAddressConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForAreaCodeRiskConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForAutoAttendantKeyConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForAutoAttendantPromptConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForAzureActiveDirectoryConfigurationConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForBannedProvisioningIpConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForBaseStationHandsetConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForBlockedIpAddressConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForBlockedPhoneNumberConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForCallDetailAppsuiteChannelConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForCallDetailConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForCallDetailReadOnlyConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForCallNotificationTransmissionConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForCallParkingLotConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForCallRecordingCallDetailConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForCallRecordingConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForCallSegmentConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForClosedExceptionConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForCronJobConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForCronJobExecutionConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForDashboardConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForDashboardTileConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForDashboardTileEntityParameterConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForDashboardTileEntityParameterValueConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForDashboardTileLayoutConfigurationConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForDashboardTileParameterConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForDashboardTileParameterDateRangeConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForDepartmentConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForDepartmentExtensionConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForDeviceConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForDeviceTypeConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForExtensionAutoAttendantConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForExtensionConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForExtensionExternalForwardConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForExtensionFaxConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForExtensionFmFmConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForExtensionGroupConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForExtensionGroupExtensionConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForExtensionGroupSuperviseeConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForExtensionHuntGroupConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForExtensionMailboxConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForExtensionPagingGroupConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForExtensionPhoneConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForExtensionQueueConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForExtensionSuperviseeConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForExtensionTypeConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
}


export interface RootQueryCountForExternalNumberHistoryConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForFaxAttachmentConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForFaxConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForFaxEmailAddressConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForFileConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForFileDepotConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForFmFmStepConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForFmFmStepExtensionConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForFmFmStepPhoneNumberConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForHuntGroupExtensionGroupConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForHuntGroupMemberConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForLocationConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForMailboxConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForMailboxMessageConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForNoteConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForOpenSipsFraudLogConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForOpenSipsFraudWhitelistConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForOpenSipsMismatchedContactAndFromLogConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForOpenSipsViaLogConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForOpenSipsZoiperProWhitelistConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForOpensipsHardPhoneWhiteListConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForPagingGroupExtensionGroupConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForPagingGroupMemberConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForPhoneConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForPhoneNumberConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForPrivilegeCategoryConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
}


export interface RootQueryCountForPrivilegeConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForPromptConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForProviderCallRateConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForQueueAgentDialConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForQueueAgentLoginConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForQueueCallbackDialConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForQueueExtensionGroupConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForQueueExtensionStatusConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForQueueHistoryCallDetailConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForQueueHistoryConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForQueueLogConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForQueueMemberConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForQueuePeriodicAnnouncementConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForRm12ClientConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForReportConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForReportParameterConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForRm12ClientTokenConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForRoleCallRecordingExtensionConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForRoleCallRecordingExtensionGroupConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForRoleConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForRolePrivilegeConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForRoleReportConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForScheduleConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForScheduleDetailConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForScheduledJobConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForServerConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForSipUserConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForSipUserRegistrationConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForSystemLogConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForTileConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForTileSetConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForTileSetTypeConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForTileViewModeBoundConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForTimeBasedRouteConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForUserCallRecordingExtensionConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForUserCallRecordingExtensionGroupConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForUserConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForUserDirectorySourceConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
}


export interface RootQueryCountForUserPreferenceConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForUserPreferenceDefinitionConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
}


export interface RootQueryCountForUserPrivilegeConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForUserReportConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForUserRoleConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCountForWebhookRegistrationConnectionArgs {
  filters?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryCronJobArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryCronJobExecutionArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryCronJobExecutionsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryCronJobsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryDashboardArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryDashboardTileArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryDashboardTileEntityParameterArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryDashboardTileEntityParameterValueArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryDashboardTileEntityParameterValuesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryDashboardTileEntityParametersConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryDashboardTileLayoutConfigurationArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryDashboardTileLayoutConfigurationsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryDashboardTileParameterArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryDashboardTileParameterDateRangeArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryDashboardTileParameterDateRangesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryDashboardTileParametersConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryDashboardTilesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryDashboardsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryDepartmentArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryDepartmentExtensionArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryDepartmentExtensionsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryDepartmentsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryDeviceArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryDeviceTypeArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryDeviceTypesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryDevicesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryDoesCallDetailExistArgs {
  callDetailId: Scalars['UInt']['input'];
}


export interface RootQueryExtensionArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryExtensionAllExtensionsForDepartmentArgs {
  accountId: Scalars['UInt']['input'];
  departmentName?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryExtensionAutoAttendantArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryExtensionAutoAttendantExtensionIdsByAccountIdArgs {
  accountId: Scalars['UInt']['input'];
}


export interface RootQueryExtensionAutoAttendantsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryExtensionCallQueueExtensionIdsByAccountIdArgs {
  accountId: Scalars['UInt']['input'];
}


export interface RootQueryExtensionExtensionByNumberAndAccountArgs {
  accountId: Scalars['UInt']['input'];
  number: Scalars['UInt']['input'];
}


export interface RootQueryExtensionExtensionBySipUserNameAndAccountShortNameArgs {
  accountShortName?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryExtensionExtensionIdsByAccountIdArgs {
  accountId: Scalars['UInt']['input'];
}


export interface RootQueryExtensionExtensionIdsByPhoneNumbersArgs {
  phoneNumbers: Array<Scalars['UInt']['input']>;
}


export interface RootQueryExtensionExtensionNamesArgs {
  extensionIds: Array<Scalars['UInt']['input']>;
}


export interface RootQueryExtensionExtensionNumbersAndNamesByAccountIdArgs {
  accountId: Scalars['UInt']['input'];
}


export interface RootQueryExtensionExtensionsAndDefaultNumbersByAccountIdArgs {
  accountId: Scalars['UInt']['input'];
}


export interface RootQueryExtensionExtensionsByNumbersAndAccountArgs {
  accountId: Scalars['UInt']['input'];
  numbers: Array<Scalars['UInt']['input']>;
}


export interface RootQueryExtensionExternalForwardArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryExtensionExternalForwardsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryExtensionFaxArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryExtensionFaxesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryExtensionFmFmArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryExtensionFmFmsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryExtensionGroupArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryExtensionGroupExtensionArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryExtensionGroupExtensionsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryExtensionGroupSuperviseeArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryExtensionGroupSuperviseesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryExtensionGroupsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryExtensionHuntGroupArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryExtensionHuntGroupsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryExtensionMailboxArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryExtensionMailboxesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryExtensionPagingGroupArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryExtensionPagingGroupsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryExtensionPhoneArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryExtensionPhonesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryExtensionQueueArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryExtensionQueueExtensionsByAccountArgs {
  accountId: Scalars['UInt']['input'];
}


export interface RootQueryExtensionQueuesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryExtensionSuperviseeArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryExtensionSuperviseesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryExtensionTypeArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['Int']['input']>;
}


export interface RootQueryExtensionTypesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryExtensionsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryExternalNumberHistoriesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryExternalNumberHistoryArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryFaxArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryFaxAttachmentArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryFaxAttachmentsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryFaxEmailAddressArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryFaxEmailAddressesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryFaxesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryFileArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryFileDepotArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryFileDepotsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryFilesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryFmFmStepArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryFmFmStepExtensionArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryFmFmStepExtensionsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryFmFmStepPhoneNumberArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryFmFmStepPhoneNumbersConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryFmFmStepsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryFraudAlertArgs {
  openSipsFraudLog: OpenSipsFraudLogInput;
}


export interface RootQueryGetAnnouncementFrequencyArgs {
  queueExtensionId: Scalars['UInt']['input'];
}


export interface RootQueryGetExtensionFaxArgs {
  extensionId: Scalars['UInt']['input'];
}


export interface RootQueryGetExtensionIdArgs {
  fromEmail?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryHuntGroupExtensionGroupArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryHuntGroupExtensionGroupsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryHuntGroupMemberArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryHuntGroupMembersConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryIsCallCostOverDailyLimitArgs {
  accountId: Scalars['UInt']['input'];
}


export interface RootQueryIsExtensionIdOnAccountArgs {
  accountId: Scalars['UInt']['input'];
  extensionId: Scalars['UInt']['input'];
}


export interface RootQueryIsNdt1AccountArgs {
  accountshortName?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryIsPhoneNumberOutboundEnabledArgs {
  accountId: Scalars['UInt']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryLocationArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryLocationsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryMailboxArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryMailboxMessageArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryMailboxMessageMailboxMessageArgs {
  mailboxMessageId: Scalars['UInt']['input'];
}


export interface RootQueryMailboxMessageNumberOfReadMessagesForMailboxArgs {
  mailboxId: Scalars['UInt']['input'];
}


export interface RootQueryMailboxMessageNumberOfUnreadMessagesForMailboxArgs {
  mailboxId: Scalars['UInt']['input'];
}


export interface RootQueryMailboxMessagesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryMailboxesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryNoteArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryNotesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryOpenSipsFraudLogArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryOpenSipsFraudLogsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryOpenSipsFraudWhitelistArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryOpenSipsFraudWhitelistsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryOpenSipsMismatchedContactAndFromLogArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryOpenSipsMismatchedContactAndFromLogsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryOpenSipsViaLogArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryOpenSipsViaLogsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryOpenSipsZoiperProWhitelistArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryOpenSipsZoiperProWhitelistsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryOpensipsHardPhoneWhiteListArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryOpensipsHardPhoneWhiteListsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryPagingGroupExtensionGroupArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryPagingGroupExtensionGroupsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryPagingGroupMemberArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryPagingGroupMembersConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryPhoneArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryPhoneNumberArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryPhoneNumberAccountPhoneNumbersAndNamesArgs {
  accountId: Scalars['UInt']['input'];
}


export interface RootQueryPhoneNumberCreateUserArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id: Scalars['UInt']['input'];
}


export interface RootQueryPhoneNumberPhoneNumberIdsArgs {
  phoneNumbers: Array<InputMaybe<Scalars['String']['input']>>;
}


export interface RootQueryPhoneNumberPhoneNumbersArgs {
  phoneNumberIds: Array<Scalars['UInt']['input']>;
}


export interface RootQueryPhoneNumberUpdateUserArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id: Scalars['UInt']['input'];
}


export interface RootQueryPhoneNumbersConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryPhonesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryPrivilegeArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryPrivilegeCategoriesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryPrivilegeCategoryArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryPrivilegesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryPromptArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryPromptsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryProviderCallRateArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['Int']['input']>;
}


export interface RootQueryProviderCallRateProviderCallRateArgs {
  code?: InputMaybe<Scalars['String']['input']>;
  zone: Scalars['UInt']['input'];
}


export interface RootQueryProviderCallRatesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryQueueAgentDialArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryQueueAgentDialsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryQueueAgentLoginArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryQueueAgentLoginsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryQueueCallbackDialArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryQueueCallbackDialsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryQueueExtensionGroupArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryQueueExtensionGroupsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryQueueExtensionStatusArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryQueueExtensionStatusesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryQueueHistoriesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryQueueHistoryArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryQueueHistoryCallDetailArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryQueueHistoryCallDetailsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryQueueHistoryCallersWaitingByExtensionIdsArgs {
  extensionIds: Array<Scalars['UInt']['input']>;
}


export interface RootQueryQueueHistoryQueueHistoryByIdArgs {
  queueHistoryId: Scalars['UInt']['input'];
}


export interface RootQueryQueueLogArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryQueueLogsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryQueueMemberArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryQueueMemberQueueMemberByIdArgs {
  queueMemberId: Scalars['UInt']['input'];
}


export interface RootQueryQueueMemberQueueMembersByAgentExtensionIdArgs {
  extensionId: Scalars['UInt']['input'];
}


export interface RootQueryQueueMemberQueueMembersByExtensionIdsArgs {
  extensionIds: Array<Scalars['UInt']['input']>;
  isLoggedIn?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface RootQueryQueueMembersConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryQueuePeriodicAnnouncementArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryQueuePeriodicAnnouncementsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryRm12ClientArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryRm12ClientsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryReportArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryReportParameterArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryReportParametersConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryReportsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryRm12ClientTokenArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryRm12ClientTokensConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryRoleArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryRoleCallRecordingExtensionArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryRoleCallRecordingExtensionGroupArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryRoleCallRecordingExtensionGroupsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryRoleCallRecordingExtensionsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryRoleCreateUserArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id: Scalars['UInt']['input'];
}


export interface RootQueryRoleLinksForUserConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
  userId: Scalars['Int']['input'];
}


export interface RootQueryRolePrivilegeArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryRolePrivilegesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryRolePrivilegesForRoleConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
  roleId: Scalars['UInt']['input'];
}


export interface RootQueryRoleReportArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryRoleReportsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryRoleReportsForRoleConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
  roleId: Scalars['UInt']['input'];
}


export interface RootQueryRoleRolePrivilegeArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  itemId: Scalars['UInt']['input'];
  roleId: Scalars['UInt']['input'];
}


export interface RootQueryRoleRoleReportArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  roleId: Scalars['UInt']['input'];
  roleReportId: Scalars['UInt']['input'];
}


export interface RootQueryRoleUpdateUserArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id: Scalars['UInt']['input'];
}


export interface RootQueryRoleUserLinkArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  itemId: Scalars['UInt']['input'];
  roleId: Scalars['UInt']['input'];
}


export interface RootQueryRolesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryRunCallParkingTileArgs {
  params: ExecuteTilePostModelCallParkingTileReportParametersInput;
}


export interface RootQueryRunClockTileArgs {
  params: ExecuteTilePostModelClockTileReportParametersInput;
}


export interface RootQueryRunPhoneQueuesTileArgs {
  params: ExecuteTilePostModelPhoneQueuesTileReportParametersInput;
}


export interface RootQueryRunQueueMembersTileArgs {
  params: ExecuteTilePostModelQueueMembersTileReportParametersInput;
}


export interface RootQueryRunWaitTimesGraphTileArgs {
  params: ExecuteTilePostModelWaitTimesTileReportParametersInput;
}


export interface RootQuerySaveEffectiveUserPreferencesForUserArgs {
  effectiveUserPreference: EffectiveUserPreferenceInput;
  userId: Scalars['Int']['input'];
}


export interface RootQuerySaveNewAccountForAccountArgs {
  account: AccountInput;
}


export interface RootQuerySaveWebhookRegistrationForWebhookRegistrationArgs {
  currentUserAccountId?: InputMaybe<Scalars['UInt']['input']>;
  request: WebhookRegistrationRequestInput;
}


export interface RootQueryScheduleArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryScheduleDetailArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryScheduleDetailsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryScheduledJobArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryScheduledJobsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQuerySchedulesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQuerySearchDevicesArgs {
  searchText?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQuerySearchPhoneNumbersArgs {
  searchText?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQuerySearchSoftphoneUsernamesArgs {
  searchText?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryServerArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryServersConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQuerySipUserArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQuerySipUserAppSuiteSipUserByExtensionIdArgs {
  extensionId: Scalars['UInt']['input'];
}


export interface RootQuerySipUserRegistrationArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQuerySipUserRegistrationsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQuerySipUserSipDomainArgs {
  accountContext?: InputMaybe<Scalars['String']['input']>;
  presenceUser?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQuerySipUsersConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQuerySystemLogArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQuerySystemLogsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryTileArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryTileSetArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryTileSetTypeArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryTileSetTypesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryTileSetsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryTileViewModeBoundArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['Int']['input']>;
}


export interface RootQueryTileViewModeBoundsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryTilesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryTimeBasedRouteArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryTimeBasedRouteCurrentTimeBasedRouteArgs {
  extensionId: Scalars['UInt']['input'];
}


export interface RootQueryTimeBasedRouteNextTimeBasedRouteArgs {
  extensionId: Scalars['UInt']['input'];
}


export interface RootQueryTimeBasedRoutesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryUserArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['Int']['input']>;
}


export interface RootQueryUserAccountShortNameByUserIdArgs {
  userId: Scalars['Int']['input'];
}


export interface RootQueryUserCallRecordingExtensionArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryUserCallRecordingExtensionGroupArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryUserCallRecordingExtensionGroupsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryUserCallRecordingExtensionsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryUserDirectorySourceArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryUserDirectorySourcesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryUserLinksForRoleConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
  roleId: Scalars['UInt']['input'];
}


export interface RootQueryUserPreferenceArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryUserPreferenceDefinitionArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryUserPreferenceDefinitionsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryUserPreferencesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryUserPrivilegeArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryUserPrivilegesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryUserPrivilegesForUserConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
  userId: Scalars['Int']['input'];
}


export interface RootQueryUserReportArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryUserReportsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryUserRoleArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryUserRoleLinkArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  itemId: Scalars['UInt']['input'];
  userId: Scalars['Int']['input'];
}


export interface RootQueryUserRolesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryUserUserPrivilegeArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  userId: Scalars['Int']['input'];
  userPrivilegeId: Scalars['UInt']['input'];
}


export interface RootQueryUsersConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}


export interface RootQueryValidateAndGetPresenceAccountArgs {
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
}


export interface RootQueryViaAlertArgs {
  request: OpenSipsViaLogInput;
}


export interface RootQueryWebhookRegistrationArgs {
  getOptions?: InputMaybe<Array<GetOption>>;
  id?: InputMaybe<Scalars['UInt']['input']>;
}


export interface RootQueryWebhookRegistrationsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  getOptions?: InputMaybe<Array<GetOption>>;
  orderingOptions?: InputMaybe<Array<OrderingOption>>;
}

export interface SaveOption {
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  dateTimeValue?: InputMaybe<Scalars['DateTime']['input']>;
  intValue?: InputMaybe<Scalars['Int']['input']>;
  option: Scalars['String']['input'];
  stringValue?: InputMaybe<Scalars['String']['input']>;
}

export interface Schedule {
  account: Account;
  accountId: Scalars['UInt']['output'];
  closedExceptionsConnection: ClosedExceptionConnection;
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  description: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  phoneNumbersConnection: PhoneNumberConnection;
  scheduleDetailsConnection: ScheduleDetailConnection;
  scheduleId: Scalars['UInt']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}


export interface ScheduleClosedExceptionsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface SchedulePhoneNumbersConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface ScheduleScheduleDetailsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface ScheduleConnection {
  /** Information to aid in pagination. */
  edges: Array<ScheduleModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Schedule>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface ScheduleDetail {
  closeTime: Maybe<Scalars['UtcDateTime']['output']>;
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  dayOfWeek: Maybe<DayOfWeek>;
  openTime: Maybe<Scalars['UtcDateTime']['output']>;
  schedule: Schedule;
  scheduleDetailId: Scalars['UInt']['output'];
  scheduleId: Scalars['UInt']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface ScheduleDetailConnection {
  /** Information to aid in pagination. */
  edges: Array<ScheduleDetailModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<ScheduleDetail>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface ScheduleDetailInput {
  closeTime?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek?: InputMaybe<DayOfWeek>;
  fields: Array<Scalars['String']['input']>;
  openTime?: InputMaybe<Scalars['DateTime']['input']>;
  scheduleDetailId?: InputMaybe<Scalars['UInt']['input']>;
  scheduleId?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface ScheduleDetailModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ScheduleDetail;
}

export interface ScheduleInput {
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  closedExceptions?: InputMaybe<Array<ClosedExceptionInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  fields: Array<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers?: InputMaybe<Array<PhoneNumberInput>>;
  scheduleDetails?: InputMaybe<Array<ScheduleDetailInput>>;
  scheduleId?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface ScheduleModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Schedule;
}

export interface ScheduledJob {
  baseUrl: Maybe<Scalars['String']['output']>;
  createDate: Scalars['UtcDateTime']['output'];
  createUser: User;
  createUserId: Scalars['Int']['output'];
  endDate: Maybe<Scalars['UtcDateTime']['output']>;
  isRetryOnFailure: Scalars['Boolean']['output'];
  requestBody: Maybe<Scalars['String']['output']>;
  requestMethod: HttpRequestMethods;
  requestPath: Maybe<Scalars['String']['output']>;
  responseBody: Maybe<Scalars['String']['output']>;
  runDate: Maybe<Scalars['UtcDateTime']['output']>;
  scheduledDate: Scalars['UtcDateTime']['output'];
  scheduledJobId: Scalars['UInt']['output'];
  status: ScheduledJobStatuses;
  updateDate: Scalars['UtcDateTime']['output'];
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface ScheduledJobConnection {
  /** Information to aid in pagination. */
  edges: Array<ScheduledJobModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<ScheduledJob>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface ScheduledJobInput {
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fields: Array<Scalars['String']['input']>;
  isRetryOnFailure?: InputMaybe<Scalars['Boolean']['input']>;
  requestBody?: InputMaybe<Scalars['String']['input']>;
  requestMethod?: InputMaybe<HttpRequestMethods>;
  requestPath?: InputMaybe<Scalars['String']['input']>;
  responseBody?: InputMaybe<Scalars['String']['input']>;
  runDate?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledJobId?: InputMaybe<Scalars['UInt']['input']>;
  status?: InputMaybe<ScheduledJobStatuses>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface ScheduledJobModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ScheduledJob;
}

export enum ScheduledJobStatuses {
  /** Complete */
  Complete = 'Complete',
  /** Disabled */
  Disabled = 'Disabled',
  /** Failed */
  Failed = 'Failed',
  /** Queued */
  Queued = 'Queued',
  /** Running */
  Running = 'Running'
}

export interface SelectedAccountReportParameterGraphType {
  isAskParameter: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  parameterType: ReportParameters;
  sortOrder: Maybe<Scalars['Int']['output']>;
  value: Scalars['UInt']['output'];
}

export interface SelectedAccountReportParameterInput {
  fields: Array<Scalars['String']['input']>;
  isAskParameter?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parameterType?: InputMaybe<ReportParameters>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['UInt']['input']>;
}

export interface Server {
  iPAddress: Maybe<Scalars['String']['output']>;
  isAcceptingNewCalls: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
  lastStasisStart: Scalars['UtcDateTime']['output'];
  serverId: Scalars['UInt']['output'];
  serverName: Maybe<Scalars['String']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface ServerConnection {
  /** Information to aid in pagination. */
  edges: Array<ServerModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Server>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface ServerInput {
  fields: Array<Scalars['String']['input']>;
  iPAddress?: InputMaybe<Scalars['String']['input']>;
  isAcceptingNewCalls?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastStasisStart?: InputMaybe<Scalars['DateTime']['input']>;
  serverId?: InputMaybe<Scalars['UInt']['input']>;
  serverName?: InputMaybe<Scalars['String']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface ServerModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Server;
}

export interface ShowDateReportParameterGraphType {
  isAskParameter: Scalars['Boolean']['output'];
  parameterType: ReportParameters;
  sortOrder: Maybe<Scalars['Int']['output']>;
  value: Scalars['Boolean']['output'];
}

export interface ShowDateReportParameterInput {
  fields: Array<Scalars['String']['input']>;
  isAskParameter?: InputMaybe<Scalars['Boolean']['input']>;
  parameterType?: InputMaybe<ReportParameters>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface SipUser {
  account: Account;
  accountId: Scalars['UInt']['output'];
  dbAliasId: Maybe<Scalars['UInt']['output']>;
  externalIps: Maybe<Scalars['String']['output']>;
  hashPassword: Maybe<Scalars['String']['output']>;
  internalIps: Maybe<Scalars['String']['output']>;
  isConnected: Scalars['Boolean']['output'];
  isFraud: Scalars['Boolean']['output'];
  isHacked: Scalars['Boolean']['output'];
  lastConnected: Maybe<Scalars['UtcDateTime']['output']>;
  lastPasswordChange: Scalars['UtcDateTime']['output'];
  legacyDbAliasId: Maybe<Scalars['UInt']['output']>;
  legacySubscriberId: Maybe<Scalars['UInt']['output']>;
  phone: Phone;
  phoneId: Scalars['UInt']['output'];
  phoneNumber: Maybe<PhoneNumber>;
  phoneNumberId: Maybe<Scalars['UInt']['output']>;
  resetSipUserPassword: Maybe<Scalars['Boolean']['output']>;
  sipUserId: Scalars['UInt']['output'];
  subscriberId: Scalars['UInt']['output'];
  userAgents: Maybe<Scalars['String']['output']>;
  userName: Maybe<Scalars['String']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface SipUserConnection {
  /** Information to aid in pagination. */
  edges: Array<SipUserModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<SipUser>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface SipUserInput {
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  dbAliasId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  hashPassword?: InputMaybe<Scalars['String']['input']>;
  isFraud?: InputMaybe<Scalars['Boolean']['input']>;
  isHacked?: InputMaybe<Scalars['Boolean']['input']>;
  lastPasswordChange?: InputMaybe<Scalars['DateTime']['input']>;
  legacyDbAliasId?: InputMaybe<Scalars['UInt']['input']>;
  legacySubscriberId?: InputMaybe<Scalars['UInt']['input']>;
  phoneId?: InputMaybe<Scalars['UInt']['input']>;
  phoneNumberId?: InputMaybe<Scalars['UInt']['input']>;
  resetSipUserPassword?: InputMaybe<Scalars['Boolean']['input']>;
  sipUserId?: InputMaybe<Scalars['UInt']['input']>;
  subscriberId?: InputMaybe<Scalars['UInt']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface SipUserModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: SipUser;
}

export interface SipUserRegistration {
  externalIp: Maybe<Scalars['String']['output']>;
  firstRegisterTime: Scalars['UtcDateTime']['output'];
  internalIp: Maybe<Scalars['String']['output']>;
  lastRegisterTime: Scalars['UtcDateTime']['output'];
  registerExpirationTime: Maybe<Scalars['UtcDateTime']['output']>;
  shortName: Maybe<Scalars['String']['output']>;
  sipUserRegistrationId: Scalars['UInt']['output'];
  userAgent: Maybe<Scalars['String']['output']>;
  userName: Maybe<Scalars['String']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface SipUserRegistrationConnection {
  /** Information to aid in pagination. */
  edges: Array<SipUserRegistrationModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<SipUserRegistration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface SipUserRegistrationModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: SipUserRegistration;
}

export interface SystemLog {
  account: Maybe<Account>;
  accountId: Maybe<Scalars['UInt']['output']>;
  areaId: SystemLogAreas;
  areaName: Maybe<Scalars['String']['output']>;
  callDetail: Maybe<CallDetail>;
  callDetailId: Maybe<Scalars['UInt']['output']>;
  createUser: Maybe<User>;
  createUserDate: Maybe<Scalars['UtcDateTime']['output']>;
  createUserId: Maybe<Scalars['Int']['output']>;
  logCode: Maybe<LogCodes>;
  message: Maybe<Scalars['String']['output']>;
  severityId: SystemLogSeverities;
  severityName: Maybe<Scalars['String']['output']>;
  systemLogId: Scalars['UInt']['output'];
  typeId: SystemLogTypes;
  typeName: Maybe<Scalars['String']['output']>;
}

export enum SystemLogAreas {
  /** Broadcast */
  Broadcast = 'Broadcast',
  /** CallRecordings */
  CallRecordings = 'CallRecordings',
  /** Calls */
  Calls = 'Calls',
  /** DeviceManagement */
  DeviceManagement = 'DeviceManagement',
  /** Fax */
  Fax = 'Fax',
  /** LogLevelUpdate */
  LogLevelUpdate = 'LogLevelUpdate',
  /** Migration */
  Migration = 'Migration',
  /** Osips */
  Osips = 'Osips',
  /** Queues */
  Queues = 'Queues',
  /** Voicemails */
  Voicemails = 'Voicemails'
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface SystemLogConnection {
  /** Information to aid in pagination. */
  edges: Array<SystemLogModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<SystemLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface SystemLogInput {
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  areaId?: InputMaybe<SystemLogAreas>;
  callDetailId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  logCode?: InputMaybe<LogCodes>;
  message?: InputMaybe<Scalars['String']['input']>;
  severityId?: InputMaybe<SystemLogSeverities>;
  systemLogId?: InputMaybe<Scalars['UInt']['input']>;
  typeId?: InputMaybe<SystemLogTypes>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface SystemLogModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: SystemLog;
}

export enum SystemLogSeverities {
  /** High */
  High = 'High',
  /** Low */
  Low = 'Low',
  /** Medium */
  Medium = 'Medium'
}

export enum SystemLogTypes {
  /** Delete */
  Delete = 'Delete',
  /** Insert */
  Insert = 'Insert',
  /** Miscellaneous */
  Miscellaneous = 'Miscellaneous',
  /** Security */
  Security = 'Security',
  /** StasisException */
  StasisException = 'StasisException',
  /** Update */
  Update = 'Update'
}

export interface Tile {
  canEditRefreshTime: Scalars['Boolean']['output'];
  description: Maybe<Scalars['String']['output']>;
  designerDescription: Maybe<Scalars['String']['output']>;
  isCustom: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  reportParametersConnection: TileReportParametersConnection;
  tileId: Tiles;
  tileSetType: Maybe<TileSetType>;
  tileViewModeBound: Maybe<TileViewModeBound>;
  typeId: TileTypes;
}


export interface TileReportParametersConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface TileConnection {
  /** Information to aid in pagination. */
  edges: Array<TileModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Tile>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface TileInput {
  canEditRefreshTime?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designerDescription?: InputMaybe<Scalars['String']['input']>;
  fields: Array<Scalars['String']['input']>;
  isCustom?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reportParameters?: InputMaybe<Array<TileReportParametersInput>>;
  tileId?: InputMaybe<Tiles>;
  tileSetType?: InputMaybe<TileSetTypeInput>;
  typeId?: InputMaybe<TileTypes>;
}

export interface TileLayoutConfigurationParameterGraphType {
  color: Maybe<Scalars['String']['output']>;
  column: Maybe<Scalars['Int']['output']>;
  fields: Array<Maybe<Scalars['String']['output']>>;
  height: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  refreshTimeSeconds: Maybe<Scalars['Int']['output']>;
  row: Maybe<Scalars['Int']['output']>;
  timeZone: Maybe<TimeZoneReportParameterGraphType>;
  width: Maybe<Scalars['Int']['output']>;
}

export interface TileLayoutConfigurationParameterInput {
  color?: InputMaybe<Scalars['String']['input']>;
  column?: InputMaybe<Scalars['Int']['input']>;
  fields: Array<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  refreshTimeSeconds?: InputMaybe<Scalars['Int']['input']>;
  row?: InputMaybe<Scalars['Int']['input']>;
  timeZone?: InputMaybe<TimeZoneReportParameterInput>;
  width?: InputMaybe<Scalars['Int']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface TileModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Tile;
}

export interface TileReportParameters {
  reportParameter: ReportParameter;
  reportParameterId: Scalars['Int']['output'];
  tile: Tile;
  tileId: Scalars['Int']['output'];
  tileReportParameterId: Scalars['Int']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface TileReportParametersConnection {
  /** Information to aid in pagination. */
  edges: Array<TileReportParametersModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<TileReportParameters>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface TileReportParametersInput {
  fields: Array<Scalars['String']['input']>;
  reportParameter?: InputMaybe<ReportParameterInput>;
  reportParameterId?: InputMaybe<Scalars['Int']['input']>;
  tile?: InputMaybe<TileInput>;
  tileId?: InputMaybe<Scalars['Int']['input']>;
  tileReportParameterId?: InputMaybe<Scalars['Int']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface TileReportParametersModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TileReportParameters;
}

export interface TileSet {
  description: Maybe<Scalars['String']['output']>;
  designerDescription: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  tileSetId: TileSets;
  tileSetTypeConnection: TileSetTypeConnection;
}


export interface TileSetTileSetTypeConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface TileSetConnection {
  /** Information to aid in pagination. */
  edges: Array<TileSetModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<TileSet>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface TileSetInput {
  description?: InputMaybe<Scalars['String']['input']>;
  designerDescription?: InputMaybe<Scalars['String']['input']>;
  fields: Array<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tileSetId?: InputMaybe<TileSets>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface TileSetModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TileSet;
}

export interface TileSetType {
  tile: Tile;
  tileId: Tiles;
  tileSet: TileSet;
  tileSetId: TileSets;
  tileSetTypeId: Scalars['Int']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface TileSetTypeConnection {
  /** Information to aid in pagination. */
  edges: Array<TileSetTypeModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<TileSetType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface TileSetTypeInput {
  fields: Array<Scalars['String']['input']>;
  tileId?: InputMaybe<Tiles>;
  tileSetId?: InputMaybe<TileSets>;
  tileSetTypeId?: InputMaybe<Scalars['Int']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface TileSetTypeModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TileSetType;
}

export enum TileSets {
  /** Parked Calls */
  CallParking = 'CallParking',
  /** Clock */
  Clock = 'Clock',
  /** NDT Wait Times */
  NdtWaitTimes = 'NdtWaitTimes',
  /** Phone Queues */
  PhoneQueues = 'PhoneQueues',
  /** Queue Members */
  QueueMembers = 'QueueMembers'
}

export enum TileTypes {
  /** Bar Graph */
  BarGraph = 'BarGraph',
  /** Clock */
  Clock = 'Clock',
  /** Line Graph */
  LineGraph = 'LineGraph',
  /** Pie Graph */
  PieGraph = 'PieGraph',
  /** Pie Grid Graph */
  PieGridGraph = 'PieGridGraph',
  /** Summary */
  Summary = 'Summary',
  /** Table */
  Table = 'Table'
}

export interface TileViewModeBound {
  heightLowerBound: Maybe<Scalars['Int']['output']>;
  heightUpperBound: Maybe<Scalars['Int']['output']>;
  tile: Tile;
  tileId: Scalars['Int']['output'];
  tileViewModeBoundId: Scalars['Int']['output'];
  widthLowerBound: Maybe<Scalars['Int']['output']>;
  widthUpperBound: Maybe<Scalars['Int']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface TileViewModeBoundConnection {
  /** Information to aid in pagination. */
  edges: Array<TileViewModeBoundModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<TileViewModeBound>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface TileViewModeBoundInput {
  fields: Array<Scalars['String']['input']>;
  heightLowerBound?: InputMaybe<Scalars['Int']['input']>;
  heightUpperBound?: InputMaybe<Scalars['Int']['input']>;
  tileId?: InputMaybe<Scalars['Int']['input']>;
  tileViewModeBoundId?: InputMaybe<Scalars['Int']['input']>;
  widthLowerBound?: InputMaybe<Scalars['Int']['input']>;
  widthUpperBound?: InputMaybe<Scalars['Int']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface TileViewModeBoundModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TileViewModeBound;
}

export enum TileViewModes {
  /** Large */
  Large = 'Large',
  /** Medium */
  Medium = 'Medium',
  /** Small */
  Small = 'Small'
}

export enum Tiles {
  /** Parked Calls */
  CallParking = 'CallParking',
  /** Clock */
  Clock = 'Clock',
  /** NDT Wait Times (Graph) */
  NDTWaitTimesGraph = 'NDTWaitTimesGraph',
  /** Phone Queues */
  PhoneQueues = 'PhoneQueues',
  /** Queue Members */
  QueueMembers = 'QueueMembers'
}

export interface TimeBasedRoute {
  comment: Maybe<Scalars['String']['output']>;
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  endDate: Maybe<Scalars['UtcDateTime']['output']>;
  endTime: Maybe<Scalars['UtcDateTime']['output']>;
  extension: Extension;
  extensionId: Scalars['UInt']['output'];
  isActiveFriday: Scalars['Boolean']['output'];
  isActiveMonday: Scalars['Boolean']['output'];
  isActiveSaturday: Scalars['Boolean']['output'];
  isActiveSunday: Scalars['Boolean']['output'];
  isActiveThursday: Scalars['Boolean']['output'];
  isActiveTuesday: Scalars['Boolean']['output'];
  isActiveWednesday: Scalars['Boolean']['output'];
  nDT1TimeBasedRouteId: Scalars['Int']['output'];
  priorityId: Scalars['UInt']['output'];
  routeExtension: Maybe<Extension>;
  routeExtensionId: Maybe<Scalars['UInt']['output']>;
  routeExtensionNullAction: NullActionTypes;
  startDate: Maybe<Scalars['UtcDateTime']['output']>;
  startTime: Maybe<Scalars['UtcDateTime']['output']>;
  timeBasedRouteId: Scalars['UInt']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface TimeBasedRouteConnection {
  /** Information to aid in pagination. */
  edges: Array<TimeBasedRouteModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<TimeBasedRoute>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface TimeBasedRouteInput {
  comment?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  isActiveFriday?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveMonday?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveSaturday?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveSunday?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveThursday?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveTuesday?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveWednesday?: InputMaybe<Scalars['Boolean']['input']>;
  nDT1TimeBasedRouteId?: InputMaybe<Scalars['Int']['input']>;
  priorityId?: InputMaybe<Scalars['UInt']['input']>;
  routeExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  routeExtensionNullAction?: InputMaybe<NullActionTypes>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  timeBasedRouteId?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface TimeBasedRouteModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TimeBasedRoute;
}

export interface TimeRangeReportParameterGraphType {
  endDate: Maybe<Scalars['UtcDateTime']['output']>;
  isAskParameter: Scalars['Boolean']['output'];
  parameterType: ReportParameters;
  relativeDate: Maybe<RelativeDateOptions>;
  sortOrder: Maybe<Scalars['Int']['output']>;
  startDate: Maybe<Scalars['UtcDateTime']['output']>;
}

export interface TimeRangeReportParameterInput {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fields: Array<Scalars['String']['input']>;
  isAskParameter?: InputMaybe<Scalars['Boolean']['input']>;
  parameterType?: InputMaybe<ReportParameters>;
  relativeDate?: InputMaybe<RelativeDateOptions>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
}

export interface TimeZoneReportParameterGraphType {
  isAskParameter: Scalars['Boolean']['output'];
  parameterType: ReportParameters;
  sortOrder: Maybe<Scalars['Int']['output']>;
  value: Maybe<Scalars['String']['output']>;
}

export interface TimeZoneReportParameterInput {
  fields: Array<Scalars['String']['input']>;
  isAskParameter?: InputMaybe<Scalars['Boolean']['input']>;
  parameterType?: InputMaybe<ReportParameters>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
}

export enum TimeZones {
  /** Alaska */
  Alaska = 'Alaska',
  /** Arizona */
  Arizona = 'Arizona',
  /** Atlantic */
  Atlantic = 'Atlantic',
  /** Central */
  Central = 'Central',
  /** Eastern */
  Eastern = 'Eastern',
  /** Hawaii */
  Hawaii = 'Hawaii',
  /** Mountain */
  Mountain = 'Mountain',
  /** Pacific */
  Pacific = 'Pacific',
  /** Saskatchewan */
  Saskatchewan = 'Saskatchewan'
}

export interface User {
  accessTokensConnection: AccessTokenConnection;
  account: Maybe<Account>;
  accountId: Maybe<Scalars['UInt']['output']>;
  accountName: Maybe<Scalars['String']['output']>;
  accountShortName: Maybe<Scalars['String']['output']>;
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  dashboard: Maybe<Dashboard>;
  directorySource: UserDirectorySource;
  directorySourceId: Scalars['UInt']['output'];
  emailAddress: Maybe<Scalars['String']['output']>;
  extension: Maybe<Extension>;
  extensionId: Maybe<Scalars['UInt']['output']>;
  externalId: Maybe<Scalars['String']['output']>;
  failedLoginAttempts: Scalars['UInt']['output'];
  hasAllExtensionRecordings: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
  isAdmin: Scalars['Boolean']['output'];
  isForcePasswordChange: Scalars['Boolean']['output'];
  isLocked: Scalars['Boolean']['output'];
  isPasswordMigrated: Scalars['Boolean']['output'];
  isSystemUser: Scalars['Boolean']['output'];
  lastLoggedIn: Maybe<Scalars['UtcDateTime']['output']>;
  lastPasswordChangeDate: Maybe<Scalars['UtcDateTime']['output']>;
  lockoutDate: Maybe<Scalars['UtcDateTime']['output']>;
  name: Maybe<Scalars['String']['output']>;
  privilegesConnection: UserPrivilegeConnection;
  rolesConnection: UserRoleConnection;
  timeZoneId: TimeZones;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
  userCallRecordingExtensionGroupsConnection: UserCallRecordingExtensionGroupConnection;
  userCallRecordingExtensionsConnection: UserCallRecordingExtensionConnection;
  userId: Scalars['Int']['output'];
  userReportsConnection: UserReportConnection;
  username: Maybe<Scalars['String']['output']>;
}


export interface UserAccessTokensConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface UserPrivilegesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface UserRolesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface UserUserCallRecordingExtensionGroupsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface UserUserCallRecordingExtensionsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}


export interface UserUserReportsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

export interface UserCallRecordingExtension {
  createDate: Scalars['UtcDateTime']['output'];
  createUserId: Maybe<Scalars['Int']['output']>;
  extension: Extension;
  extensionId: Scalars['UInt']['output'];
  isInclude: Scalars['Boolean']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUserId: Maybe<Scalars['Int']['output']>;
  user: User;
  userCallRecordingExtensionId: Scalars['UInt']['output'];
  userId: Scalars['Int']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface UserCallRecordingExtensionConnection {
  /** Information to aid in pagination. */
  edges: Array<UserCallRecordingExtensionModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<UserCallRecordingExtension>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface UserCallRecordingExtensionGroup {
  extensionGroup: ExtensionGroup;
  extensionGroupExtensionsConnection: ExtensionGroupExtensionConnection;
  extensionGroupId: Scalars['UInt']['output'];
  isInclude: Scalars['Boolean']['output'];
  user: User;
  userCallRecordingExtensionGroupId: Scalars['UInt']['output'];
  userId: Scalars['Int']['output'];
}


export interface UserCallRecordingExtensionGroupExtensionGroupExtensionsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface UserCallRecordingExtensionGroupConnection {
  /** Information to aid in pagination. */
  edges: Array<UserCallRecordingExtensionGroupModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<UserCallRecordingExtensionGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface UserCallRecordingExtensionGroupInput {
  extensionGroupExtensions?: InputMaybe<Array<ExtensionGroupExtensionInput>>;
  extensionGroupId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  isInclude?: InputMaybe<Scalars['Boolean']['input']>;
  userCallRecordingExtensionGroupId?: InputMaybe<Scalars['UInt']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface UserCallRecordingExtensionGroupModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserCallRecordingExtensionGroup;
}

export interface UserCallRecordingExtensionInput {
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  isInclude?: InputMaybe<Scalars['Boolean']['input']>;
  userCallRecordingExtensionId?: InputMaybe<Scalars['UInt']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface UserCallRecordingExtensionModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserCallRecordingExtension;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface UserConnection {
  /** Information to aid in pagination. */
  edges: Array<UserModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface UserDirectorySource {
  name: Maybe<Scalars['String']['output']>;
  type: UserDirectorySourceTypes;
  userDirectorySourceId: Scalars['UInt']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface UserDirectorySourceConnection {
  /** Information to aid in pagination. */
  edges: Array<UserDirectorySourceModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<UserDirectorySource>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface UserDirectorySourceModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserDirectorySource;
}

export enum UserDirectorySourceTypes {
  /** Azure Active Directory */
  AzureActiveDirectory = 'AzureActiveDirectory',
  /** Local */
  Local = 'Local',
  /** Microsoft Active Directory */
  MicrosoftActiveDirectory = 'MicrosoftActiveDirectory'
}

export interface UserInput {
  accessTokens?: InputMaybe<Array<AccessTokenInput>>;
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  accountName?: InputMaybe<Scalars['String']['input']>;
  directorySourceId?: InputMaybe<Scalars['UInt']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedLoginAttempts?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  hasAllExtensionRecordings?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isForcePasswordChange?: InputMaybe<Scalars['Boolean']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  isPasswordMigrated?: InputMaybe<Scalars['Boolean']['input']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']['input']>;
  lastLoggedIn?: InputMaybe<Scalars['DateTime']['input']>;
  lastPasswordChangeDate?: InputMaybe<Scalars['DateTime']['input']>;
  lockoutDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  privileges?: InputMaybe<Array<UserPrivilegeInput>>;
  roles?: InputMaybe<Array<UserRoleInput>>;
  timeZoneId?: InputMaybe<TimeZones>;
  userCallRecordingExtensionGroups?: InputMaybe<Array<UserCallRecordingExtensionGroupInput>>;
  userCallRecordingExtensions?: InputMaybe<Array<UserCallRecordingExtensionInput>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  userReports?: InputMaybe<Array<UserReportInput>>;
  username?: InputMaybe<Scalars['String']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface UserModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: User;
}

export interface UserPostInput {
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  extensionId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  hasAllExtensionRecordings?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  isPasswordMigrated?: InputMaybe<Scalars['Boolean']['input']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<UserRoleInput>>;
  userCallRecordingExtensionGroups?: InputMaybe<Array<UserCallRecordingExtensionGroupInput>>;
  userCallRecordingExtensions?: InputMaybe<Array<UserCallRecordingExtensionInput>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  userReports?: InputMaybe<Array<UserReportInput>>;
  username?: InputMaybe<Scalars['String']['input']>;
}

export interface UserPreference {
  createDate: Scalars['UtcDateTime']['output'];
  createUserId: Maybe<Scalars['Int']['output']>;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUserId: Maybe<Scalars['Int']['output']>;
  user: User;
  userId: Scalars['Int']['output'];
  userPreference: UserPreferences;
  userPreferenceId: Scalars['UInt']['output'];
  value: Maybe<Scalars['String']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface UserPreferenceConnection {
  /** Information to aid in pagination. */
  edges: Array<UserPreferenceModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<UserPreference>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface UserPreferenceDefinition {
  defaultValue: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
  userPreferenceDefinitionId: Scalars['UInt']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface UserPreferenceDefinitionConnection {
  /** Information to aid in pagination. */
  edges: Array<UserPreferenceDefinitionModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<UserPreferenceDefinition>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface UserPreferenceDefinitionModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserPreferenceDefinition;
}

export interface UserPreferenceInput {
  fields: Array<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  userPreference?: InputMaybe<UserPreferences>;
  userPreferenceId?: InputMaybe<Scalars['UInt']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface UserPreferenceModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserPreference;
}

export enum UserPreferences {
  /** Expand Sidebar Menu */
  ExpandMenu = 'ExpandMenu',
  /** Most Recent Device */
  MostRecentDeviceType = 'MostRecentDeviceType',
  /** Wrap Queues on Queue History Register */
  QueueHistoryRegisterWrapQueues = 'QueueHistoryRegisterWrapQueues',
  /** Selected Dashboard */
  SelectedDashboardId = 'SelectedDashboardId',
  /** Show Extension Register Hover Tooltips */
  ShowExtensionRegisterPopup = 'ShowExtensionRegisterPopup',
  /** Use Alternating Colors for Register Rows */
  UseAlternatingRowColors = 'UseAlternatingRowColors'
}

export interface UserPrivilege {
  accountId: Maybe<Scalars['UInt']['output']>;
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  isAdd: Scalars['Boolean']['output'];
  isDelete: Scalars['Boolean']['output'];
  isEdit: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isView: Scalars['Boolean']['output'];
  privilege: Privilege;
  privilegeId: Scalars['Int']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
  user: User;
  userId: Scalars['Int']['output'];
  userPrivilegeId: Scalars['UInt']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface UserPrivilegeConnection {
  /** Information to aid in pagination. */
  edges: Array<UserPrivilegeModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<UserPrivilege>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface UserPrivilegeInput {
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  fields: Array<Scalars['String']['input']>;
  isAdd?: InputMaybe<Scalars['Boolean']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  isEdit?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isView?: InputMaybe<Scalars['Boolean']['input']>;
  privilegeId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  userPrivilegeId?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface UserPrivilegeModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserPrivilege;
}

export interface UserReport {
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  report: Report;
  reportId: Scalars['Int']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
  user: User;
  userId: Scalars['Int']['output'];
  userReportId: Scalars['UInt']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface UserReportConnection {
  /** Information to aid in pagination. */
  edges: Array<UserReportModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<UserReport>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface UserReportInput {
  fields: Array<Scalars['String']['input']>;
  reportId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  userReportId?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface UserReportModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserReport;
}

export interface UserRole {
  createDate: Scalars['UtcDateTime']['output'];
  createUser: Maybe<User>;
  createUserId: Maybe<Scalars['Int']['output']>;
  role: Role;
  roleId: Scalars['UInt']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  updateUser: Maybe<User>;
  updateUserId: Maybe<Scalars['Int']['output']>;
  user: User;
  userId: Scalars['Int']['output'];
  userRoleId: Scalars['UInt']['output'];
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface UserRoleConnection {
  /** Information to aid in pagination. */
  edges: Array<UserRoleModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<UserRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface UserRoleInput {
  fields: Array<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['UInt']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  userRoleId?: InputMaybe<Scalars['UInt']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface UserRoleModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserRole;
}

export enum Versions {
  /** NDT 1 */
  NDT1 = 'NDT1',
  /** NDT 2 */
  NDT2 = 'NDT2'
}

export interface WaitTimesGraphTileDataGraphType {
  aggregateQueues: Scalars['Boolean']['output'];
  averageWaitTimeLast30Minutes: Scalars['Decimal']['output'];
  averageWaitTimeToday: Scalars['Decimal']['output'];
  queueDataPointSummary: Array<QueueDataPointSummaryGraphType>;
}

export interface WaitTimesGraphTileGraphType {
  dashboardTileId: Maybe<Scalars['Int']['output']>;
  data: Maybe<WaitTimesGraphTileDataGraphType>;
  isLcs: Scalars['Boolean']['output'];
  parameters: Maybe<WaitTimesTileReportParametersGraphType>;
  runDate: Scalars['UtcDateTime']['output'];
}

export interface WaitTimesTileReportParametersGraphType {
  accountId: Scalars['UInt']['output'];
  aggregateQueues: Maybe<AggregateQueuesReportParameterGraphType>;
  aggregateRest: Scalars['Boolean']['output'];
  callQueues: Maybe<CallQueueExtensionsToIncludeReportParameterGraphType>;
  limit: Scalars['Int']['output'];
  selectedAccount: Maybe<SelectedAccountReportParameterGraphType>;
  tileLayoutConfiguration: Maybe<TileLayoutConfigurationParameterGraphType>;
  timeRange: Maybe<TimeRangeReportParameterGraphType>;
  timeZone: Maybe<TimeZoneReportParameterGraphType>;
}

export interface WaitTimesTileReportParametersInput {
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  aggregateQueues?: InputMaybe<AggregateQueuesReportParameterInput>;
  aggregateRest?: InputMaybe<Scalars['Boolean']['input']>;
  callQueues?: InputMaybe<CallQueueExtensionsToIncludeReportParameterInput>;
  fields: Array<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  selectedAccount?: InputMaybe<SelectedAccountReportParameterInput>;
  tileLayoutConfiguration?: InputMaybe<TileLayoutConfigurationParameterInput>;
  timeRange?: InputMaybe<TimeRangeReportParameterInput>;
  timeZone?: InputMaybe<TimeZoneReportParameterInput>;
}

export interface WebhookRegistration {
  account: Maybe<Account>;
  accountId: Maybe<Scalars['UInt']['output']>;
  applicationName: Maybe<Scalars['String']['output']>;
  applicationVersion: Maybe<Scalars['String']['output']>;
  createDate: Scalars['UtcDateTime']['output'];
  updateDate: Maybe<Scalars['UtcDateTime']['output']>;
  webhookRegistrationId: Scalars['UInt']['output'];
  webhookTypeId: WebhookType;
  webhookUrl: Maybe<Scalars['String']['output']>;
}

/** A connection from an object to a list of objects of type `AutoRegisteringEntity`. */
export interface WebhookRegistrationConnection {
  /** Information to aid in pagination. */
  edges: Array<WebhookRegistrationModelEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<WebhookRegistration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
}

export interface WebhookRegistrationInput {
  accountId?: InputMaybe<Scalars['UInt']['input']>;
  applicationName?: InputMaybe<Scalars['String']['input']>;
  applicationVersion?: InputMaybe<Scalars['String']['input']>;
  fields: Array<Scalars['String']['input']>;
  webhookRegistrationId?: InputMaybe<Scalars['UInt']['input']>;
  webhookTypeId?: InputMaybe<WebhookType>;
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
}

/** An edge in a connection from an object to another object of type `AutoRegisteringEntity`. */
export interface WebhookRegistrationModelEdge {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: WebhookRegistration;
}

export interface WebhookRegistrationRequestInput {
  applicationName?: InputMaybe<Scalars['String']['input']>;
  applicationVersion?: InputMaybe<Scalars['String']['input']>;
  fields: Array<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  webhookTypeId?: InputMaybe<WebhookType>;
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
}

export enum WebhookType {
  /** Account Queue Strategy Changed */
  AccountQueueStrategyChanged = 'AccountQueueStrategyChanged',
  /** Agent Login Status Changed */
  AgentLoginStatusChanged = 'AgentLoginStatusChanged',
  /** Call Notification */
  CallNotification = 'CallNotification',
  /** DND Status Changed */
  DNDStatusChanged = 'DNDStatusChanged',
  /** Queue Members Changed */
  QueueMembersChanged = 'QueueMembersChanged'
}
